import ReactDOM from 'react-dom';
import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Slider, InputNumber, Row, Col } from 'antd';
import 'antd/dist/antd.css'; // or 'antd/dist/antd.less'
import { Button } from 'antd';

import * as d3 from "d3"
import {calDistance, drawRect, normalizeVec, drawPolygon, drawLine,PointToSegDist,getVecNorm} from "./util"
import BSpline from "./BSpline";

var MarchingSquaresJS = require('marchingsquares');
var IsoInsideTest = require('point-in-polygon');
var AreaCal = require('2d-polygon-area');
//barrier map:
//1: inside the gap of a node
//2: inside the gap of an edge
//3. inside a node
//4. inside an edge
//5. inside the initial field of a node
//6. inside the initial field of an edge

// Note: X and Y attribute are all center point for both circle and rectangle!

var pointDataName="BubbleSetExample1.txt"
var edgeDataName="BubbleSetEdge1.txt"
const {ShapeInfo, Intersection,Point2D,IntersectionQuery} = require("kld-intersections");
var colors=['#e1642c','#d35d6d','#cecf7b','#4aa15f','#0885c2','#e2a2be','#ed334e','#6950a1','#1d953f','#ea66a6','#bed742','#2b4490']   //fig2
//var colors=['#fbf4a4','#c4da90','#a7bfd9','#f3c4d3','#f5c3a0','#a5c3af','#b9b9b4','#d2c1d5','#e7f1f5','#f9dce2','#e7f1f5','#cdcadb'] //fig3
//var colors=['#d35d6d','#0885c2','#4aa15f','#6950a1','#0885c2','#e2a2be','#ed334e','#6950a1','#1d953f','#ea66a6','#bed742','#2b4490']   //drawFig
//var colors=['#f16b22','#7e519f','#713e3a'] //fig1
var buffer=10
// var nodeR0=10
// var nodeR1=20
// var edgeR0=15
// var edgeR1=20
var nodeR1=15
var nodeR0=nodeR1-5

var edgeR1=20
var edgeR0=edgeR1-5


var defaultEdgeWidth=5
var edgeWidth=5 //5-10
var itemEnergyShape="circle"
var nodeWeight=1
var edgeWeight=1
var nodeNegWeight=-0.8
var edgeNegWeight=0
var barrierGap=3
var intervals = [0.001]
var pixelGroup = 2
var gapBetween=1
var fixdis = Math.sqrt(0.25 * (pixelGroup - 1) * (pixelGroup - 1) + 0.25 * (pixelGroup - 1) * (pixelGroup - 1))
var control_points={}
var initialControlPoints={}
var is_selected={}
var eps = 1e-10
var move_points = []
var mid_point = 0
var nearpts = []
var svg;
var g;
var hasChangeView = false;
var offsetX,offsetY,viewWidth,viewHeight;
var prepoints = []

var svgwidth = 2000
var svgheight = 2000
var skipPoint = 10
var minItemArea = Number.MAX_VALUE

var editSeg = {}
var recalNum = 0
var recal = false
var remove_Polys = {}

var lineFunction = d3.line()
    .x(function(d) { return d[0]; })
    .y(function(d) { return d[1]; })
    .curve(d3.curveBasisClosed);

var lineFunction_reDraw = d3.line()
    .x(function(d) { return d[0]; })
    .y(function(d) { return d[1]; })
    .curve(d3.curveCardinal);

function clone(obj) {
    // Handle the 3 simple types, and null or undefined or function
    if (null == obj || "object" != typeof obj) return obj;

    // Handle Date
    if (obj instanceof Date) {
        var copy = new Date();
        copy.setTime(obj.getTime());
        return copy;
    }
    // Handle Array or Object
    if (obj instanceof Array | obj instanceof Object) {
        var copy = (obj instanceof Array)?[]:{};
        for (var attr in obj) {
            if (obj.hasOwnProperty(attr))
                copy[attr] = clone(obj[attr]);
        }
        return copy;
    }
    throw new Error("Unable to clone obj! Its type isn't supported.");
}

//d3.select("svg")
class AdaptiveIsovalue extends  Component{
    static propTypes = {
        pointData: PropTypes.array,
        edges: PropTypes.array
    }

    static defaultProps = {
        pointData:[],
        edges:[]
    }

    constructor() {
        super();
        this.state = {
            nodeR0: 10,
            nodeR1: 20,
            edgeR0: 15,
            edgeR1: 20,
            pixelGroup: 3,
            gapBetween:1,
            edgeWidth: defaultEdgeWidth,
            hasSelectEdge:false
        }
        this.isfirstcreate=true
        this.pointData=[]
        this.canvasWidth=-1
        this.canvasHeight=-1
        this.maxX=-1
        this.maxY=-1
        this.minX=-1
        this.minY=-1
        this.maxDis=Number.MIN_VALUE
        this.catPointDict={}
        this.catEdgeDict={}
        this.edges=[]
        this.maxDistance=-1
        this.itemShape=""
        this.itemBBox=[]
        this.catEnergyField={}
        this.catNotGroup={}
        this.activeRegion={
            x:0,
            y:0,
            width:0,
            height:0
        }
        this.energyField={
            width:0,
            height:0,
            field:[]
        }
        this.editMode=false
        this.editIndex=-1
        this.updatedEnergyPoints={}
        this.selectedEdge=-1
        this.edgeControlPoints=[]
        this.hasMST=false
        this.updateIdx = []
        this.hasBubbles = false
        this.firstFlag = true
    }

    init(){
        this.pointData=[]
        this.canvasWidth=-1
        this.canvasHeight=-1
        this.maxX=-1
        this.maxY=-1
        this.minX=-1
        this.minY=-1
        this.maxDis=Number.MIN_VALUE
        this.catPointDict={}
        this.catEdgeDict={}
        this.edges=[]
        this.maxDistance=-1
        this.itemShape=""
        this.itemBBox=[]
        this.catEnergyField={}
        this.catNotGroup={}
        this.activeRegion={
            x:0,
            y:0,
            width:0,
            height:0
        }
        this.energyField={
            width:0,
            height:0,
            field:[]
        }
        this.editMode=false
        this.editIndex=-1
        this.updatedEnergyPoints={}
        this.selectedEdge=-1
        this.updateIdx = []
        this.firstFlag = true
    }

    init_all(){

        colors=['#e1642c','#d35d6d','#cecf7b','#4aa15f','#0885c2','#e2a2be','#ed334e','#6950a1','#1d953f','#ea66a6','#bed742','#2b4490']
        buffer=10
        nodeR1=15
        nodeR0=nodeR1-5
        edgeR1=20
        edgeR0=edgeR1-5
        defaultEdgeWidth=5
        edgeWidth=5
        itemEnergyShape="circle"
        nodeWeight=1
        edgeWeight=1
        nodeNegWeight=-0.8
        edgeNegWeight=0
        barrierGap=3
        intervals = [0.001]
        pixelGroup = 2
        gapBetween=1
        fixdis = Math.sqrt(0.25 * (pixelGroup - 1) * (pixelGroup - 1) + 0.25 * (pixelGroup - 1) * (pixelGroup - 1))
        control_points={}
        initialControlPoints={}
        is_selected={}
        eps = 1e-10
        move_points = []
        mid_point = 0
        nearpts = []
        hasChangeView = false;
        prepoints = []
        svgwidth = 2000
        svgheight = 2000
        skipPoint = 10
        minItemArea = Number.MAX_VALUE
        editSeg = {}
        recalNum = 0
        recal = false
        remove_Polys = {}

        this.setState({
            nodeR0: 10,
            nodeR1: 20,
            edgeR0: 15,
            edgeR1: 20,
            pixelGroup: 3,
            gapBetween:1,
            edgeWidth: defaultEdgeWidth,
            hasSelectEdge:false
        })
        this.isfirstcreate=true
        this.pointData=[]
        this.canvasWidth=-1
        this.canvasHeight=-1
        this.maxX=-1
        this.maxY=-1
        this.minX=-1
        this.minY=-1
        this.maxDis=Number.MIN_VALUE
        this.catPointDict={}
        this.catEdgeDict={}
        this.edges=[]
        this.maxDistance=-1
        this.itemShape=""
        this.itemBBox=[]
        this.catEnergyField={}
        this.catNotGroup={}
        this.activeRegion={
            x:0,
            y:0,
            width:0,
            height:0
        }
        this.energyField={
            width:0,
            height:0,
            field:[]
        }
        this.editMode=false
        this.editIndex=-1
        this.updatedEnergyPoints={}
        this.selectedEdge=-1
        this.edgeControlPoints=[]
        this.hasMST=false
        this.updateIdx = []
        this.hasBubbles = false
        this.firstFlag = true

        this.render()
        this.componentDidMount()

    }

    bubbleState(){
        return this.hasBubbles
    }

    setViewBox(X, Y, Width, Height){
        X = offsetX
        Y = offsetY
        Width = viewWidth
        Height = viewHeight
    }

    componentDidMount() {
        this.props.onRef(this)
        this.canvasWidth=document.getElementById("mainsvg").getBoundingClientRect().width
        this.canvasHeight=document.getElementById("mainsvg").getBoundingClientRect().height
        //unable local right click menu
        document.oncontextmenu=function(){
            return false;
        }

        //let svg = d3.select("svg");


        //this.getData()
    }

    preProcessPoints(points, pdict){
        for(let i = 0;i < points.length; i ++){
            let tmp
            if(points[i].flag == true){
                tmp = this.pointData[points[i].id]
                tmp.flag = true
            }
            else{
                tmp = points[i]
            }
            for (let c = 0;c < tmp.catArray.length; c ++){
                let nowcat = tmp.catArray[c]
                if(!pdict.hasOwnProperty(nowcat)){
                    pdict[nowcat] = []
                }
                pdict[nowcat].push(tmp)
            }
        }
    }

    preProcessEdges(edges, edict, filledges){
        //console.log("preProcessEdges")
        //console.log(edges)
        //console.log(this.edges)
        for(let i = 0;i < edges.length; i ++){
            let tmp
            let catarr
            if(edges[i].flag == true){
                tmp = this.edges[edges[i].id]
                tmp.flag = true
                catarr = this.pointData[tmp.start].catArray
                filledges.push(tmp)
            }
            else{
                tmp = edges[i]
                catarr = tmp.startpoint.catArray
            }
            for (let c = 0;c < catarr.length; c ++){
                let nowcat = catarr[c]
                if(!edict.hasOwnProperty(nowcat)){
                    edict[nowcat] = []
                }
                edict[nowcat].push(tmp)
            }
        }
    }

    editReDraw(editPoints, editEdges, HpointData, Hedges){

        let tmpedges = clone(this.edges)

        this.pointData = HpointData
        this.edges = Hedges
        this.catPointDict = {}
        this.catEdgeDict = {}
        this.updateIdx = []
        this.itemShape = this.pointData[0].shape

        for (let i = 0; i < this.pointData.length; i++) {
            this.pointData[i].x = parseFloat(this.pointData[i].x)
            this.pointData[i].y = parseFloat(this.pointData[i].y)
            this.pointData[i].id = i
            this.pointData[i].cat = this.pointData[i].cat.toString()
            let cats = this.pointData[i].cat.split(",")
            let catarray = []
            if (cats.length > 1) {
                this.pointData[i].multicat = true
                for (let c = 0; c < cats.length; c++) {
                    catarray.push(cats[c])
                }
            } else {
                this.pointData[i].multicat = false
                catarray.push(this.pointData[i].cat)
            }
            this.pointData[i].catArray = catarray
        }

        this.centralizeData(false)

        this.calEdgeLength()

        this.calActiveRegion(false)

        let updatePoints = {}
        let updateEdges = {}
        let filledges = []

        this.preProcessPoints(editPoints, updatePoints)
        this.preProcessEdges(editEdges, updateEdges, filledges)

        this.calEnergyField_Part(updatePoints, updateEdges)

        this.calFinalEnergeField_Part()

        this.fillCrossingEdge_Part(filledges)

        d3.selectAll("path").remove()
        //d3.selectAll("rect").remove()
        //for(let k in this.catEnergyField){
        //    this.drawEnergyField(k)
        //}

        recal = false
        recalNum = 0
        this.firstFlag = true
        this.findOutLine()
        this.calOutLine()

        this.calEdgeControlPoints()

        let that=this
        function handleSvgClick(){
            d3.select("svg").selectAll("line")
                .filter(function(){
                    return parseInt(d3.select(this).attr("index"))==that.selectedEdge
                })
                .attr("stroke","red")
                .attr("opacity",0)
            that.selectedEdge=-1
            that.setState({
                hasSelectEdge:false,
                edgeWidth:defaultEdgeWidth
            })
        }
        d3.select("svg")
            .on("click",handleSvgClick)



    }

    getData(){
        //let that=this
        //fetch('/data/'+pointDataName,{
        //    method:'GET',
        //    headers:{
        //        'Content-Type':'application/json;charset=UTF-8'
        //    },
        //    mode:'cors',
        //    cache:'default'
        //})
            //.then(res=>res.json())
            //.then(data=>{
        if(this.props.pointData && this.props.edges) {
            if(this.props.edges.length > 0){
                this.hasMST = true;
            }
            this.init();
            if(this.hasMST == false){
                let tmp = this.props.createMST()
                this.pointData = tmp[0]
                this.edges = tmp[1]
                colors = tmp[2]
                this.hasMST = true;
            }
            else{
                this.pointData = this.props.pointData
                this.edges = this.props.edges
            }
            //console.log("Draw Bubbles")
            //console.log(this.pointData)
            //console.log(this.edges)
            this.itemShape = this.pointData[0].shape
            for (let i = 0; i < this.pointData.length; i++) {
                this.pointData[i].x = parseFloat(this.pointData[i].x)
                this.pointData[i].y = parseFloat(this.pointData[i].y)
                this.pointData[i].id = i
                this.pointData[i].cat = this.pointData[i].cat.toString()

                if(this.pointData[i].hasOwnProperty("radius")){
                    minItemArea = Math.min(minItemArea, this.pointData[i].radius * this.pointData[i].radius * Math.PI)
                }
                else{
                    minItemArea = Math.min(minItemArea, this.pointData[i].width * this.pointData[i].width)
                }

                let cats = this.pointData[i].cat.split(",")
                let catarray = []
                if (cats.length > 1) {
                    this.pointData[i].multicat = true
                    for (let c = 0; c < cats.length; c++) {
                        catarray.push(cats[c])
                    }
                } else {
                    this.pointData[i].multicat = false
                    catarray.push(this.pointData[i].cat)
                }
                this.pointData[i].catArray = catarray
            }

            this.loadEdgeData()
            if(this.props.handleCreated){
                this.props.handleCreated()
            }
        }
            //})

    }



    centralizeData(ViewFlag){
        this.minX=Number.MAX_VALUE
        this.minY=Number.MAX_VALUE
        this.maxX=Number.MIN_VALUE
        this.maxY=Number.MIN_VALUE
        for (let i=0;i<this.pointData.length;i++){
            //this.pointData[i].isGroup=true;
            if(itemEnergyShape=="circle"){
                if(this.itemShape=="rectangle"){
                    let r=Math.sqrt(Math.pow(this.pointData[i].width,2)+Math.pow(this.pointData[i].height,2))/2
                    this.pointData[i].radius=r
                }
                this.pointData[i].maxX=this.pointData[i].x+this.pointData[i].radius
                this.pointData[i].minX=this.pointData[i].x-this.pointData[i].radius
                this.pointData[i].maxY=this.pointData[i].y+this.pointData[i].radius
                this.pointData[i].minY=this.pointData[i].y-this.pointData[i].radius

            }
            else if(itemEnergyShape=="rectangle"){
                if(this.itemShape=="circle"){
                    this.pointData[i].width=this.pointData[i].radius*2
                    this.pointData[i].height=this.pointData[i].radius*2
                }
                this.pointData[i].maxX=this.pointData[i].x+this.pointData[i].width/2
                this.pointData[i].minX=this.pointData[i].x-this.pointData[i].width/2
                this.pointData[i].maxY=this.pointData[i].y+this.pointData[i].height/2
                this.pointData[i].minY=this.pointData[i].y-this.pointData[i].height/2

            }

            this.maxX=Math.max(this.maxX,this.pointData[i].maxX)
            this.maxY=Math.max(this.maxY,this.pointData[i].maxY)
            this.minX=Math.min(this.minX,this.pointData[i].minX)
            this.minY=Math.min(this.minY,this.pointData[i].minY)

            for (let c=0;c<this.pointData[i].catArray.length;c++){
                let nowcat=this.pointData[i].catArray[c]
                if(!this.catPointDict.hasOwnProperty(nowcat)){
                    this.catPointDict[nowcat]=[]
                    this.catPointDict[nowcat].minX = Number.MAX_VALUE
                    this.catPointDict[nowcat].maxX = Number.MIN_VALUE
                    this.catPointDict[nowcat].minY = Number.MAX_VALUE
                    this.catPointDict[nowcat].maxY = Number.MIN_VALUE
                }
                this.catPointDict[nowcat].push(this.pointData[i])
                this.catPointDict[nowcat].minX = Math.min(this.catPointDict[nowcat].minX,this.pointData[i].minX)
                this.catPointDict[nowcat].maxX = Math.max(this.catPointDict[nowcat].maxX,this.pointData[i].maxX)
                this.catPointDict[nowcat].minY = Math.min(this.catPointDict[nowcat].minY,this.pointData[i].minY)
                this.catPointDict[nowcat].maxY = Math.max(this.catPointDict[nowcat].maxY,this.pointData[i].maxY)
            }

        }


        for (let i=0;i<this.edges.length;i++){
            let start=this.edges[i].start
            let end=this.edges[i].end
            let catarr=this.pointData[start].catArray

            let minx=Math.min(this.pointData[start].x,this.pointData[end].x)
            let miny=Math.min(this.pointData[start].y,this.pointData[end].y)
            let maxx=Math.max(this.pointData[start].x,this.pointData[end].x)
            let maxy=Math.max(this.pointData[start].y,this.pointData[end].y)

            if(this.edges[i].virtrual){
                let vpoints=this.edges[i].virtrualNodes
                for (let p=0;p<vpoints.length;p++){
                    let x=vpoints[p][0]
                    let y=vpoints[p][1]
                    minx=Math.min(minx,x)
                    miny=Math.min(miny,y)
                    maxx=Math.max(maxx,x)
                    maxy=Math.max(maxy,y)
                }
            }

            this.maxX=Math.max(this.maxX,maxx)
            this.maxY=Math.max(this.maxY,maxy)
            this.minX=Math.min(this.minX,minx)
            this.minY=Math.min(this.minY,miny)

            this.edges[i].x=minx
            this.edges[i].y=miny
            this.edges[i].width=maxx-minx
            this.edges[i].height=maxy-miny

            //this.edges[i].isGroup=true;

            for (let c=0;c<catarr.length;c++){
                // let catarr=this.pointData[this.edges[i].start].catArray
                let nowcat=catarr[c]
                this.catPointDict[nowcat].minX = Math.min(this.catPointDict[nowcat].minX,minx)
                this.catPointDict[nowcat].maxX = Math.max(this.catPointDict[nowcat].maxX,maxx)
                this.catPointDict[nowcat].minY = Math.min(this.catPointDict[nowcat].minY,miny)
                this.catPointDict[nowcat].maxY = Math.max(this.catPointDict[nowcat].maxY,maxy)


            }

        }

        for(let i=0;i<this.edges.length;i++){
            let cat=this.edges[i].cat
            if(!this.catEdgeDict.hasOwnProperty(cat)){
                this.catEdgeDict[cat]=[]
            }
            this.catEdgeDict[cat].push(this.edges[i])

        }
        //console.log(this.catEdgeDict)

        if(ViewFlag){
            d3.select("#mainsvg")
                .attr("viewBox",(this.minX-Math.max(nodeR1,edgeR1)-buffer-10)+" "+(this.minY-Math.max(nodeR1,edgeR1)-buffer-10)+" "+(this.maxX-this.minX+Math.max(nodeR1,edgeR1)*2+buffer*2+20)+" "+(this.maxY-this.minY+Math.max(nodeR1,edgeR1)*2+buffer*2+20))
////
            d3.select("#leftsvg")
                .attr("viewBox",(this.minX-Math.max(nodeR1,edgeR1)-buffer-10)+" "+(this.minY-Math.max(nodeR1,edgeR1)-buffer-10)+" "+(this.maxX-this.minX+Math.max(nodeR1,edgeR1)*2+buffer*2+20)+" "+(this.maxY-this.minY+Math.max(nodeR1,edgeR1)*2+buffer*2+20))
//
            d3.selectAll('g').attr("transform","");
        }


        if(hasChangeView == false){
            offsetX = this.minX-Math.max(nodeR1,edgeR1)-buffer-10
            offsetY = this.minY-Math.max(nodeR1,edgeR1)-buffer-10
            viewWidth = this.maxX-this.minX+Math.max(nodeR1,edgeR1)*2+buffer*2+20
            viewHeight = this.maxY-this.minY+Math.max(nodeR1,edgeR1)*2+buffer*2+20
            hasChangeView = true
        }

    }


    drawPointData(){
        colors = this.props.colorArray
        // d3.select("svg").selectAll("*").remove();
        svg = d3.select('svg');

        svg.call(d3.zoom()
            .extent([[offsetX, offsetY], [viewWidth, viewHeight]])
            .scaleExtent([1, 8])
            .on("zoom", zoomed));

        function zoomed({transform}) {
            d3.selectAll('g').attr("transform", transform);
        }
        let that=this

        function dragged(event) {
            // console.log("end!")
            d3.select(this)
                .attr("cx",event.x)
                .attr("cy",event.y)
        }
        function dragstart() {
            // console.log("start!")
            // d3.select(this).classed("fixed", true);
        }

        var drag = d3.drag()
            .on("start",dragstart)
            .on("drag",dragged)

        let items=[]


        if(this.itemShape=="circle"){
            for (let i=0;i<this.pointData.length;i++){
                let index=i
                g.append("circle")
                    .attr("class","dataPoint")
                    .attr("cx",this.pointData[i].x)
                    .attr("cy",this.pointData[i].y)
                    .attr("r",this.pointData[i].radius)
                    .attr("fill",function(d,i){
                        return colors[that.pointData[index].catArray[that.pointData[index].catArray.length-1]]
                    })
                    .attr("catefory",this.pointData[i].cat)
                    .attr("index",index)
                    .on("mouseover",function(d,i){
                    })
                    // .on("click",that.clickItem.bind(that))
                    // .on("drag",function(){
                    //     console.log("drag!")
                    // })
                    // .call(drag)
            }
            items=document.getElementsByTagName("circle")
            // console.log(items)
            for (let i=0;i<items.length;i++){
                this.itemBBox.push({
                    "id":items[i].getAttribute("index"),
                    "bbox":items[i].getBBox()
                })
            }
        }
        else if(this.itemShape=="rectangle"){
            for (let i=0;i<this.pointData.length;i++){
                let index=i
                g.append("rect")
                    .attr("class","dataPoint")
                    .attr("x",this.pointData[i].x-this.pointData[i].width/2)
                    .attr("y",this.pointData[i].y-this.pointData[i].height/2)
                    .attr("width",this.pointData[i].width)
                    .attr("height",this.pointData[i].height)
                    .attr("fill",function(){
                        return colors[that.pointData[index].catArray[that.pointData[index].catArray.length-1]]
                    })
                    .attr("catefory",this.pointData[i].cat)
                    .attr("index",index)
                    .on("mouseover",function(d,i){
                    })
                    // .on("click",that.clickItem.bind(that))
                    // .on("drag",function(){
                    //     console.log("drag!")
                    // })
                    // .call(drag)
            }
            items=document.getElementsByTagName("rect")
            // console.log(items)
            for (let i=0;i<items.length;i++){
                this.itemBBox.push({
                    id:items[i].getAttribute("index"),
                    bbox:items[i].getBBox()
                })
            }
        }
    }

    isInEdgeRange(x,y,start,end){
        let x1=start.x
        let y1=start.y
        let x2=end.x
        let y2=end.y

        let cross = (x2 - x1) * (x - x1) + (y2 - y1) * (y - y1);
        // if (cross <= 0) return Math.sqrt((x - x1) * (x - x1) + (y - y1) * (y - y1));
        if (cross <= 0) return false

        let d2 = (x2 - x1) * (x2 - x1) + (y2 - y1) * (y2 - y1);
        // if (cross >= d2) return Math.sqrt((x - x2) * (x - x2) + (y - y2) * (y - y2));
        if (cross >= d2) return false

        return true
    }

    calEdgeControlPoints(){
        function sortArr(a,b){
            return a.avgdis-b.avgdis
        }
        this.edgeControlPoints=[]
        let tempcontrolpoints=[]
        for(let i=0;i<this.edges.length;i++){
            this.edgeControlPoints.push([])
            tempcontrolpoints.push([])
        }
        for (var k in control_points){
            for (let n=0;n<control_points[k].length;n++){
                let controlpoints=control_points[k][n]
                for(let i=0;i<controlpoints.length;i++){
                    let minDis=Number.MAX_VALUE
                    let minindex=-1
                    for(let e=0;e<this.edges.length;e++){
                        let edge=this.edges[e]
                        if(edge.cat!=k){
                            continue
                        }
                        let start=this.pointData[edge.start]
                        let end=this.pointData[edge.end]
                        let dis=PointToSegDist(controlpoints[i][0],controlpoints[i][1],start.x,start.y,end.x,end.y)
                        if(dis>0){
                            if(dis<minDis){
                                minDis=dis
                                minindex=e
                            }
                        }
                    }
                    if(minindex>=0){
                        tempcontrolpoints[minindex].push({
                            order:n,
                            index:i,
                            dis:minDis
                        })
                    }
                }
            }


        }
        // console.log(tempcontrolpoints[153])

        for(let i=0;i<tempcontrolpoints.length;i++){
            let iscontinue=false
            let temppoints=[]
            for(let j=1;j<tempcontrolpoints[i].length;j++){
                let lastindex=tempcontrolpoints[i][j-1].index
                let index=tempcontrolpoints[i][j].index
                if(index-lastindex==1){
                    if(iscontinue){
                        temppoints.push(tempcontrolpoints[i][j-1])
                    }
                    else{
                        iscontinue=true
                        temppoints.push(tempcontrolpoints[i][j-1])
                    }
                }
                else{
                    if(iscontinue){
                        temppoints.push(tempcontrolpoints[i][j-1])
                        iscontinue=false

                        this.edgeControlPoints[i].push(temppoints)

                        temppoints=[]
                    }
                    else{

                    }
                }
            }
            if(iscontinue){
                temppoints.push(tempcontrolpoints[i][tempcontrolpoints[i].length-1])
                this.edgeControlPoints[i].push(temppoints)
            }
        }

        for (let i=0;i<this.edgeControlPoints.length;i++){
            if(this.edgeControlPoints[i].length>2){
                for (let j=0;j<this.edgeControlPoints[i].length;j++){
                    let avgdis=0
                    for (let p=0;p<this.edgeControlPoints[i][j].length;p++){
                        avgdis+=this.edgeControlPoints[i][j][p].dis
                    }
                    avgdis=avgdis/this.edgeControlPoints[i][j].length
                    this.edgeControlPoints[i][j].avgdis=avgdis
                }
                this.edgeControlPoints[i].sort(sortArr)
                let tmp=[this.edgeControlPoints[i][0],this.edgeControlPoints[i][1]]
                this.edgeControlPoints[i]=tmp
            }

        }

    }

    changeEdgeWidth(index,width){
        let dw=width-defaultEdgeWidth
        dw=dw*1.5
        // console.log(width,dw)
        //recalculate energy field
/*        let i=index
        let edges=this.edges
        let k=edges[index].cat
        let controlpoints=control_points[k]
        let start=this.pointData[edges[index].start]
        let end=this.pointData[edges[index].end]
        let distances=[]
        for (let i=0;i<controlpoints.length;i++){
            let distoedge=PointToSegDist(controlpoints[i][0],controlpoints[i][1],start.x,start.y,end.x,end.y)
            distances.push(distoedge)
        }

        let iscontinue=false
        let temppoints={
            points:[],
            dis:0
        }
        let potentialPoints=[]
        for(let i=0;i<distances.length;i++){
            if(distances[i]>=0){
                if(iscontinue){
                    temppoints.points.push(i)
                    temppoints.dis+=distances[i]
                }
                else{
                    iscontinue=true
                    temppoints={
                        points:[],
                        dis:0
                    }
                    temppoints.points.push(i)
                    temppoints.dis+=distances[i]
                }
            }
            else{
                if(iscontinue){
                    if(temppoints.points.length>1){
                        temppoints.dis=temppoints.dis/temppoints.points.length
                        potentialPoints.push(temppoints)
                    }
                    temppoints={
                        points:[],
                        dis:0
                    }
                    iscontinue=false
                }
                else{

                }
            }
        }
        for(let i=0;i<potentialPoints.length;i++){
            for(let p=0;p<potentialPoints[i].points.length;p++){
                let point=controlpoints[potentialPoints[i].points[p]]
                drawRect(point[0],point[1],1,1,"red")
            }
        }
        console.log(potentialPoints)*/
        let k=this.edges[index].cat
        let start=this.pointData[this.edges[index].start]
        let end=this.pointData[this.edges[index].end]
        let dir=[end.x-start.x,end.y-start.y]

        let norm=[-dir[1],dir[0]]
        norm=normalizeVec(norm)

        // drawLine([start.x,start.y],[start.x+50*norm[0],start.y+50*norm[1]],"red")

        //console.log("changEdgeWidth:")
        //console.log(this.edgeControlPoints)

        let controlpoints=this.edgeControlPoints[index]
            let firstOutline=controlpoints[0]
            let secondOutline=controlpoints[1]
            let p1=control_points[k][firstOutline[0].order][firstOutline[0].index]
            let vec1=[p1[0]-start.x,p1[1]-start.y]
            let dot=vec1[0]*norm[0]+vec1[1]*norm[1]

            let firstMidpoint=firstOutline.length/2
            let secondMidpoint=secondOutline.length/2

            if(dot>0){
                //same direction with firstOutline
                let dx=dw*norm[0]
                let dy=dw*norm[1]
                for (let p=0;p<firstOutline.length;p++){
                    // if(p==0||p==firstOutline.length-1)
                    //     continue
                    let index=firstOutline[p].index
                    let order=firstOutline[p].order
                    // console.log(initialControlPoints[k][order][index][0])
                    control_points[k][order][index][0]=initialControlPoints[k][order][index][0]+dx
                    control_points[k][order][index][1]=initialControlPoints[k][order][index][1]+dy
                    // console.log(initialControlPoints[k][order][index][0])
                    // drawRect(control_points[k][order][index][0],control_points[k][order][index][1],1,1,"red")
                }
                for (let p=0;p<secondOutline.length;p++){
                    // if(p==0||p==secondOutline.length-1)
                    //     continue
                    let index=secondOutline[p].index
                    let order=secondOutline[p].order
                    // console.log(initialControlPoints[k][order][index][0])
                    control_points[k][order][index][0]=initialControlPoints[k][order][index][0]-dx
                    control_points[k][order][index][1]=initialControlPoints[k][order][index][1]-dy
                    // console.log(initialControlPoints[k][order][index][0])
                    // drawRect(control_points[k][order][index][0],control_points[k][order][index][1],1,1,"red")

                }

            }
            else{
                let dx=dw*norm[0]
                let dy=dw*norm[1]
                for (let p=0;p<firstOutline.length;p++){
                    // if(p==0||p==firstOutline.length-1)
                    //     continue
                    let index=firstOutline[p].index
                    let order=firstOutline[p].order
                    // console.log(initialControlPoints[k][order][index][0])
                    control_points[k][order][index][0]=initialControlPoints[k][order][index][0]-dx
                    control_points[k][order][index][1]=initialControlPoints[k][order][index][1]-dy
                    // console.log(initialControlPoints[k][order][index][0])
                    // drawRect(control_points[k][order][index][0],control_points[k][order][index][1],1,1,"red")

                }
                for (let p=0;p<secondOutline.length;p++){
                    // if(p==0||p==secondOutline.length-1)
                    //     continue
                    let index=secondOutline[p].index
                    let order=secondOutline[p].order
                    // console.log(initialControlPoints[k][order][index][0])
                    control_points[k][order][index][0]=initialControlPoints[k][order][index][0]+dx
                    control_points[k][order][index][1]=initialControlPoints[k][order][index][1]+dy
                    // console.log(initialControlPoints[k][order][index][0])
                    // drawRect(control_points[k][order][index][0],control_points[k][order][index][1],1,1,"red")

                }
            }

            //apply changes to energy field



        let drawPathData="";
        for(let j = 0;j < control_points[k].length; j ++){
            drawPathData += lineFunction(control_points[k][j]);
        }
        this.reDraw(k,this,drawPathData)


    }

    handleEdgeWidth(event, element){
        event.stopPropagation()
        let that = this
        that.selectedEdge=parseInt(d3.select(element).attr("index"))
        that.setState({
            hasSelectEdge:true
        })
        d3.select("svg").selectAll("line")
            .filter(function(){
                return parseInt(d3.select(element).attr("index"))==that.selectedEdge
            })
            .attr("stroke","red")
            .attr("opacity",1)
    }

    drawEdges(){
        d3.select("#mainsvg").selectAll("line").remove()
        let that=this

        function handleClick(event){
            event.stopPropagation()
            that.selectedEdge=parseInt(d3.select(this).attr("index"))
            that.setState({
                hasSelectEdge:true
            })
            d3.select("svg").selectAll("line")
                .filter(function(){
                    return parseInt(d3.select(this).attr("index"))==that.selectedEdge
                })
                .attr("stroke","red")
                .attr("opacity",1)
        }
        for (let i=0;i<this.edges.length;i++){
            let start=this.edges[i].start
            let end=this.edges[i].end
            let index=i
            if(this.edges[i].virtrual){
                let vpoints=this.edges[i].virtrualNodes
                let vstart=[this.pointData[start].x,this.pointData[start].y]
                let vend
                for (let v=0;v<vpoints.length;v++){
                    vend=vpoints[v]
                    g.append("line")
                        .attr("x1",vstart[0])
                        .attr("y1",vstart[1])
                        .attr("x2",vend[0])
                        .attr("y2",vend[1])
                        .attr("index",index)
                        .attr("stroke-width",3)
                        .attr("stroke","black")
                        .attr("opacity",0)
                        .on("mouseover",function(d,i){
                            if(that.state.hasSelectEdge){
                                return
                            }
                            let thisindex=d3.select(this).attr("index")
                            d3.select("svg")
                                .selectAll("line")
                                .filter(function(){
                                    return d3.select(this).attr("index")==thisindex
                                })
                                .attr("opacity",1)
                        })
                        .on("mouseout",function(d,i){
                            if(that.state.hasSelectEdge){
                                return
                            }
                            let thisindex=d3.select(this).attr("index")
                            d3.select("svg")
                                .selectAll("line")
                                .filter(function(){
                                    return d3.select(this).attr("index")==thisindex
                                })
                                .attr("opacity",0)
                        })
                        .on("click",handleClick)
                    vstart=vend
                }
                vend=[this.pointData[end].x,this.pointData[end].y]
                g.append("line")
                    .attr("x1",vstart[0])
                    .attr("y1",vstart[1])
                    .attr("x2",vend[0])
                    .attr("y2",vend[1])
                    .attr("index",index)
                    .attr("stroke-width",3)
                    .attr("stroke","black")
                    .attr("opacity",0)
                    .on("mouseover",function(d,i){
                        if(that.state.hasSelectEdge){
                            return
                        }
                        let thisindex=d3.select(this).attr("index")
                        d3.select("svg")
                            .selectAll("line")
                            .filter(function(){
                                return d3.select(this).attr("index")==thisindex
                            })
                            .attr("opacity",1)
                    })
                    .on("mouseout",function(d,i){
                        if(that.state.hasSelectEdge){
                            return
                        }
                        let thisindex=d3.select(this).attr("index")
                        d3.select("svg")
                            .selectAll("line")
                            .filter(function(){
                                return d3.select(this).attr("index")==thisindex
                            })
                            .attr("opacity",0)
                    })
                    .on("click",handleClick)

            }
            else{
                g.append("line")
                    .attr("x1",this.pointData[start].x)
                    .attr("y1",this.pointData[start].y)
                    .attr("x2",this.pointData[end].x)
                    .attr("y2",this.pointData[end].y)
                    .attr("index",index)
                    .attr("stroke-width",3)
                    .attr("stroke","black")
                    .attr("opacity",0)
                    .on("mouseover",function(d,i){
                        if(that.state.hasSelectEdge){
                            return
                        }
                        let thisindex=d3.select(this).attr("index")
                        d3.select("svg")
                            .selectAll("line")
                            .filter(function(){
                                return d3.select(this).attr("index")==thisindex
                            })
                            .attr("opacity",1)
                    })
                    .on("mouseout",function(d,i){
                        if(that.state.hasSelectEdge){
                            return
                        }
                        let thisindex=d3.select(this).attr("index")
                        d3.select("svg")
                            .selectAll("line")
                            .filter(function(){
                                return d3.select(this).attr("index")==thisindex
                            })
                            .attr("opacity",0)
                    })
                    .on("click",handleClick)

            }

        }
        // console.log(JSON.stringify(this.edges))
    }

    calEdgeLength(){
        let minlength=Number.MAX_VALUE
        let maxlength=Number.MIN_VALUE
        for(let i=0;i<this.edges.length;i++){
            let startpoint=this.pointData[this.edges[i].start]
            let endpoint=this.pointData[this.edges[i].end]
            if(this.edges[i].virtrual){
                let vpoint=this.edges[i].virtrualNodes
                let nowp
                let nextp
                let edgelength=0
                nowp=[startpoint.x,startpoint.y]
                for (let i=0;i<vpoint.length;i++){
                    nextp=vpoint[i]
                    edgelength+=calDistance(nowp[0],nowp[1],nextp[0],nextp[1])
                    nowp=nextp
                }
                edgelength+=calDistance(nowp[0],nowp[1],endpoint.x,endpoint.y)

                if(edgelength>maxlength){
                    maxlength=edgelength
                }
                if(edgelength<minlength){
                    minlength=edgelength
                }

            }
            else{

                let edgelength=calDistance(startpoint.x,startpoint.y,endpoint.x,endpoint.y)
                if(edgelength>maxlength){
                    maxlength=edgelength
                }
                if(edgelength<minlength){
                    minlength=edgelength
                }

            }

        }
        this.maxEdgeLength=maxlength
        this.minEdgeLength=minlength

    }

    componentWillUpdate(nextProps, nextState, nextContext) {
    }

    findOutLine(){
        for (var k in this.catEnergyField){
            this.updatedEnergyPoints[k]=[]
        }

        intervals=[0.01]

        // total field to active region
        let fieldData = {}
        for(var k in this.catEnergyField){
            fieldData[k] = []
            let startY = parseInt((this.catEnergyField[k].boundingY - this.catEnergyField[k].y)/pixelGroup)
            let startX = parseInt((this.catEnergyField[k].boundingX - this.catEnergyField[k].x)/pixelGroup)
            let endY = parseInt((this.catEnergyField[k].boundingHeight * pixelGroup + this.catEnergyField[k].boundingY - this.catEnergyField[k].y)/pixelGroup)
            let endX = parseInt((this.catEnergyField[k].boundingWidth * pixelGroup + this.catEnergyField[k].boundingX - this.catEnergyField[k].x)/pixelGroup)
            let i = 0
            for(let y = startY; y < endY; y ++){
                fieldData[k].push([])
                for(let x = startX; x < endX; x ++){
                    fieldData[k][i].push(this.catEnergyField[k].finalField[y][x])
                }
                i ++
            }
        }

        let isoDict=this.calISOLine(intervals, fieldData)

        //console.log(isoDict)

        let polygontest = {};

        control_points = {};

        let tmp_polygon = {};



        for (var k in isoDict){
            let dx=this.catEnergyField[k].boundingX
            let dy=this.catEnergyField[k].boundingY
            let prelength = 0
            for(let i = 0; i < isoDict[k].length; i ++ ){
                let polygon = [];
                if(!tmp_polygon.hasOwnProperty(k)){
                    tmp_polygon[k] = []
                }
                let sk = skipPoint
                if(isoDict[k][i].length < 30){
                    //continue;
                }
                if(isoDict[k][i].length < 50){
                    //sk = 1
                }
                for(let j = 0; j < isoDict[k][i].length; j += sk){
                    polygon.push([isoDict[k][i][j][0]*pixelGroup + dx,isoDict[k][i][j][1]*pixelGroup + dy])
                }
                tmp_polygon[k].push(polygon)
                let flag = false;
                for(let p = 0;p < this.catPointDict[k].length; p ++){
                    flag = IsoInsideTest([ this.catPointDict[k][p].x, this.catPointDict[k][p].y ], polygon);
                    if(flag) break;
                }
                if(flag){

                    if(prelength==0){
                        tmp_polygon[k].selectidx = []
                        control_points[k] = []
                    }

                    tmp_polygon[k].selectidx.push(tmp_polygon[k].length - 1)

                    polygontest[k] = [];
                    for(let j = 0; j < isoDict[k][i].length; j += sk){
                        polygontest[k].push([isoDict[k][i][j][0],isoDict[k][i][j][1]]);
                    }
                    is_selected[k] = false

                    let curlen = control_points[k].length
                    control_points[k][curlen] = [];
                    control_points[k][curlen] = polygon;

                    let meandis = 0;
                    let sz = control_points[k][curlen].length;
                    for(let j = 0; j < sz; j ++){
                        meandis += calDistance(control_points[k][curlen][j][0], control_points[k][curlen][j][1],
                            control_points[k][curlen][(j + 1) % sz][0],control_points[k][curlen][(j + 1) % sz][1])
                    }
                    meandis /= sz
                    control_points[k][curlen].meandis = meandis;
                    prelength ++
                    //this.drawISOLinesV2(k,this)
                }
            }
            //this.drawEnergyField(k);
        }

        //console.log(tmp_polygon)

        for(let k in this.catEnergyField){
            this.updatedEnergyPoints[k] = []
        }


        //remove_Polys = {}

        for(var k in isoDict){
            //let dx=this.catEnergyField[k].boundingX
            //let dy=this.catEnergyField[k].boundingY
            let sidx = tmp_polygon[k].selectidx;
            for(let i = 0; i < tmp_polygon[k].length; i ++){
                let isthis = false
                for(let j = 0;j < sidx.length; j ++){
                    if(i == sidx[j]){
                        isthis = true
                        break
                    }
                }
                if(isthis){
                    continue
                }
                let flag = true;
                for(let p = 0; p < sidx.length; p ++){
                    for(let j = 0; j < tmp_polygon[k][i].length; j ++){
                        flag = IsoInsideTest([ tmp_polygon[k][i][j][0], tmp_polygon[k][i][j][1] ], tmp_polygon[k][sidx[p]]);
                        if(flag == false){
                            break;
                        }
                    }
                    if(flag){
                        break;
                    }
                }
                if(flag){

                    if(AreaCal(tmp_polygon[k][i]) < minItemArea){
                        continue
                    }

                    let st_idx = 0
                    let pt_len = tmp_polygon[k][i].length
                    let j_pt = [-1,-1]
                    while(st_idx < pt_len){
                        let idx1 = (st_idx - 1 + pt_len) % pt_len
                        let idx2 = (st_idx + 1) % pt_len
                        let ve1 = [tmp_polygon[k][i][idx1][0] - tmp_polygon[k][i][st_idx][0], tmp_polygon[k][i][idx1][1] - tmp_polygon[k][i][st_idx][1]]
                        let ve2 = [tmp_polygon[k][i][idx2][0] - tmp_polygon[k][i][st_idx][0], tmp_polygon[k][i][idx2][1] - tmp_polygon[k][i][st_idx][1]]
                        let ve3 = [ve1[0] + ve2[0], ve1[1] + ve2[1]]
                        let ve3_len = Math.sqrt(ve3[0] * ve3[0] + ve3[1] * ve3[1])
                        if(ve3_len != 0){
                            ve3 = [ve3[0] / ve3_len, ve3[1] / ve3_len]
                        }
                        let test_pt = [tmp_polygon[k][i][st_idx][0] + 2 * ve3[0], tmp_polygon[k][i][st_idx][1] + 2 * ve3[1]]
                        if(IsoInsideTest(test_pt, tmp_polygon[k][i])){
                            j_pt = [test_pt[0], test_pt[1]]
                            break;
                        }
                        st_idx ++
                    }

                    let is_use_inner = true

                    if(j_pt[0] != -1 && j_pt[1] != -1){
                        //if(k=="2"){
                        //  g.append("circle")
                        //      .attr("cx",j_pt[0])
                        //      .attr("cy",j_pt[1])
                        //      .attr("r",3)
                        //      .attr("fill","black")
//
                        //}

                        let j_y = parseInt((j_pt[1] -this.catEnergyField[k].y) / pixelGroup)
                        let j_x = parseInt((j_pt[0] -this.catEnergyField[k].x) / pixelGroup)
                        //if(k=="2"){
                        //    console.log("inner outline!")
                        //    console.log("(" + j_pt[0] + ", " + j_pt[1] + ")")
                        //    console.log(this.catEnergyField["2"].field[j_y][j_x])
                        //    console.log(this.catEnergyField["2"].finalField[j_y][j_x])
                        //    console.log(this.catEnergyField["2"].barrierMap[j_y][j_x])
                        //    console.log(this.catEnergyField["2"].pointIndexMap[j_y][j_x])
                        //    console.log(this.catEnergyField["2"].edgeIndexMap[j_y][j_x])
                        //    console.log(this.catEnergyField["3"].field[j_y][j_x])
                        //    console.log(this.catEnergyField["3"].finalField[j_y][j_x])
                        //    console.log(this.catEnergyField["3"].barrierMap[j_y][j_x])
                        //    console.log(this.catEnergyField["3"].pointIndexMap[j_y][j_x])
                        //    console.log(this.catEnergyField["3"].edgeIndexMap[j_y][j_x])
                        //}
                        //console.log("inner outline!")
                        //console.log(this.catEnergyField[k].field[j_y][j_x])
                        //console.log(this.catEnergyField[k].finalField[j_y][j_x])
                        if(this.catEnergyField[k].finalField[j_y][j_x] > 0.01){
                            is_use_inner = false
                        }
                    }

                    if(!is_use_inner){
                        continue
                    }

                    let curlen = control_points[k].length;
                    control_points[k][curlen] = [];
                    for(let j = 0; j < tmp_polygon[k][i].length; j ++){
                        control_points[k][curlen].push( [tmp_polygon[k][i][j][0], tmp_polygon[k][i][j][1]] )
                    }
                    let meandis = 0;
                    let sz = control_points[k][curlen].length;
                    for(let j = 0; j < sz; j ++){
                        meandis += calDistance(control_points[k][curlen][j][0], control_points[k][curlen][j][1],
                            control_points[k][curlen][(j + 1) % sz][0],control_points[k][curlen][(j + 1) % sz][1])
                    }
                    meandis /= sz
                    control_points[k][curlen].meandis = meandis;
                }
                /*
                else{
                    recal = true
                    if(!remove_Polys.hasOwnProperty(k)){
                        remove_Polys[k] = []
                    }
                    let tmp_polygon = []
                    let sub_polygon = []
                    for(let j = 0; j < isoDict[k][i].length; j ++){
                        let realx = isoDict[k][i][j][0]*pixelGroup + dx
                        let realy = isoDict[k][i][j][1]*pixelGroup + dy
                        sub_polygon.push([realx, realy])
                        let x = parseInt((realx - this.catEnergyField[k].x) / pixelGroup)
                        let y = parseInt((realy - this.catEnergyField[k].y) / pixelGroup)
                        tmp_polygon.push([x, y])
                    }
                    remove_Polys[k].push(tmp_polygon)
                    this.fillPolygon(sub_polygon, k, 0, true)
                }

                 */
            }
        }

    }

    calOutLine(){

        //if(recal && recalNum == 0){
        //    recalNum += 1
        //    for(let k in remove_Polys){
        //        this.recalFinalEnergeField(k)
        //    }
        //}
//
        //if(this.firstFlag){
        //    this.firstFlag = false
        //    this.createGapInBoundary()
        //}


        //this.findOutLine()

        let path_Info = {}

        for(var k in this.catEnergyField){
            path_Info[k] = []
            let curdata=""
            for(let i = 0; i < control_points[k].length; i ++){
                path_Info[k].push(lineFunction(control_points[k][i]))
                curdata += lineFunction(control_points[k][i])
            }
            this.drawISOLinesV2(k, this, curdata);
        }

        //for(let k in this.catEnergyField){
        //    this.drawEnergyField(k)
        //}

        for (var k in control_points){
            initialControlPoints[k]=[]
            for (let i=0;i<control_points[k].length;i++){
                initialControlPoints[k][i]=[]
                for (let j=0;j<control_points[k][i].length;j++){
                    initialControlPoints[k][i].push([])
                    initialControlPoints[k][i][j].push(control_points[k][i][j][0])
                    initialControlPoints[k][i][j].push(control_points[k][i][j][1])
                }
            }
        }

    }


    loadEdgeData(){
        //let that=this
        //fetch('/data/'+edgeDataName,{
        //    method:'GET',
        //    headers:{
        //        'Content-Type':'application/json;charset=UTF-8'
        //    },
        //    mode:'cors',
        //    cache:'default'
        //})
        //    .then(res=>res.json())
        //    .then(data=>{
                //this.edges=data

                this.centralizeData(true)


                // this.drawEdges()
                this.calEdgeLength()
                this.calActiveRegion(true)


                this.calEnergyField()
                //this.calFinalEnergeFieldV2()
                this.calFinalEnergeField()
                this.fillCrossingEdge()
                this.createGapInBoundary()

                //console.time("smooth")
                // this.smoothEnergyField()
                //console.timeEnd("smooth")

                // for(let k in this.catPointDict){
                //    this.drawEnergyField(k);
                // }



                d3.select("svg").selectAll("*").remove()
                g = d3.select('svg').append("g")

                //g.append("image")
                //    .attr("x",-42)
                //    .attr("y",-42)
                //    .attr("width",995)
                //    .attr("height",1350)
                //    .attr("xlink:href","/data/background/Manhatton.jpg")

                recal = false
                recalNum = 0

                this.findOutLine()
                this.calOutLine()

                /*

                // re-cal the energy field for inner outline
                for (var k in this.catEnergyField){
                    this.catEnergyField[k].tfinalField = []
                    for(let y=0;y<this.catEnergyField[k].height;y++){
                        this.catEnergyField[k].tfinalField.push(new Array(this.catEnergyField[k].width).fill(0));
                        for(let x=0;x<this.catEnergyField[k].width;x++){
                            let val = this.catEnergyField[k].finalField[y][x];
                            if(IsoInsideTest([x, y], polygontest[k])){
                                //console.log("test!!")
                                if(val > 0){
                                    this.catEnergyField[k].tfinalField[y][x] = 0;
                                }
                                else{
                                    this.catEnergyField[k].tfinalField[y][x] = 10;
                                }
                            }
                            else{
                                this.catEnergyField[k].finalField[y][x] = 0;
                            }
                        }
                    }
                }


                let isoLineDict={}
                for (var k in this.catEnergyField){
                    var isoLines = [];
                    isoLines=MarchingSquaresJS
                        .isoLines(this.catEnergyField[k].tfinalField,
                            intervals,
                            {
                                polygons: false,
                                linearRing: false,
                                noFrame:true
                            }
                        )
                    isoLineDict[k]=isoLines[0]
                }

                for (var k in isoLineDict){
                    //console.log(isoLineDict[k])
                    let dx=this.catEnergyField[k].x
                    let dy=this.catEnergyField[k].y
                    for(let i = 0; i < isoLineDict[k].length; i ++ ){
                        if(isoLineDict[k][i].length < 30){
                            continue;
                        }
                        let curlen = control_points[k].length;
                        control_points[k][curlen] = [];
                        for(let j = 0; j < isoLineDict[k][i].length; j += 10){
                            control_points[k][curlen].push([isoLineDict[k][i][j][0]*pixelGroup + dx,isoLineDict[k][i][j][1]*pixelGroup + dy])
                        }
                        let meandis = 0;
                        let sz = control_points[k][curlen].length;
                        for(let j = 0; j < sz; j ++){
                            meandis += calDistance(control_points[k][curlen][j][0], control_points[k][curlen][j][1],
                                control_points[k][curlen][(j + 1) % sz][0],control_points[k][curlen][(j + 1) % sz][1])
                        }
                        meandis /= sz
                        control_points[k][curlen].meandis = meandis;
                    }
                    //this.drawEnergyField(k);
                }

                 */

                //this.drawEnergyField("2")
                //this.drawEnergyField("3")

                this.calEdgeControlPoints()



                this.drawEdges()
                this.drawPointData()

                //for(let k in this.catEnergyField){
                //    this.drawEnergyField(k)
                //}

                let that=this
                function handleSvgClick(){
                    d3.select("svg").selectAll("line")
                        .filter(function(){
                            return parseInt(d3.select(this).attr("index"))==that.selectedEdge
                        })
                        .attr("stroke","red")
                        .attr("opacity",0)
                    that.selectedEdge=-1
                    that.setState({
                        hasSelectEdge:false,
                        edgeWidth:defaultEdgeWidth
                    })
                }
                        d3.select("svg")
                            .on("click",handleSvgClick)

            //})
    }

    afterEditReDraw(){

        this.pointData = this.props.pointData

        this.edges = this.props.edges

        this.drawEdges()

        this.drawPointData()

        let that=this

        function handleSvgClick(){
            d3.select("svg").selectAll("line")
                .filter(function(){
                    return parseInt(d3.select(this).attr("index"))==that.selectedEdge
                })
                .attr("stroke","red")
                .attr("opacity",0)
            that.selectedEdge=-1
            that.setState({
                hasSelectEdge:false,
                edgeWidth:defaultEdgeWidth
            })
        }
        d3.select("svg")
            .on("click",handleSvgClick)

    }

    calActiveRegion(flag){

        for (var k in this.catPointDict){

            if(flag || !this.catEnergyField.hasOwnProperty(k)){
                this.catEnergyField[k]={}
                //console.log("calActiveRegion:")
                //console.log(k)
            }

            let maxx=this.catPointDict[k].maxX
            let minx=this.catPointDict[k].minX
            let maxy=this.catPointDict[k].maxY
            let miny=this.catPointDict[k].minY

            //console.log("active region: ")
            //console.log([maxx, minx, maxy, miny])

            this.catEnergyField[k].boundingX=minx-Math.max(nodeR1,edgeR1)-buffer
            this.catEnergyField[k].boundingY=miny-Math.max(nodeR1,edgeR1)-buffer

            this.catEnergyField[k].boundingWidth=Math.ceil((maxx-minx+Math.max(nodeR1,edgeR1)*2+buffer*2)/pixelGroup)
            this.catEnergyField[k].boundingHeight=Math.ceil((maxy-miny+Math.max(nodeR1,edgeR1)*2+buffer*2)/pixelGroup)

            if(flag || !this.catEnergyField[k].hasOwnProperty("field")){

                let centerX = this.catEnergyField[k].boundingX + 0.5 * this.catEnergyField[k].boundingWidth
                let centerY = this.catEnergyField[k].boundingY + 0.5 * this.catEnergyField[k].boundingHeight

                this.catEnergyField[k].x = parseInt((centerX - 0.5 * svgwidth))
                this.catEnergyField[k].y = parseInt((centerY - 0.5 * svgheight))

                this.catEnergyField[k].width = parseInt(svgwidth / pixelGroup)
                this.catEnergyField[k].height = parseInt(svgheight / pixelGroup)

                this.catEnergyField[k].field=[]
                this.catEnergyField[k].barrierMap=[]
                for (let i=0;i<svgheight;i++){
                    this.catEnergyField[k].field.push(new Array(svgwidth).fill(0))
                    this.catEnergyField[k].barrierMap.push(new Array(svgwidth).fill(0))
                }

            }

        }

        this.hasBubbles = true

    }

    calDistanceToItem(x,y,item){
        //TODO: Rectangle items
        //inside is 0
        if(itemEnergyShape=="circle"){
            let dis=calDistance(x,y,item.x,item.y)
            if(dis<item.radius){
                return 0
            }
            else{
                return dis-item.radius
            }
        }

    }

    getPointEdgeDistance(lx1, ly1, lx2, ly2, x, y) {
        var x1 = lx1;
        var y1 = ly1;
        var x2 = lx2 - x1;
        var y2 = ly2 - y1;
        var px = x - x1;
        var py = y - y1;
        var dotprod = px * x2 + py * y2;
        var projlenSq;
        if(dotprod <= 0) {
            projlenSq = 0;
        } else {
            px = x2 - px;
            py = y2 - py;
            dotprod = px * x2 + py * y2;
            if(dotprod <= 0) {
                projlenSq = 0;
            } else {
                projlenSq = dotprod * dotprod / (x2 * x2 + y2 * y2);
            }
        }
        var lenSq = px * px + py * py - projlenSq;
        if(lenSq < 0) {
            lenSq = 0;
        }
        return Math.sqrt(lenSq);
    }

    calDistanceToEdgeV2(x,y,edge){
        //return the distance to the edge and distance to two nodes
        let startpoint, endpoint
        if(edge.flag == false){
            startpoint = edge.startpoint
            endpoint = edge.endpoint
        }
        else{
            startpoint=this.pointData[edge.start]
            endpoint=this.pointData[edge.end]
        }
        if(edge.virtrual && edge.virtrualNodes.length > 0){
            let vpoint=edge.virtrualNodes
            let nowp=[startpoint.x,startpoint.y]
            let nextp
            let mindis=Number.MAX_VALUE
            let distancetostartnode=0
            let distancetoendnode=0
            let distancetoedge=0
            let totaldistance=0
            let minindex=-1
            for (let i=0;i<vpoint.length;i++){
                nextp=vpoint[i]
                let dis=this.getPointEdgeDistance(nowp[0],nowp[1],nextp[0],nextp[1],x,y)
                if(dis<mindis){
                    mindis=dis
                    minindex=i
                }
                nowp=nextp
            }

            nowp=[startpoint.x,startpoint.y]
            for(let i=0;i<minindex;i++){
                nextp=vpoint[i]
                distancetostartnode+=calDistance(nowp[0],nowp[1],nextp[0],nextp[1])
                nowp=nextp
            }
            if(minindex==0){
                nowp=[startpoint.x,startpoint.y]
                nextp=vpoint[0]
            }
            else{
                nowp=vpoint[minindex-1]
                nextp=vpoint[minindex]
            }

            let enddis=this.getPointEdgeDistance(endpoint.x,endpoint.y,vpoint[vpoint.length-1][0],vpoint[vpoint.length-1][1],x,y)
            if(enddis<mindis){
                mindis=enddis
                distancetostartnode+=calDistance(nowp[0],nowp[1],nextp[0],nextp[1])
                nowp=nextp
                nextp=[endpoint.x,endpoint.y]
            }

            distancetoedge=mindis

            let sp=[x-nowp[0],y-nowp[1]]
            let se=[nextp[0]-nowp[0],nextp[1]-nowp[1]]
            let es=[nowp[0]-nextp[0],nowp[1]-nextp[1]]
            let ep=[x-nextp[0],x-nextp[1]]
            let selength=calDistance(nowp[0],nowp[1],nextp[0],nextp[1])
            let sesp=se[0]*sp[0]+se[1]*sp[1]
            let esep=es[0]*ep[0]+es[1]*ep[1]
            let n=sesp/selength

            // if(sesp>0&&esep>0){
            distancetostartnode+=n
            // }


            nowp=[startpoint.x,startpoint.y]
            for(let i=0;i<vpoint.length;i++){
                nextp=vpoint[i]
                totaldistance+=calDistance(nowp[0],nowp[1],nextp[0],nextp[1])
                nowp=nextp
            }
            totaldistance+=calDistance(nowp[0],nowp[1],endpoint.x,endpoint.y)
            distancetoendnode=totaldistance-distancetostartnode
            let distancetonode=Math.min(distancetostartnode,distancetoendnode)

            if(distancetonode<0){
                distancetonode=-1
                // drawRect(x,y,5,5,"red")
                // console.log()
            }

            return [distancetoedge,distancetonode,totaldistance]

        }
        else{
            let distancetoedge=this.getPointEdgeDistance(startpoint.x,startpoint.y,endpoint.x,endpoint.y,x,y)
            let sp=[x-startpoint.x,y-startpoint.y]
            let se=[endpoint.x-startpoint.x,endpoint.y-startpoint.y]
            let es=[startpoint.x-endpoint.x,startpoint.y-endpoint.y]
            let ep=[x-endpoint.x,y-endpoint.y]

            let selength=calDistance(startpoint.x,startpoint.y,endpoint.x,endpoint.y)
            let sesp=se[0]*sp[0]+se[1]*sp[1]
            let esep=es[0]*ep[0]+es[1]*ep[1]


            let n=sesp/selength

            // let dir=[se[0]/selength*n,se[1]/selength*n]
            // let newp=[se[0]+dir[0],se[1]+dir[1]]


            let distancetostartnode=n
            let distancetoendnode=selength-n
            let distancetonode=Math.min(distancetostartnode,distancetoendnode)
            if(distancetonode<0){
                distancetonode=-1

            }

            let totaldistance=selength

            return [distancetoedge,distancetonode,totaldistance]
        }


    }

    calDistanceToEdge(x,y,edge){
        //return the distance to the edge and distance to two nodes
        let startpoint=this.pointData[edge.start]
        let endpoint=this.pointData[edge.end]
        if(edge.virtrual){
            let vpoint=edge.virtrualNodes
            let nowp=[startpoint.x,startpoint.y]
            let nextp
            let mindis=Number.MAX_VALUE
            let distancetostartnode=0
            let distancetoendnode=0
            let distancetoedge=0
            let totaldistance=0
            let minindex=-1
            for (let i=0;i<vpoint.length;i++){
                nextp=vpoint[i]
                let dis=this.getPointEdgeDistance(nowp[0],nowp[1],nextp[0],nextp[1],x,y)
                if(dis<mindis){
                    mindis=dis
                    minindex=i
                }
                nowp=nextp
            }

            nowp=[startpoint.x,startpoint.y]
            for(let i=0;i<minindex;i++){
                nextp=vpoint[i]
                distancetostartnode+=calDistance(nowp[0],nowp[1],nextp[0],nextp[1])
                nowp=nextp
            }
            if(minindex==0){
                nowp=[startpoint.x,startpoint.y]
                nextp=vpoint[0]
            }
            else{
                nowp=vpoint[minindex-1]
                nextp=vpoint[minindex]
            }

            let enddis=this.getPointEdgeDistance(endpoint.x,endpoint.y,vpoint[vpoint.length-1][0],vpoint[vpoint.length-1][1],x,y)
            if(enddis<mindis){
                mindis=enddis
                distancetostartnode+=calDistance(nowp[0],nowp[1],nextp[0],nextp[1])
                nowp=nextp
                nextp=[endpoint.x,endpoint.y]
            }

            distancetoedge=mindis

            let sp=[x-nowp[0],y-nowp[1]]
            let se=[nextp[0]-nowp[0],nextp[1]-nowp[1]]
            let es=[nowp[0]-nextp[0],nowp[1]-nextp[1]]
            let ep=[x-nextp[0],x-nextp[1]]
            let selength=calDistance(nowp[0],nowp[1],nextp[0],nextp[1])
            let sesp=se[0]*sp[0]+se[1]*sp[1]
            let esep=es[0]*ep[0]+es[1]*ep[1]
            let n=sesp/selength

            // if(sesp>0&&esep>0){
            distancetostartnode+=n
            // }


            nowp=[startpoint.x,startpoint.y]
            for(let i=0;i<vpoint.length;i++){
                nextp=vpoint[i]
                totaldistance+=calDistance(nowp[0],nowp[1],nextp[0],nextp[1])
                nowp=nextp
            }
            totaldistance+=calDistance(nowp[0],nowp[1],endpoint.x,endpoint.y)
            distancetoendnode=totaldistance-distancetostartnode
            let distancetonode=Math.min(distancetostartnode,distancetoendnode)

            if(distancetonode<0){
                distancetonode=-1
                // drawRect(x,y,5,5,"red")
                // console.log()
            }

            return [distancetoedge,distancetonode,totaldistance]

        }
        else{
            let distancetoedge=this.getPointEdgeDistance(startpoint.x,startpoint.y,endpoint.x,endpoint.y,x,y)
            let sp=[x-startpoint.x,y-startpoint.y]
            let se=[endpoint.x-startpoint.x,endpoint.y-startpoint.y]
            let es=[startpoint.x-endpoint.x,startpoint.y-endpoint.y]
            let ep=[x-endpoint.x,y-endpoint.y]

            let selength=calDistance(startpoint.x,startpoint.y,endpoint.x,endpoint.y)
            let sesp=se[0]*sp[0]+se[1]*sp[1]
            let esep=es[0]*ep[0]+es[1]*ep[1]


            let n=sesp/selength

            // let dir=[se[0]/selength*n,se[1]/selength*n]
            // let newp=[se[0]+dir[0],se[1]+dir[1]]


            let distancetostartnode=n
            let distancetoendnode=selength-n
            let distancetonode=Math.min(distancetostartnode,distancetoendnode)
            if(distancetonode<0){
                distancetonode=-1

            }

            let totaldistance=selength

            return [distancetoedge,distancetonode,totaldistance]
        }


    }

    isRectIntersects (rect1,rect2) {
        if(rect1.width <= 0 || rect1.height <= 0 || rect2.width <= 0 || rect2.height <= 0) return false;
        return (rect2.maxX > rect1.minX &&
            rect2.maxY > rect1.minY &&
            rect2.minX < rect1.maxX &&
            rect2.minY < rect1.maxY);
    };

    isThisCat(point,cat){
        let catarr=point.catArray
        for(let i=0;i<catarr.length;i++){
            if(catarr[i]==cat){
                return true
            }
        }
        return false
    }

    LabelGroupElement(){
        let maxpdis = nodeR1 * 2
        for(let k1 in this.catPointDict){

            // cal for points
            for(let i = 0;i < this.catPointDict[k1].length; i ++){
                if(this.catPointDict[k1][i].isGroup==false){
                    continue;
                }
                let isgroup = true;
                let x1 = this.catPointDict[k1][i].x;
                let y1 = this.catPointDict[k1][i].y;
                for(let k2 in this.catPointDict){
//
                    if(k1==k2){
                        continue;
                    }
//
                    // cal node
                    for(let j = 0;j < this.catPointDict[k2].length; j ++){
                        let x2 = this.catPointDict[k2][j].x;
                        let y2 = this.catPointDict[k2][j].y;
                        if(calDistance(x1,y1,x2,y2) < maxpdis + this.catPointDict[k2][j].radius + this.catPointDict[k1][i].radius){
                            isgroup = false;
                            this.catPointDict[k2][j].isGroup = false;
                            break;
                        }
                    }
//
                    if(isgroup==false){
                        break;
                    }
//
                    // cal edge
                    if(!this.catEdgeDict.hasOwnProperty(k2)){
                        continue;
                    }
                    for(let j = 0;j < this.catEdgeDict[k2].length; j ++ ){
                        if(this.calDistanceToEdge(x1,y1,this.catEdgeDict[k2][j])[0] < maxpdis + this.catPointDict[k1][i].radius){
                            isgroup = false;
                            this.catEdgeDict[k2][j].isGroup = false;
                            break;
                        }
                    }
                    if(isgroup==false){
                        break;
                    }
                }
                this.catPointDict[k1][i].isGroup = isgroup
            }

            // cal for edges
            if(!this.catEdgeDict.hasOwnProperty(k1)){
                continue;
            }
            for(let i = 0;i < this.catEdgeDict[k1].length;i ++){
                let s1 = this.pointData[this.catEdgeDict[k1][i].start];
                let e1 = this.pointData[this.catEdgeDict[k1][i].end];
                if(this.catEdgeDict[k1][i].isGroup == false){
                    continue;
                }
                let isgroup = true
                for(let k2 in this.catPointDict){
                    if(k1==k2){
                        continue;
                    }
                    // cal node
                    for(let j = 0;j < this.catPointDict[k2].length; j ++){
                        let x2 = this.catPointDict[k2][j].x;
                        let y2 = this.catPointDict[k2][j].y;
                        if(this.calDistanceToEdge(x2,y2,this.catEdgeDict[k1][i])[0] < maxpdis + this.catPointDict[k2][j].radius){
                            isgroup = false;
                            this.catPointDict[k2][j].isGroup = false;
                            break;
                        }
                    }
                    if(isgroup==false){
                        break;
                    }
//
                    //// cal edge
                    //if(!this.catEdgeDict.hasOwnProperty(k2)){
                    //    continue;
                    //}
                    //for(let j = 0;j < this.catEdgeDict[k2].length; j ++ ){
                    //    let s2 = this.pointData[this.catEdgeDict[k2][j].start];
                    //    let e2 = this.pointData[this.catEdgeDict[k2][j].end];
                    //    if(this.checkEdgeCrossing(s1,e1,s2,e2)[0]){
                    //        isgroup = false;
                    //        this.catEdgeDict[k2][j].isGroup = false;
                    //        break;
                    //    }
                    //}
                    //if(isgroup==false){
                    //    break;
                    //}
//
                }
                this.catEdgeDict[k1][i].isGroup = isgroup
            }

        }
    }

    calEnergyField_Part(updatePoints, updateEdges){

        for (var k in this.catPointDict){

            if(!this.catEnergyField[k].hasOwnProperty("finalField")){
                // group attrs
                this.catPointDict[k].pointMap=[]
                this.catEnergyField[k].pointBarrierMap=[]
                this.catEnergyField[k].edgeBarrierMap=[]
                this.catEnergyField[k].pointIndexMap=[]
                this.catEnergyField[k].edgeIndexMap=[]
                this.catEnergyField[k].edgeIndexMap2=[]
                this.catEnergyField[k].finalField = []
                this.catEnergyField[k].subUpdate = []

                for (let y=0;y<svgheight;y++){
                    this.catEnergyField[k].finalField.push(new Array(svgwidth).fill(0))
                    this.catEnergyField[k].subUpdate.push(new Array(svgwidth).fill(0))
                    this.catEnergyField[k].pointBarrierMap.push(new Array(svgwidth).fill(0))
                    this.catEnergyField[k].edgeBarrierMap.push(new Array(svgwidth).fill(0))
                    this.catEnergyField[k].pointIndexMap.push(new Array(svgwidth).fill(-1))
                    this.catEnergyField[k].edgeIndexMap.push(new Array(svgwidth).fill(-1))

                    this.catEnergyField[k].edgeIndexMap2.push([])
                    for(let x=0;x<svgwidth;x++){
                        this.catEnergyField[k].edgeIndexMap2[y].push([])
                    }
                }

            }

        }


        for(var k in this.catPointDict){

            if(!updatePoints.hasOwnProperty(k)){
                updatePoints[k] = []
            }

            if(!updateEdges.hasOwnProperty(k)){
                updateEdges[k] = []
            }

            let members = updatePoints[k]

            // cal positive energy of nodes and barrier map
            for (let i=0;i<members.length;i++){
                let point=members[i]
                //this.catPointDict[k].pointMap.push([])
                // cal influence area for pixel group
                let startx
                let endx
                let starty
                let endy
                startx=Math.floor((point.minX-nodeR1-10-this.catEnergyField[k].x) / pixelGroup);
                startx = Math.max(0, startx)
                endx=Math.min(Math.ceil((point.maxX+nodeR1+10-this.catEnergyField[k].x) / pixelGroup),this.catEnergyField[k].width);
                endx = Math.max(0, endx)
                starty=Math.floor((point.minY-nodeR1-10-this.catEnergyField[k].y) / pixelGroup);
                starty = Math.max(0, starty)
                endy=Math.min(Math.ceil((point.maxY+nodeR1+10-this.catEnergyField[k].y) / pixelGroup),this.catEnergyField[k].height);
                endy = Math.max(0, endy)
                for (let y=starty;y<endy;y++){
                    for (let x=startx;x<endx;x++){
                        let realx=x * pixelGroup + this.catEnergyField[k].x
                        let realy=y * pixelGroup + this.catEnergyField[k].y

                        //if(!this.updateIdx.hasOwnProperty(realy)){
                        //    this.updateIdx[realy] = {}
                        //}
//
                        //this.updateIdx[realy][realx] = 1

                        this.updateIdx.push([parseInt(realy), parseInt(realx)])

                        let distance=this.calDistanceToItem(realx,realy,point)

                        if(distance<nodeR1+fixdis){
                            let energy=nodeWeight*Math.pow(nodeR1-distance,2)/Math.pow(nodeR1-nodeR0,2)

                            if(members[i].flag == false){
                                this.catEnergyField[k].field[y][x]-=energy
                                this.catEnergyField[k].finalField[y][x]=0
                                this.catEnergyField[k].subUpdate[y][x] = 1
                                if(this.catEnergyField[k].field[y][x] <= 0.015 || this.catEnergyField[k].edgeIndexMap[y][x] == -1){
                                    this.catEnergyField[k].field[y][x] = 0
                                    this.catEnergyField[k].pointBarrierMap[y][x]=0
                                    this.catEnergyField[k].pointIndexMap[y][x]=-1
                                    this.catEnergyField[k].barrierMap[y][x]=0
                                }
                            }
                            else{

                                this.catEnergyField[k].field[y][x]+=energy
                                this.catEnergyField[k].finalField[y][x]=0
                                this.catEnergyField[k].subUpdate[y][x] = 0
                                if(this.catEnergyField[k].barrierMap[y][x]==0){
                                    this.catEnergyField[k].barrierMap[y][x]=5
                                }
                                if(this.catEnergyField[k].pointBarrierMap[y][x]==0){
                                    this.catEnergyField[k].pointBarrierMap[y][x]=5
                                }
                                if(this.catEnergyField[k].pointIndexMap[y][x]==-1){
                                    this.catEnergyField[k].pointIndexMap[y][x]=point.id
                                }

                            }

                        }

                        if(members[i].flag == true){

                            if(distance<=barrierGap+fixdis){
                                if(this.catEnergyField[k].barrierMap[y][x]!=3){
                                    this.catEnergyField[k].barrierMap[y][x]=1
                                }
                                if(this.catEnergyField[k].pointBarrierMap[y][x]!=3){
                                    this.catEnergyField[k].pointBarrierMap[y][x]=1
                                }
                            }

                            if(distance<=fixdis){
                                //inside
                                this.catEnergyField[k].barrierMap[y][x]=3
                                //this.catPointDict[k].pointMap[i].push([x,y])
                                this.catEnergyField[k].pointBarrierMap[y][x]=3
                                this.catEnergyField[k].pointIndexMap[y][x]=point.id
                            }

                        }

                    }
                }
            }


            let EDGELENGTH_THRESH=this.maxEdgeLength/1.5
            // cal positive value of edges
            let edges=updateEdges[k]
            edges.sort(function(a,b){
                return a.flag - b.flag
            })
            //console.log("Sort Edegs:")
            //console.log(edges)
            for (let i=0;i<edges.length;i++){
                // cal positive value for pixel group
                let startx
                let endx
                let starty
                let endy
                let startid=edges[i].start
                let endid=edges[i].end
                startx=Math.floor((edges[i].x-edgeR1-10-this.catEnergyField[k].x)/pixelGroup)
                startx = Math.max(0, startx)
                endx=Math.min(Math.ceil((edges[i].x+edges[i].width+edgeR1+10-this.catEnergyField[k].x)/pixelGroup),this.catEnergyField[k].width)
                endx = Math.max(0, endx)
                starty=Math.floor((edges[i].y-edgeR1-10-this.catEnergyField[k].y)/pixelGroup)
                starty = Math.max(0, starty)
                endy=Math.min(Math.ceil((edges[i].y+edges[i].height+edgeR1+10-this.catEnergyField[k].y)/pixelGroup),this.catEnergyField[k].height)
                endy = Math.max(0, endy)
                for (let y=starty;y<endy;y++){
                    for (let x=startx;x<endx;x++){
                        let realx=x*pixelGroup+this.catEnergyField[k].x
                        let realy=y*pixelGroup+this.catEnergyField[k].y

                        //if(!this.updateIdx.hasOwnProperty(realy)){
                        //    this.updateIdx[realy] = {}
                        //}
//
                        //this.updateIdx[realy][realx] = 1

                        this.updateIdx.push([parseInt(realy), parseInt(realx)])

                        let distance=this.calDistanceToEdgeV2(realx,realy,edges[i])
                        let distancetoEdge=distance[0]
                        let distancetoNode=distance[1]
                        let totalDistance=distance[2]

                        if(distancetoNode<0){
                            continue
                        }

                        if(distancetoEdge<edgeR1+fixdis){
                            let newR1=edgeR1
                            let reducefactor=edgeR1/10
                            let factor=(edgeR1-2)/(reducefactor*totalDistance)

                            if(totalDistance>EDGELENGTH_THRESH){
                                newR1=2*edgeR1/(1+factor*distancetoNode)
                            }
                            if(newR1>edgeR1){
                                newR1=edgeR1
                            }

                            if(newR1>2*nodeR1){
                                newR1=2*nodeR1
                            }
                            let energy
                            if(distancetoEdge>newR1){
                                energy=0
                            }
                            else{
                                energy=edgeWeight*Math.pow(newR1-distancetoEdge,2)/Math.pow(edgeR1-edgeR0,2)
                            }


                            if(edges[i].flag == true){
                                let preenergy = this.catEnergyField[k].finalField[y][x]
                                this.catEnergyField[k].field[y][x]+=energy
                                this.catEnergyField[k].finalField[y][x]=0
                                this.catEnergyField[k].subUpdate[y][x] = 0
                                if(this.catEnergyField[k].barrierMap[y][x]==0||this.catEnergyField[k].barrierMap[y][x]==5){
                                    if(energy>0)
                                        this.catEnergyField[k].barrierMap[y][x]=6
                                }
                                if(this.catEnergyField[k].edgeBarrierMap[y][x]==0||this.catEnergyField[k].edgeBarrierMap[y][x]==5) {
                                    if(energy>0)
                                        this.catEnergyField[k].edgeBarrierMap[y][x]=6
                                }
                                if(energy>0){
                                    this.catEnergyField[k].edgeIndexMap[y][x]=startid
                                    this.catEnergyField[k].edgeIndexMap2[y][x].push({start:startid,end:endid})
                                }

                            }
                            else{
                                this.catEnergyField[k].field[y][x]-=energy
                                this.catEnergyField[k].finalField[y][x]=0
                                this.catEnergyField[k].subUpdate[y][x] = 1
                                let delflag = false
                                if(this.catEnergyField[k].pointIndexMap[y][x] == -1 && this.catEnergyField[k].edgeIndexMap2[y][x].length == 1){
                                    if(this.catEnergyField[k].edgeIndexMap2[y][x][0].start == startid && this.catEnergyField[k].edgeIndexMap2[y][x][0].end == endid){
                                        delflag = true
                                    }
                                }
                                if(this.catEnergyField[k].field[y][x] <= 0.015 || delflag){
                                    this.catEnergyField[k].field[y][x]=0
                                    this.catEnergyField[k].edgeBarrierMap[y][x]=0
                                    this.catEnergyField[k].edgeIndexMap[y][x]=-1
                                    for(let it = this.catEnergyField[k].edgeIndexMap2[y][x].length - 1; it >= 0 ; it --){
                                        let s = this.catEnergyField[k].edgeIndexMap2[y][x][it].start
                                        let e = this.catEnergyField[k].edgeIndexMap2[y][x][it].end
                                        if(s==startid&&e==endid){
                                            this.catEnergyField[k].edgeIndexMap2[y][x].splice(it,1)
                                        }
                                    }
                                    this.catEnergyField[k].barrierMap[y][x]=0
                                }
                                //if(this.catEnergyField[k].pointIndexMap[y][x] != -1){
                                //    this.catEnergyField[k].barrierMap[y][x]=this.catEnergyField[k].pointBarrierMap[y][x]
                                //    this.catEnergyField[k].edgeBarrierMap[y][x]=0
                                //    this.catEnergyField[k].edgeIndexMap[y][x]=-1
                                //}
                            }

                        }

                        /*
                        let startpoint=this.pointData[startid]
                        let endpoint=this.pointData[endid]

                        if(startpoint.multicat&&endpoint.multicat){
                            let hasSameCat=false
                            let samecat=-1
                            for (let c1=0;c1<startpoint.catArray.length;c1++){
                                let cat1=startpoint.catArray[c1]
                                if(cat1!=k){
                                    for (let c2=0;c2<endpoint.catArray.length;c2++){
                                        let cat2=endpoint.catArray[c2]
                                        if(cat2!=k){
                                            if(cat2==cat1){
                                                hasSameCat=true
                                                samecat=cat1
                                                break
                                            }
                                        }
                                    }

                                }
                            }
                            if(hasSameCat&&parseInt(samecat)<parseInt(k)){
                                if(distancetoEdge<edgeR1+20+fixdis){
                                    let realx=x*pixelGroup+this.catEnergyField[k].x
                                    let realy=y*pixelGroup+this.catEnergyField[k].y

                                    let relativex=Math.floor((realx-this.catEnergyField[samecat].x)/pixelGroup)
                                    let relativey=Math.floor((realy-this.catEnergyField[samecat].y)/pixelGroup)
                                    let energy=edgeWeight*Math.pow(edgeR1-0,2)/Math.pow(edgeR1-edgeR0,2)
                                    // let energyscale=100

                                    if(relativex>0&&relativey>0&&relativex<this.catEnergyField[samecat].width&&relativey<this.catEnergyField[samecat].height){
                                        this.catEnergyField[samecat].field[relativey][relativex]+=energy
                                        this.catEnergyField[samecat].edgeIndexMap[relativey][relativex]=startpoint.id
                                    }
                                }
                            }
                        }
                        */

                        if(edges[i].flag == true){
                            if(distancetoEdge<=barrierGap+fixdis){
                                if(this.catEnergyField[k].barrierMap[y][x]!=4&&this.catEnergyField[k].barrierMap[y][x]!=3&&this.catEnergyField[k].barrierMap[y][x]!=1){
                                    this.catEnergyField[k].barrierMap[y][x]=2
                                }
                                if(this.catEnergyField[k].edgeBarrierMap[y][x]!=4&&this.catEnergyField[k].edgeBarrierMap[y][x]!=3&&this.catEnergyField[k].edgeBarrierMap[y][x]!=1){
                                    this.catEnergyField[k].edgeBarrierMap[y][x]=2
                                }
                            }

                            if(distancetoEdge<=2+fixdis){
                                //inside
                                this.catEnergyField[k].barrierMap[y][x]=4
                                this.catEnergyField[k].edgeBarrierMap[y][x]=4
                            }
                        }
                    }
                }
            }

        }
    }

    calEnergyField(){

        //TODO: edge and node use different barrier map

        for (var k in this.catPointDict){

            // group attrs
            this.catPointDict[k].pointMap=[]
            this.catEnergyField[k].pointBarrierMap=[]
            this.catEnergyField[k].edgeBarrierMap=[]
            this.catEnergyField[k].pointIndexMap=[]
            this.catEnergyField[k].edgeIndexMap=[]
            this.catEnergyField[k].edgeIndexMap2=[]
            this.catEnergyField[k].finalField = []
            this.catEnergyField[k].subUpdate = []

            for (let y=0;y<svgheight;y++){
                this.catEnergyField[k].subUpdate.push(new Array(svgwidth).fill(0))
                this.catEnergyField[k].finalField.push(new Array(svgwidth).fill(0))
                this.catEnergyField[k].pointBarrierMap.push(new Array(svgwidth).fill(0))
                this.catEnergyField[k].edgeBarrierMap.push(new Array(svgwidth).fill(0))
                this.catEnergyField[k].pointIndexMap.push(new Array(svgwidth).fill(-1))
                this.catEnergyField[k].edgeIndexMap.push(new Array(svgwidth).fill(-1))
                this.catEnergyField[k].edgeIndexMap2.push([])
                for(let x=0;x<svgwidth;x++){
                    this.catEnergyField[k].edgeIndexMap2[y].push([])
                }
            }

            //// not group attrs
            //this.catPointDict[k].gpointMap=[]
            //this.catEnergyField[k].gpointBarrierMap=[]
            //this.catEnergyField[k].gedgeBarrierMap=[]
            //this.catEnergyField[k].gpointIndexMap=[]
            //this.catEnergyField[k].gedgeIndexMap=[]
//
            //for(let y=0;y<this.catEnergyField[k].gheight;y++){
            //    this.catEnergyField[k].gpointBarrierMap.push(new Array(this.catEnergyField[k].gwidth).fill(0))
            //    this.catEnergyField[k].gedgeBarrierMap.push(new Array(this.catEnergyField[k].gwidth).fill(0))
            //    this.catEnergyField[k].gpointIndexMap.push(new Array(this.catEnergyField[k].gwidth).fill(-1))
            //    this.catEnergyField[k].gedgeIndexMap.push(new Array(this.catEnergyField[k].gwidth).fill(-1))
            //}


        }

        // cal bbox of edges
        // fix to cal at this.centralizeData()

        // cal the real active region
        //this.LabelGroupElement()

        for(var k in this.catPointDict){
            let members=this.catPointDict[k]
            // cal positive energy of nodes and barrier map
            for (let i=0;i<members.length;i++){
                let point=members[i]
                this.catPointDict[k].pointMap.push([])
                // cal influence area for pixel group
                let startx
                let endx
                let starty
                let endy
                startx=Math.floor((point.minX-nodeR1-10-this.catEnergyField[k].x) / pixelGroup);
                endx=Math.min(Math.ceil((point.maxX+nodeR1+10-this.catEnergyField[k].x) / pixelGroup),this.catEnergyField[k].width);
                starty=Math.floor((point.minY-nodeR1-10-this.catEnergyField[k].y) / pixelGroup);
                endy=Math.min(Math.ceil((point.maxY+nodeR1+10-this.catEnergyField[k].y) / pixelGroup),this.catEnergyField[k].height);
                for (let y=starty;y<endy;y++){
                    for (let x=startx;x<endx;x++){
                        let realx=x * pixelGroup + this.catEnergyField[k].x
                        let realy=y * pixelGroup + this.catEnergyField[k].y
                        let distance=this.calDistanceToItem(realx,realy,point)
                        if(distance<nodeR1+fixdis){
                            let energy=nodeWeight*Math.pow(nodeR1-distance,2)/Math.pow(nodeR1-nodeR0,2)
                            this.catEnergyField[k].field[y][x]+=energy
                            if(this.catEnergyField[k].barrierMap[y][x]==0){
                                this.catEnergyField[k].barrierMap[y][x]=5
                            }
                            if(this.catEnergyField[k].pointBarrierMap[y][x]==0){
                                this.catEnergyField[k].pointBarrierMap[y][x]=5
                            }
                            if(this.catEnergyField[k].pointIndexMap[y][x]==-1){
                                this.catEnergyField[k].pointIndexMap[y][x]=point.id
                            }
                        }
                        if(point.multicat){
                            let catarr=point.catArray
                            for (let c=0;c<catarr.length;c++){
                                if(catarr[c]!=k&&parseInt(catarr[c])<parseInt(k)){
                                    if(distance<nodeR1+10){
                                        let realx=x * pixelGroup + this.catEnergyField[k].x
                                        let realy=y * pixelGroup + this.catEnergyField[k].y

                                        let relativex=Math.floor((realx-this.catEnergyField[catarr[c]].x)/pixelGroup)
                                        let relativey=Math.floor((realy-this.catEnergyField[catarr[c]].y)/pixelGroup)
                                        let energy=nodeWeight*Math.pow(nodeR1-distance,2)/Math.pow(nodeR1-nodeR0,2)
                                        if(relativex>0&&relativey>0&&relativex<this.catEnergyField[catarr[c]].width&&relativey<this.catEnergyField[catarr[c]].height){
                                            // this.catEnergyField[catarr[c]].field[relativey][relativex]+=energy
                                        }
                                    }
                                }
                            }
                        }
                        if(distance<=barrierGap+fixdis){
                            if(this.catEnergyField[k].barrierMap[y][x]!=3){
                                this.catEnergyField[k].barrierMap[y][x]=1
                            }
                            if(this.catEnergyField[k].pointBarrierMap[y][x]!=3){
                                this.catEnergyField[k].pointBarrierMap[y][x]=1
                            }
                        }

                        if(distance<=fixdis){
                            //inside
                            this.catEnergyField[k].barrierMap[y][x]=3
                            this.catPointDict[k].pointMap[i].push([x,y])
                            this.catEnergyField[k].pointBarrierMap[y][x]=3
                            this.catEnergyField[k].pointIndexMap[y][x]=point.id
                        }

                    }
                }
            }
            // let EDGELENGTH_THRESH=(this.maxEdgeLength+this.minEdgeLength)/3
            let EDGELENGTH_THRESH=this.maxEdgeLength/2
            // let EDGELENGTH_THRESH=this.maxEdgeLength/1.5

            // cal positive value of edges
            if(this.catEdgeDict.hasOwnProperty(k)){
                let edges=this.catEdgeDict[k]
                for (let i=0;i<edges.length;i++){
                    // cal positive value for pixel group
                    let startx
                    let endx
                    let starty
                    let endy
                    let startid=edges[i].start
                    let endid=edges[i].end
                    startx=Math.floor((edges[i].x-edgeR1-10-this.catEnergyField[k].x)/pixelGroup)
                    endx=Math.min(Math.ceil((edges[i].x+edges[i].width+edgeR1+10-this.catEnergyField[k].x)/pixelGroup),this.catEnergyField[k].width)
                    starty=Math.floor((edges[i].y-edgeR1-10-this.catEnergyField[k].y)/pixelGroup)
                    endy=Math.min(Math.ceil((edges[i].y+edges[i].height+edgeR1+10-this.catEnergyField[k].y)/pixelGroup),this.catEnergyField[k].height)
                    for (let y=starty;y<endy;y++){
                        for (let x=startx;x<endx;x++){
                            let realx=x*pixelGroup+this.catEnergyField[k].x
                            let realy=y*pixelGroup+this.catEnergyField[k].y

                            let distance=this.calDistanceToEdge(realx,realy,edges[i])
                            let distancetoEdge=distance[0]
                            let distancetoNode=distance[1]
                            let totalDistance=distance[2]

                            if(distancetoNode<0){
                                continue
                            }

                            if(distancetoEdge<edgeR1+fixdis){
                                let newR1=edgeR1
                                // let factor=(edgeR1-2)/this.maxEdgeLength
                                let reducefactor=edgeR1/10
                                let factor=(edgeR1-2)/(reducefactor*totalDistance)

                                if(totalDistance>EDGELENGTH_THRESH){
                                    newR1=2*edgeR1/(1+factor*distancetoNode)


                                    // newR1=2*edgeR1/(1+factor*distancetoNode/4)

                                    // weight=1-Math.pow(factor,2)
                                    // let factor=2*(Math.exp(2)-1)/this.maxEdgeLength
                                    // weight=1/(Math.log(1+factor*distancetoNode)+2)

                                    // weight=weight*2
                                }
                                if(newR1>edgeR1){
                                    newR1=edgeR1
                                }

                                if(newR1>2*nodeR1){
                                    newR1=2*nodeR1
                                }
                                let energy
                                if(distancetoEdge>newR1){
                                    energy=0
                                }
                                else{
                                    energy=edgeWeight*Math.pow(newR1-distancetoEdge,2)/Math.pow(edgeR1-edgeR0,2)
                                }
                                this.catEnergyField[k].field[y][x]+=energy

                                if(this.catEnergyField[k].barrierMap[y][x]==0||this.catEnergyField[k].barrierMap[y][x]==5){
                                    if(energy>0)
                                        this.catEnergyField[k].barrierMap[y][x]=6
                                }

                                if(this.catEnergyField[k].edgeBarrierMap[y][x]==0||this.catEnergyField[k].edgeBarrierMap[y][x]==5) {
                                    if(energy>0)
                                        this.catEnergyField[k].edgeBarrierMap[y][x]=6
                                }

                                if(energy>0){
                                    this.catEnergyField[k].edgeIndexMap[y][x]=startid
                                    this.catEnergyField[k].edgeIndexMap2[y][x].push({start:startid,end:endid})
                                }


                            }

                            let startpoint=this.pointData[startid]
                            let endpoint=this.pointData[endid]

                            if(startpoint.multicat&&endpoint.multicat){
                                let hasSameCat=false
                                let samecat=-1
                                for (let c1=0;c1<startpoint.catArray.length;c1++){
                                    let cat1=startpoint.catArray[c1]
                                    if(cat1!=k){
                                        for (let c2=0;c2<endpoint.catArray.length;c2++){
                                            let cat2=endpoint.catArray[c2]
                                            if(cat2!=k){
                                                if(cat2==cat1){
                                                    hasSameCat=true
                                                    samecat=cat1
                                                    break
                                                }
                                            }
                                        }

                                    }
                                }
                                if(hasSameCat&&parseInt(samecat)<parseInt(k)){
                                    if(distancetoEdge<edgeR1+20+fixdis){
                                        let realx=x*pixelGroup+this.catEnergyField[k].x
                                        let realy=y*pixelGroup+this.catEnergyField[k].y

                                        let relativex=Math.floor((realx-this.catEnergyField[samecat].x)/pixelGroup)
                                        let relativey=Math.floor((realy-this.catEnergyField[samecat].y)/pixelGroup)
                                        let energy=edgeWeight*Math.pow(edgeR1-0,2)/Math.pow(edgeR1-edgeR0,2)
                                        // let energyscale=100

                                        if(relativex>0&&relativey>0&&relativex<this.catEnergyField[samecat].width&&relativey<this.catEnergyField[samecat].height){
                                            this.catEnergyField[samecat].field[relativey][relativex]+=energy
                                            this.catEnergyField[samecat].edgeIndexMap[relativey][relativex]=startpoint.id
                                            this.catEnergyField[samecat].edgeIndexMap2[relativey][relativex].push({start:startpoint.id, end:endpoint.id})
                                        }
                                    }
                                }
                            }

                            if(distancetoEdge<=barrierGap+fixdis){
                                if(this.catEnergyField[k].barrierMap[y][x]!=4&&this.catEnergyField[k].barrierMap[y][x]!=3&&this.catEnergyField[k].barrierMap[y][x]!=1){
                                    this.catEnergyField[k].barrierMap[y][x]=2
                                }
                                if(this.catEnergyField[k].edgeBarrierMap[y][x]!=4&&this.catEnergyField[k].edgeBarrierMap[y][x]!=3&&this.catEnergyField[k].edgeBarrierMap[y][x]!=1){
                                    this.catEnergyField[k].edgeBarrierMap[y][x]=2
                                }
                            }

                            if(distancetoEdge<=2+fixdis){
                                //inside
                                this.catEnergyField[k].barrierMap[y][x]=4
                                this.catEnergyField[k].edgeBarrierMap[y][x]=4
                            }

                        }
                    }
                }
            }

        }
    }

    checkEdgeCrossing(a, b, c, d){

        // 三角形abc 面积的2倍
        var area_abc = (a.x - c.x) * (b.y - c.y) - (a.y - c.y) * (b.x - c.x);

        // 三角形abd 面积的2倍
        var area_abd = (a.x - d.x) * (b.y - d.y) - (a.y - d.y) * (b.x - d.x);

        // 面积符号相同则两点在线段同侧,不相交 (对点在线段上的情况,本例当作不相交处理);
        if ( area_abc*area_abd>=0 ) {
            return [false];
        }

        // 三角形cda 面积的2倍
        var area_cda = (c.x - a.x) * (d.y - a.y) - (c.y - a.y) * (d.x - a.x);
        // 三角形cdb 面积的2倍
        // 注意: 这里有一个小优化.不需要再用公式计算面积,而是通过已知的三个面积加减得出.
        var area_cdb = area_cda + area_abc - area_abd ;
        if (  area_cda * area_cdb >= 0 ) {
            return [false];
        }

        //计算交点坐标
        var t = area_cda / ( area_abd- area_abc );
        var dx= t*(b.x - a.x),
            dy= t*(b.y - a.y);
        return[true, { x: a.x + dx , y: a.y + dy }];

    }

    createGapInBoundary(){
        let gap=this.state.gapBetween
        if(gap==0)
            return
        for (var k in this.catEnergyField){
            let field=this.catEnergyField[k].finalField
            let deletePoints=[]
            let startY = parseInt((this.catEnergyField[k].boundingY - this.catEnergyField[k].y)/pixelGroup)
            let startX = parseInt((this.catEnergyField[k].boundingX - this.catEnergyField[k].x)/pixelGroup)
            let endY = parseInt((this.catEnergyField[k].boundingHeight * pixelGroup + this.catEnergyField[k].boundingY - this.catEnergyField[k].y)/pixelGroup)
            let endX = parseInt((this.catEnergyField[k].boundingWidth * pixelGroup + this.catEnergyField[k].boundingX - this.catEnergyField[k].x)/pixelGroup)
            for(let y=startY;y<endY;y++){
                for(let x=startX;x<endX;x++){
                    if(field[y][x]==0){
                        continue
                    }

                    if(this.catEnergyField[k].barrierMap[y][x]==4)
                        continue

                    //check if it is the boundary
                    let isboundary=false
                    for (let i=0;i<gap;i++){
                        let delta=i+1
                        //right
                        if(x+delta<this.catEnergyField[k].width){
                            if(field[y][x+delta]==0){
                                isboundary=true
                                break
                            }
                        }
                        //left
                        if(x-delta>0){
                            if(field[y][x-delta]==0){
                                isboundary=true
                                break
                            }
                        }
                        //up
                        if(y-delta>0){
                            if(field[y-delta][x]==0){
                                isboundary=true
                                break
                            }
                        }
                        //down
                        if(y+delta<this.catEnergyField[k].height){
                            if(field[y+delta][x]==0){
                                isboundary=true
                                break
                            }
                        }
                        //right-top
                        if(x+delta<this.catEnergyField[k].width&&y-delta>0){
                            if(field[y-delta][x+delta]==0){
                                isboundary=true
                                break
                            }
                        }
                        //right-bottom
                        if(x+delta<this.catEnergyField[k].width&&y+delta<this.catEnergyField[k].height){
                            if(field[y+delta][x+delta]==0){
                                isboundary=true
                                break
                            }
                        }
                        //left-top
                        if(x-delta>0&&y-delta>0){
                            if(field[y-delta][x-delta]==0){
                                isboundary=true
                                break
                            }
                        }
                        //left-bottom
                        if(x-delta>0&&y+delta<this.catEnergyField[k].height){
                            if(field[y+delta][x-delta]==0){
                                isboundary=true
                                break
                            }
                        }

                    }

                    if(isboundary){
                        // this.catEnergyField[k].finalField[y][x]=0
                        deletePoints.push([x,y])
                    }

                }
            }

            for (let i=0;i<deletePoints.length;i++){
                let x=deletePoints[i][0]
                let y=deletePoints[i][1]
                this.catEnergyField[k].finalField[y][x]=0
            }
        }

    }

    removeEmptyZone(isoDict){

        // for (var k in this.catEnergyField){
        //     for (let y=0;y<this.catEnergyField[k].height;y++){
        //         for (let x=0;x<this.catEnergyField[k].width;x++){
        //             if(this.catEnergyField[k].barrierMap[y][x]==3||this.catEnergyField[k].barrierMap[y][x]==1||this.catEnergyField[k].barrierMap[y][x]==2||this.catEnergyField[k].barrierMap[y][x]==4){
        //                 this.catEnergyField[k].finalField[y][x]=0
        //             }
        //         }
        //     }
        // }

        for (var k in isoDict){
            let isolines=isoDict[k]
            let isolinepoints=[]
            let finalField=this.catEnergyField[k].finalField
            this.catEnergyField[k].isoLineMap=[]

            for (let i=0;i<isolines.length;i++){
                let relativepoints=[]
                for (let p=0;p<isolines[i].length;p++){
                    relativepoints.push({x:isolines[i][p][0], y:isolines[i][p][1]})
                }
                isolinepoints.push(relativepoints)
            }

            let isoInsidePoints=[]
            for (let i=0;i<isolinepoints.length;i++){
                isoInsidePoints.push([])
            }

            for (let y=0;y<this.catEnergyField[k].height;y++){
                this.catEnergyField[k].isoLineMap.push([])
                for (let x=0;x<this.catEnergyField[k].width;x++){
                    this.catEnergyField[k].isoLineMap[y].push(-1)

                    if(finalField[y][x]>0){
                        for (let i=0;i<isolinepoints.length;i++){
                            //check if it is inside the isoline
                            let intersect=IntersectionQuery.pointInPolygon({x:x,y:y},isolinepoints[i])
                            if(intersect){
                                isoInsidePoints[i].push([x,y])
                                this.catEnergyField[k].isoLineMap[y][x]=i
                                break
                            }
                        }

                    }

                }
            }

            let notDeleteIndex=[]
            for (let i=0;i<this.catPointDict[k].pointMap.length;i++){
                let nodePoints=this.catPointDict[k].pointMap[i]
                let totalInside=true
                let isolineIndex=-1

                // if(k=="5"&&i==0){
                //     console.log()
                // }

                for (let n=0;n<nodePoints.length;n++){
                    let x=nodePoints[n][0]
                    let y=nodePoints[n][1]
                    if(n==0){
                        if(this.catEnergyField[k].isoLineMap[y][x]>-1){
                            isolineIndex=this.catEnergyField[k].isoLineMap[y][x]
                        }
                    }
                    if(this.catEnergyField[k].isoLineMap[y][x]==-1||this.catEnergyField[k].isoLineMap[y][x]!=isolineIndex){
                        totalInside=false
                        break
                    }

                }

                if(totalInside){
                    notDeleteIndex.push(isolineIndex)
                }

            }

            let deleteindex=[]

            for(let i=0;i<isoInsidePoints.length;i++){
                let isdelete=true
                for (let j=0;j<notDeleteIndex.length;j++){
                    if(i==notDeleteIndex[j]){
                        isdelete=false
                        break
                    }
                }
                if(isdelete){
                    deleteindex.push(i)
                }
            }


            for (let i=0;i<deleteindex.length;i++){
                let index=deleteindex[i]
                let deletePoints=isoInsidePoints[index]

                for(let p=0;p<deletePoints.length;p++){
                    let x=deletePoints[p][0]
                    let y=deletePoints[p][1]
                    this.catEnergyField[k].finalField[y][x]=0
                }
            }

            let newisolines=[]
            for (let i=0;i<isolines.length;i++){
                let isdelete=false
                for (let j=0;j<deleteindex.length;j++){
                    if(i==deleteindex[j]){
                        isdelete=true
                        break
                    }

                }
                if(!isdelete){
                    newisolines.push(isolines[i])
                }

            }

            isoDict[k]=newisolines
        }
        return isoDict
    }

    isSameCat(catarr1,catarr2){
        for(let i=0;i<catarr1.length;i++){
            let cat1=catarr1[i]
            for (let j=0;j<catarr2.length;j++){
                let cat2=catarr2[j]
                if(cat1==cat2){
                    return true
                }
            }
        }
        return false
    }

    isContained(catarr,cat){
        for(let i=0;i<catarr.length;i++){
            if(catarr[i]==cat){
                return true
            }
        }
        return false
    }

    calFinalEnergeFieldForOverlap(){
        //let multiCatDict=[]
        //for(let i=0;i<this.pointData.length;i++){
        //    if(this.pointData[i].multicat){
        //        let catarr=this.pointData[i].catArray
        //        multiCatDict.push(catarr)
        //    }
        //}

        for (var k in this.catEnergyField){
            //this.catEnergyField[k].finalField = this.catEnergyField[k].field
            for(let y in this.catNotGroup[k]){
                //this.catEnergyField[k].finalField.push(new Array(this.catEnergyField[k].width).fill(0))
                for(let x in this.catNotGroup[k][y]){
                    y = parseInt(y);
                    x = parseInt(x);
                    let px = Math.ceil(x/pixelGroup)
                    let py = Math.ceil(y/pixelGroup)
                    let realx=x+this.catEnergyField[k].x
                    let realy=y+this.catEnergyField[k].y
                    let value=this.catEnergyField[k].gfield[y][x]

                    // let aim=false
                    // if(Math.floor(realx)==601&&Math.floor(realy)==519){
                    //     console.log(k,value,realx,realy,x,y)
                    //     aim=true
                    // }

                    let finalvalue=value
                    let isInside=false

                    let thisPointID=this.catEnergyField[k].gpointIndexMap[y][x]
                    let thisEdgeID=this.catEnergyField[k].gedgeIndexMap[y][x]

                    let thiscat

                    if(thisEdgeID==-1&&thisPointID==-1){
                        continue
                    }

                    if(thisEdgeID>-1){
                        if(this.pointData[thisEdgeID].multicat){
                            thiscat=this.pointData[thisEdgeID].catArray
                        }
                        else{
                            thiscat=[this.pointData[thisEdgeID].cat]
                        }
                    }

                    if(thisPointID>-1){
                        if(this.pointData[thisPointID].multicat){
                            thiscat=this.pointData[thisPointID].catArray
                        }
                        else{
                            thiscat=[this.pointData[thisPointID].cat]
                        }
                    }



                    // if(this.catEnergyField[k].barrierMap[y][x]>0 && this.catEnergyField[k].barrierMap[y][x]!=5&& this.catEnergyField[k].barrierMap[y][x]!=6){
                    // if(this.catEnergyField[k].barrierMap[y][x]==1||this.catEnergyField[k].barrierMap[y][x]==2||this.catEnergyField[k].barrierMap[y][x]==3||this.catEnergyField[k].barrierMap[y][x]==4){
                    if(this.catEnergyField[k].gbarrierMap[y][x]==3||this.catEnergyField[k].gbarrierMap[y][x]==4){
                        isInside=true
                    }

                    if(isInside&&this.catEnergyField[k].gfield[y][x]==0){
                        // drawRect(realx,realy,1,1,"red")
                        value=1
                        this.catEnergyField[k].gfield[y][x]=1
                        this.catEnergyField[k].field[py][px]=1
                    }


                    /*                    if (!isInside&&value==0){
                                            continue
                                        }*/

                    if (value==0){
                        continue
                    }
                    for (var k2 in this.catEnergyField){
                        if(k2==k)
                            continue

                        // let isContain=false
                        //
                        // for (let i=0;i<this.catPointDict[k2].length;i++){
                        //     if(this.catPointDict[k2][i].multicat){
                        //         let catarr=this.catPointDict[k2][i].catArray
                        //         for (let c=0;c<catarr.length;c++){
                        //             if(catarr[c]==k){
                        //                 isContain=true
                        //                 break
                        //             }
                        //         }
                        //         if(isContain){
                        //             break
                        //         }
                        //     }
                        // }
                        // if(isContain){
                        //     continue
                        // }

                        if(k2!=k){
                            if(realx<this.catEnergyField[k2].x+this.catEnergyField[k2].gwidth&&realx>this.catEnergyField[k2].x&&realy<this.catEnergyField[k2].y+this.catEnergyField[k2].gheight&&realy>this.catEnergyField[k2].y){
                                let relativex=Math.floor((realx-this.catEnergyField[k2].x))
                                let relativey=Math.floor((realy-this.catEnergyField[k2].y))

                                let othervalue=this.catEnergyField[k2].gfield[relativey][relativex]
                                let otherinside=false
                                let otherPointID=this.catEnergyField[k2].gpointIndexMap[relativey][relativex]
                                let otherEdgeID=this.catEnergyField[k2].gedgeIndexMap[relativey][relativex]
                                let othercat

                                if(otherPointID==-1&&otherEdgeID==-1){
                                    continue
                                }
                                if(otherEdgeID>-1){
                                    if(this.pointData[otherEdgeID].multicat){
                                        othercat=this.pointData[otherEdgeID].catArray
                                    }
                                    else{
                                        othercat=[this.pointData[otherEdgeID].cat]
                                    }
                                }
                                if(otherPointID>-1){
                                    if(this.pointData[otherPointID].multicat){
                                        othercat=this.pointData[otherPointID].catArray
                                    }
                                    else{
                                        othercat=[this.pointData[otherPointID].cat]
                                    }
                                }


                                // if(aim){
                                //     console.log()
                                // }

                                // if(k=="11"&&k2=="0"){
                                //         drawRect(realx,realy,1,1,"red")
                                //     console.log()
                                // }

                                if(this.isContained(othercat,k)){
                                    //contained cat to main cat
                                    //     drawRect(realx,realy,1,1,"red")
                                    // if(k=="11"&&k2=="0"){
                                    //     drawRect(realx,realy,1,1,"red")
                                    // }
                                    continue
                                }

                                if(this.isContained(thiscat,k2)&&this.catEnergyField[k2].gpointBarrierMap[relativey][relativex]!=3){
                                    //contained cat to main cat
                                    //     drawRect(realx,realy,1,1,"red")

                                    continue

                                }


                                if(this.catEnergyField[k2].gbarrierMap[relativey][relativex]==3 ||this.catEnergyField[k2].gbarrierMap[relativey][relativex]==4){
                                    // if(this.catEnergyField[k2].barrierMap[relativey][relativex]==1 ||this.catEnergyField[k2].barrierMap[relativey][relativex]==2||this.catEnergyField[k2].barrierMap[relativey][relativex]==3 ||this.catEnergyField[k2].barrierMap[relativey][relativex]==4){

                                    otherinside=true
                                }



                                /*                                    if (!otherinside&&othervalue==0){
                                                                        // drawRect(realx,realy,1,1,"black")
                                                                        continue
                                                                    }*/

                                if (othervalue==0){
                                    // drawRect(realx,realy,1,1,"black")

                                    continue
                                }

                                // drawRect(realx,realy,1,1,"blue")
                                if(!isInside&&!otherinside){
                                    if(othervalue>value){
                                        finalvalue=0
                                        // drawRect(realx,realy,1,1,"blue")

                                        break
                                    }
                                    else{
                                        finalvalue=value
                                    }
                                    // finalvalue=0

                                }
                                else if(isInside&&!otherinside){
                                    // drawRect(realx,realy,1,1,"yellow")

                                    //pass

                                    finalvalue=value
                                }
                                else if(!isInside&&otherinside){
                                    // drawRect(realx,realy,1,1,"orange")

                                    finalvalue=0
                                    break
                                }
                                else if(isInside&&otherinside){

                                    // if(this.catEnergyField[k].barrierMap[y][x]==3||this.catEnergyField[k].barrierMap[y][x]==4){
                                    if(this.catEnergyField[k].gbarrierMap[y][x]==4){

                                        finalvalue=value
                                    }
                                    else{
                                        finalvalue=0
                                    }
                                    // finalvalue=0


                                }

                                // if(this.catEnergyField[k2].barrierMap[relativey][relativex]==4){
                                //     finalvalue=0
                                // }
                            }
                        }
                    }

                    this.catEnergyField[k].finalField[py][px]=finalvalue
                    if(this.catEnergyField[k].barrierMap[py][px]==4){
                        this.catEnergyField[k].finalField[py][px]=10000
                    }
                }
            }
        }
    }

    updateEnergyPoints(){
        //update final energyfield according to this.updatedEnergyPoints
        for (var k in this.updatedEnergyPoints){
            for (let p=0;p<this.updatedEnergyPoints[k].length;p++){
                let x=this.updatedEnergyPoints[k][p][0]
                let y=this.updatedEnergyPoints[k][p][1]
                let realx=x*pixelGroup+this.catEnergyField[k].x
                let realy=y*pixelGroup+this.catEnergyField[k].y
                let value=this.catEnergyField[k].field[y][x]
                // drawRect(realx,realy,2,2,"red")

                let finalvalue=value
                let isInside=false

                if(value == 0){
                    continue;
                }

               if(this.catEnergyField[k].barrierMap[y][x]==3||this.catEnergyField[k].barrierMap[y][x]==4){
                    isInside=true
                }

                if(isInside&&this.catEnergyField[k].field[y][x]==0){
                    value=1
                    this.catEnergyField[k].field[y][x]=1
                }

                if (value==0){
                    // drawRect(realx,realy,1,1,"black")
                    continue
                }

                for (var k2 in this.catEnergyField){
                    if(k2==k)
                        continue

                    if(k2!=k){
                        if(realx<this.catEnergyField[k2].boundingX+this.catEnergyField[k2].boundingWidth*pixelGroup&&realx>this.catEnergyField[k2].boundingX&&realy<this.catEnergyField[k2].boundingY+this.catEnergyField[k2].boundingHeight*pixelGroup&&realy>this.catEnergyField[k2].boundingY){
                            let relativex=Math.floor((realx-this.catEnergyField[k2].x)/pixelGroup)
                            let relativey=Math.floor((realy-this.catEnergyField[k2].y)/pixelGroup)

                            let othervalue=this.catEnergyField[k2].field[relativey][relativex]
                            let otherinside=false

                            // if(this.catEnergyField[k2].barrierMap[relativey][relativex]==3 ){

                                if(this.catEnergyField[k2].pointBarrierMap[relativey][relativex]==1|| this.catEnergyField[k2].pointBarrierMap[relativey][relativex]==3){
                                    // drawRect(realx,realy,1,1,"black")
                                // if(this.catEnergyField[k2].barrierMap[relativey][relativex]==3 ||this.catEnergyField[k2].barrierMap[relativey][relativex]==4){
                                // if(this.catEnergyField[k2].barrierMap[relativey][relativex]==1 ||this.catEnergyField[k2].barrierMap[relativey][relativex]==2||this.catEnergyField[k2].barrierMap[relativey][relativex]==3 ||this.catEnergyField[k2].barrierMap[relativey][relativex]==4){

                                otherinside=true
                            }


                            if (othervalue==0){
                                // drawRect(realx,realy,1,1,"black")
                                continue
                            }

                            // drawRect(realx,realy,2,2,"red")

                            // drawRect(realx,realy,1,1,"blue")
                            if(!isInside&&!otherinside){

                                if(othervalue>value){
                                    finalvalue=0
                                    // drawRect(realx,realy,2,2,"red")
                                    // drawRect(realx,realy,1,1,"blue")

                                    break
                                }
                                else{
                                    finalvalue=value
                                }
                                // finalvalue=0
                                // finalvalue=value

                            }
                            else if(isInside&&!otherinside){
                                // drawRect(realx,realy,1,1,"yellow")

                                //pass

                                finalvalue=value
                            }
                            else if(!isInside&&otherinside){
                                // drawRect(realx,realy,2,2,"black")
                                // drawRect(realx,realy,1,1,"orange")
                                finalvalue=0
                                break
                            }
                            else if(isInside&&otherinside){

                                // if(this.catEnergyField[k].barrierMap[y][x]==3||this.catEnergyField[k].barrierMap[y][x]==4){
                                if(this.catEnergyField[k].barrierMap[y][x]==4){

                                    finalvalue=value
                                }
                                else{
                                    finalvalue=0
                                }
                                // finalvalue=0


                            }

                            // if(this.catEnergyField[k2].barrierMap[relativey][relativex]==4){
                            //     finalvalue=0
                            // }

                        }
                    }
                }

                this.catEnergyField[k].finalField[y][x]=finalvalue
                //if(this.catEnergyField[k].barrierMap[y][x]==4){
                //    this.catEnergyField[k].finalField[y][x]=10000
                //}
            }

        }
    }

    calFinalEnergeField_Part(){

        this.updateIdx = new Set(this.updateIdx)
        //console.log("calFinalEnergeField_Part:")
        //console.log(this.updateIdx)
        for (var k in this.catEnergyField){
            //this.catEnergyField[k].finalField = clone(this.catEnergyField[k].field)
            for(let updateidx of this.updateIdx){


                    let realx=parseInt(updateidx[1])
                    let realy=parseInt(updateidx[0])


                    //console.log("(" + realx + ", " + realy + ")")

                    let x = parseInt((realx - this.catEnergyField[k].x) / pixelGroup)
                    let y = parseInt((realy - this.catEnergyField[k].y) / pixelGroup)

                    x = Math.min(x, this.catEnergyField[k].width - 1)
                    y = Math.min(y, this.catEnergyField[k].height - 1)
                    x = Math.max(x, 0)
                    y = Math.max(y, 0)

                    //d3.select('g').append('circle')
                    //    .attr('id','final')
                    //    .attr('cx',realx)
                    //    .attr('cy',realy)
                    //    .attr('r',1)
                    //    .attr('fill','red')

                    //console.log("(" + this.catEnergyField[k].width + ", " + this.catEnergyField[k].height + ")")
                    let value=this.catEnergyField[k].field[y][x]

                    //if(value == 0){
                    //    continue
                    //}

                    let finalvalue=value
                    let isInside=false

                    let thisPointID=this.catEnergyField[k].pointIndexMap[y][x]
                    let thisEdgeID=this.catEnergyField[k].edgeIndexMap[y][x]

                    let thiscat

                    if(thisEdgeID==-1&&thisPointID==-1){
                        continue
                    }

                    if(thisEdgeID>-1){
                        if(this.pointData[thisEdgeID].multicat){
                            thiscat=this.pointData[thisEdgeID].catArray
                        }
                        else{
                            thiscat=[this.pointData[thisEdgeID].cat]
                        }
                    }

                    if(thisPointID>-1){
                        if(this.pointData[thisPointID].multicat){
                            thiscat=this.pointData[thisPointID].catArray
                        }
                        else{
                            thiscat=[this.pointData[thisPointID].cat]
                        }
                    }



                    // if(this.catEnergyField[k].barrierMap[y][x]>0 && this.catEnergyField[k].barrierMap[y][x]!=5&& this.catEnergyField[k].barrierMap[y][x]!=6){
                    // if(this.catEnergyField[k].barrierMap[y][x]==1||this.catEnergyField[k].barrierMap[y][x]==2||this.catEnergyField[k].barrierMap[y][x]==3||this.catEnergyField[k].barrierMap[y][x]==4){
                    if(this.catEnergyField[k].barrierMap[y][x]==3||this.catEnergyField[k].barrierMap[y][x]==4){
                        isInside=true
                    }

                    if(isInside && this.catEnergyField[k].field[y][x] <= 0.015 && this.catEnergyField[k].subUpdate[y][x] != 1){
                        value=1
                        this.catEnergyField[k].edgeIndexMap[y][x] = this.edges[thisEdgeID].start
                        this.catEnergyField[k].edgeIndexMap2[y][x].push({start:this.edges[thisEdgeID].start,end:this.edges[thisEdgeID].end})
                        this.catEnergyField[k].field[y][x]=1
                    }

                    if (value==0){
                        continue
                    }

                    for (var k2 in this.catEnergyField){
                        if(k2==k)
                            continue

                        // let isContain=false
                        //
                        // for (let i=0;i<this.catPointDict[k2].length;i++){
                        //     if(this.catPointDict[k2][i].multicat){
                        //         let catarr=this.catPointDict[k2][i].catArray
                        //         for (let c=0;c<catarr.length;c++){
                        //             if(catarr[c]==k){
                        //                 isContain=true
                        //                 break
                        //             }
                        //         }
                        //         if(isContain){
                        //             break
                        //         }
                        //     }
                        // }
                        // if(isContain){
                        //     continue
                        // }

                        if(k2!=k){
                            if(realx<this.catEnergyField[k2].boundingX+this.catEnergyField[k2].boundingWidth*pixelGroup&&realx>this.catEnergyField[k2].boundingX&&realy<this.catEnergyField[k2].boundingY+this.catEnergyField[k2].boundingHeight*pixelGroup&&realy>this.catEnergyField[k2].boundingY){
                                let relativex=Math.floor((realx-this.catEnergyField[k2].x)/pixelGroup)
                                let relativey=Math.floor((realy-this.catEnergyField[k2].y)/pixelGroup)

                                let othervalue=this.catEnergyField[k2].field[relativey][relativex]
                                let otherinside=false
                                let otherPointID=this.catEnergyField[k2].pointIndexMap[relativey][relativex]
                                let otherEdgeID=this.catEnergyField[k2].edgeIndexMap[relativey][relativex]
                                let othercat

                                if(otherPointID==-1&&otherEdgeID==-1){
                                    continue
                                }

                                if(otherEdgeID>-1){
                                    if(this.pointData[otherEdgeID].multicat){
                                        othercat=this.pointData[otherEdgeID].catArray
                                    }
                                    else{
                                        othercat=[this.pointData[otherEdgeID].cat]
                                    }
                                }

                                if(otherPointID>-1){
                                    if(this.pointData[otherPointID].multicat){
                                        othercat=this.pointData[otherPointID].catArray
                                    }
                                    else{
                                        othercat=[this.pointData[otherPointID].cat]
                                    }
                                }


                                // if(aim){
                                //     console.log()
                                // }

                                // if(k=="11"&&k2=="0"){
                                //         drawRect(realx,realy,1,1,"red")
                                //     console.log()
                                // }

                                if(this.isContained(othercat,k)){
                                    //contained cat to main cat
                                    //     drawRect(realx,realy,1,1,"red")
                                    // if(k=="11"&&k2=="0"){
                                    //     drawRect(realx,realy,1,1,"red")
                                    // }
                                    continue
                                }

                                if(this.isContained(thiscat,k2)&&this.catEnergyField[k2].pointBarrierMap[relativey][relativex]!=3){
                                    //contained cat to main cat
                                    //     drawRect(realx,realy,1,1,"red")

                                    continue

                                }


                                if(this.catEnergyField[k2].barrierMap[relativey][relativex]==3 ||this.catEnergyField[k2].barrierMap[relativey][relativex]==4){
                                    // if(this.catEnergyField[k2].barrierMap[relativey][relativex]==1 ||this.catEnergyField[k2].barrierMap[relativey][relativex]==2||this.catEnergyField[k2].barrierMap[relativey][relativex]==3 ||this.catEnergyField[k2].barrierMap[relativey][relativex]==4){

                                    otherinside=true
                                }



                                /*                                    if (!otherinside&&othervalue==0){
                                                                        // drawRect(realx,realy,1,1,"black")
                                                                        continue
                                                                    }*/

                                if (othervalue==0){
                                    // drawRect(realx,realy,1,1,"black")

                                    continue
                                }

                                // drawRect(realx,realy,1,1,"blue")
                                if(!isInside&&!otherinside){
                                    if(othervalue>value){
                                        finalvalue=0
                                        // drawRect(realx,realy,1,1,"blue")

                                        break
                                    }
                                    else{
                                        finalvalue=value
                                    }
                                    // finalvalue=0

                                }
                                else if(isInside&&!otherinside){
                                    // drawRect(realx,realy,1,1,"yellow")

                                    //pass

                                    finalvalue=value
                                }
                                else if(!isInside&&otherinside){
                                    // drawRect(realx,realy,1,1,"orange")

                                    finalvalue=0
                                    break
                                }
                                else if(isInside&&otherinside){

                                    // if(this.catEnergyField[k].barrierMap[y][x]==3||this.catEnergyField[k].barrierMap[y][x]==4){
                                    if(this.catEnergyField[k].barrierMap[y][x]==4){

                                        finalvalue=value
                                    }
                                    else{
                                        finalvalue=0
                                    }
                                    // finalvalue=0


                                }

                                // if(this.catEnergyField[k2].barrierMap[relativey][relativex]==4){
                                //     finalvalue=0
                                // }

                            }
                        }
                    }

                    this.catEnergyField[k].finalField[y][x]=finalvalue
                    if(this.catEnergyField[k].barrierMap[y][x]==4 && this.catEnergyField[k].subUpdate[y][x] != 1){
                        this.catEnergyField[k].finalField[y][x]=10000
                    }
                }
        }

    }

    calFinalEnergeField(){

        //let multiCatDict=[]
        //for(let i=0;i<this.pointData.length;i++){
        //    if(this.pointData[i].multicat){
        //        let catarr=this.pointData[i].catArray
        //        multiCatDict.push(catarr)
        //    }
        //}
        for (var k in this.catEnergyField){
            let startY = parseInt((this.catEnergyField[k].boundingY - this.catEnergyField[k].y)/pixelGroup)
            let startX = parseInt((this.catEnergyField[k].boundingX - this.catEnergyField[k].x)/pixelGroup)
            let endY = parseInt((this.catEnergyField[k].boundingHeight * pixelGroup + this.catEnergyField[k].boundingY - this.catEnergyField[k].y)/pixelGroup)
            let endX = parseInt((this.catEnergyField[k].boundingWidth * pixelGroup + this.catEnergyField[k].boundingX - this.catEnergyField[k].x)/pixelGroup)
            for(let y=startY;y<endY;y++){
                for(let x=startX;x<endX;x++){
                    let realx=x*pixelGroup+this.catEnergyField[k].x
                    let realy=y*pixelGroup+this.catEnergyField[k].y
                    let value=this.catEnergyField[k].field[y][x]

                    // let aim=false
                    // if(Math.floor(realx)==601&&Math.floor(realy)==519){
                    //     console.log(k,value,realx,realy,x,y)
                    //     aim=true
                    // }

                    let finalvalue=value
                    let isInside=false

                    let thisPointID=this.catEnergyField[k].pointIndexMap[y][x]
                    let thisEdgeID=this.catEnergyField[k].edgeIndexMap[y][x]

                    let thiscat

                    if(thisEdgeID==-1&&thisPointID==-1){
                        continue
                    }

                    if(thisEdgeID>-1){
                        if(this.pointData[thisEdgeID].multicat){
                            thiscat=this.pointData[thisEdgeID].catArray
                        }
                        else{
                            thiscat=[this.pointData[thisEdgeID].cat]
                        }
                    }

                    if(thisPointID>-1){
                        if(this.pointData[thisPointID].multicat){
                            thiscat=this.pointData[thisPointID].catArray
                        }
                        else{
                            thiscat=[this.pointData[thisPointID].cat]
                        }
                    }



                    // if(this.catEnergyField[k].barrierMap[y][x]>0 && this.catEnergyField[k].barrierMap[y][x]!=5&& this.catEnergyField[k].barrierMap[y][x]!=6){
                    // if(this.catEnergyField[k].barrierMap[y][x]==1||this.catEnergyField[k].barrierMap[y][x]==2||this.catEnergyField[k].barrierMap[y][x]==3||this.catEnergyField[k].barrierMap[y][x]==4){
                    if(this.catEnergyField[k].barrierMap[y][x]==3||this.catEnergyField[k].barrierMap[y][x]==4){
                        isInside=true
                    }

                    if(isInside&&this.catEnergyField[k].field[y][x]==0){
                        this.catEnergyField[k].edgeIndexMap[y][x] = this.edges[thisEdgeID].start
                        this.catEnergyField[k].edgeIndexMap2[y][x].push({start:this.edges[thisEdgeID].start,end:this.edges[thisEdgeID].end})
                        value=1
                        this.catEnergyField[k].field[y][x]=1
                    }

                    if (value==0){
                        continue
                    }

                    for (var k2 in this.catEnergyField){
                        if(k2==k)
                            continue

                        // let isContain=false
                        //
                        // for (let i=0;i<this.catPointDict[k2].length;i++){
                        //     if(this.catPointDict[k2][i].multicat){
                        //         let catarr=this.catPointDict[k2][i].catArray
                        //         for (let c=0;c<catarr.length;c++){
                        //             if(catarr[c]==k){
                        //                 isContain=true
                        //                 break
                        //             }
                        //         }
                        //         if(isContain){
                        //             break
                        //         }
                        //     }
                        // }
                        // if(isContain){
                        //     continue
                        // }

                        if(k2!=k){
                            if(realx<=this.catEnergyField[k2].boundingX+this.catEnergyField[k2].boundingWidth*pixelGroup&&realx>=this.catEnergyField[k2].boundingX&&realy<=this.catEnergyField[k2].boundingY+this.catEnergyField[k2].boundingHeight*pixelGroup&&realy>=this.catEnergyField[k2].boundingY){
                                let relativex=Math.floor((realx-this.catEnergyField[k2].x)/pixelGroup)
                                let relativey=Math.floor((realy-this.catEnergyField[k2].y)/pixelGroup)

                                let othervalue=this.catEnergyField[k2].field[relativey][relativex]
                                let otherinside=false
                                let otherPointID=this.catEnergyField[k2].pointIndexMap[relativey][relativex]
                                let otherEdgeID=this.catEnergyField[k2].edgeIndexMap[relativey][relativex]
                                let othercat

                                if(otherPointID==-1&&otherEdgeID==-1){
                                    continue
                                }

                                if(otherEdgeID>-1){
                                    if(this.pointData[otherEdgeID].multicat){
                                        othercat=this.pointData[otherEdgeID].catArray
                                    }
                                    else{
                                        othercat=[this.pointData[otherEdgeID].cat]
                                    }
                                }

                                if(otherPointID>-1){
                                    if(this.pointData[otherPointID].multicat){
                                        othercat=this.pointData[otherPointID].catArray
                                    }
                                    else{
                                        othercat=[this.pointData[otherPointID].cat]
                                    }
                                }


                                // if(aim){
                                //     console.log()
                                // }

                                // if(k=="11"&&k2=="0"){
                                //         drawRect(realx,realy,1,1,"red")
                                //     console.log()
                                // }

                                if(this.isContained(othercat,k)){
                                    //contained cat to main cat
                                    //     drawRect(realx,realy,1,1,"red")
                                    // if(k=="11"&&k2=="0"){
                                    //     drawRect(realx,realy,1,1,"red")
                                    // }
                                    //this.catEnergyField[k].finalField[y][x]=value
                                    continue
                                }


                                if(this.isContained(thiscat,k2)&&this.catEnergyField[k2].pointBarrierMap[relativey][relativex]!=3){
                                    //contained cat to main cat
                                    //     drawRect(realx,realy,1,1,"red")
                                    //this.catEnergyField[k].finalField[y][x]=value
                                    continue

                                }


                                if(this.catEnergyField[k2].barrierMap[relativey][relativex]==3 ||this.catEnergyField[k2].barrierMap[relativey][relativex]==4){
                                    // if(this.catEnergyField[k2].barrierMap[relativey][relativex]==1 ||this.catEnergyField[k2].barrierMap[relativey][relativex]==2||this.catEnergyField[k2].barrierMap[relativey][relativex]==3 ||this.catEnergyField[k2].barrierMap[relativey][relativex]==4){

                                    otherinside=true
                                }



                                /*                                    if (!otherinside&&othervalue==0){
                                                                        // drawRect(realx,realy,1,1,"black")
                                                                        continue
                                                                    }*/

                                if (othervalue==0){
                                    // drawRect(realx,realy,1,1,"black")

                                    continue
                                }

                                // drawRect(realx,realy,1,1,"blue")
                                if(!isInside&&!otherinside){
                                    if(othervalue>value){
                                        finalvalue=0
                                        // drawRect(realx,realy,1,1,"blue")

                                        break
                                    }
                                    else{
                                        finalvalue=value
                                    }
                                    // finalvalue=0

                                }
                                else if(isInside&&!otherinside){
                                    // drawRect(realx,realy,1,1,"yellow")

                                    //pass

                                    finalvalue=value
                                }
                                else if(!isInside&&otherinside){
                                    // drawRect(realx,realy,1,1,"orange")

                                    finalvalue=0
                                    break
                                }
                                else if(isInside&&otherinside){

                                    // if(this.catEnergyField[k].barrierMap[y][x]==3||this.catEnergyField[k].barrierMap[y][x]==4){
                                    if(this.catEnergyField[k].barrierMap[y][x]==4){

                                        finalvalue=value
                                    }
                                    else{
                                        finalvalue=0
                                    }
                                    // finalvalue=0


                                }

                                // if(this.catEnergyField[k2].barrierMap[relativey][relativex]==4){
                                //     finalvalue=0
                                // }

                            }
                        }
                    }

                    this.catEnergyField[k].finalField[y][x]=finalvalue
                    if(this.catEnergyField[k].barrierMap[y][x]==4){
                        this.catEnergyField[k].finalField[y][x]=10000
                    }
                }
            }
        }
    }

    recalFinalEnergeField(preK){

        let bounding = {}
        for(let k in this.catEnergyField){
            bounding[k] = {
                minX : Number.MAX_VALUE,
                minY : Number.MAX_VALUE,
                maxX : Number.MIN_VALUE,
                maxY : Number.MIN_VALUE
            }
        }

        for (var k in this.catEnergyField){
            if(k == preK){
                continue
            }
            for(let p=0;p<this.updatedEnergyPoints[preK].length;p++) {

                let realx = this.updatedEnergyPoints[preK][p][0] * pixelGroup + this.catEnergyField[preK].x
                let realy = this.updatedEnergyPoints[preK][p][1] * pixelGroup + this.catEnergyField[preK].y

                let x = parseInt((realx - this.catEnergyField[k].x) / pixelGroup);
                let y = parseInt((realy - this.catEnergyField[k].y) / pixelGroup);


                bounding[k].minX = Math.min(bounding[k].minX, x)
                bounding[k].minY = Math.min(bounding[k].minY, y)
                bounding[k].maxX = Math.max(bounding[k].maxX, x)
                bounding[k].maxY = Math.max(bounding[k].maxY, y)

                let value = this.catEnergyField[k].field[y][x]
                let finalvalue = value
                let isInside = false

                let thisPointID = this.catEnergyField[k].pointIndexMap[y][x]
                let thisEdgeID = this.catEnergyField[k].edgeIndexMap[y][x]

                let thiscat

                if (thisEdgeID == -1 && thisPointID == -1) {
                    continue
                }

                if (thisEdgeID > -1) {
                    if (this.pointData[thisEdgeID].multicat) {
                        thiscat = this.pointData[thisEdgeID].catArray
                    } else {
                        thiscat = [this.pointData[thisEdgeID].cat]
                    }
                }

                if (thisPointID > -1) {
                    if (this.pointData[thisPointID].multicat) {
                        thiscat = this.pointData[thisPointID].catArray
                    } else {
                        thiscat = [this.pointData[thisPointID].cat]
                    }
                }

                if (this.catEnergyField[k].barrierMap[y][x] == 3 || this.catEnergyField[k].barrierMap[y][x] == 4) {
                    isInside = true
                }

                if (isInside && this.catEnergyField[k].field[y][x] == 0) {
                    this.catEnergyField[k].edgeIndexMap[y][x] = this.edges[thisEdgeID].start
                    this.catEnergyField[k].edgeIndexMap2[y][x].push({
                        start: this.edges[thisEdgeID].start,
                        end: this.edges[thisEdgeID].end
                    })
                    value = 1
                    this.catEnergyField[k].field[y][x] = 1
                }

                if (value == 0) {
                    continue
                }

                for (var k2 in this.catEnergyField) {

                    if (k2 == k)
                        continue

                    if(k2 == preK){
                        // TODO : compare final value


                        continue
                    }

                    if (realx <= this.catEnergyField[k2].boundingX + this.catEnergyField[k2].boundingWidth * pixelGroup && realx >= this.catEnergyField[k2].boundingX && realy <= this.catEnergyField[k2].boundingY + this.catEnergyField[k2].boundingHeight * pixelGroup && realy >= this.catEnergyField[k2].boundingY) {
                        let relativex = Math.floor((realx - this.catEnergyField[k2].x) / pixelGroup)
                        let relativey = Math.floor((realy - this.catEnergyField[k2].y) / pixelGroup)

                        let othervalue = this.catEnergyField[k2].field[relativey][relativex]
                        let otherinside = false
                        let otherPointID = this.catEnergyField[k2].pointIndexMap[relativey][relativex]
                        let otherEdgeID = this.catEnergyField[k2].edgeIndexMap[relativey][relativex]
                        let othercat

                        if (otherPointID == -1 && otherEdgeID == -1) {
                            continue
                        }

                        if (otherEdgeID > -1) {
                            if (this.pointData[otherEdgeID].multicat) {
                                othercat = this.pointData[otherEdgeID].catArray
                            } else {
                                othercat = [this.pointData[otherEdgeID].cat]
                            }
                        }

                        if (otherPointID > -1) {
                            if (this.pointData[otherPointID].multicat) {
                                othercat = this.pointData[otherPointID].catArray
                            } else {
                                othercat = [this.pointData[otherPointID].cat]
                            }
                        }


                        // if(aim){
                        //     console.log()
                        // }

                        // if(k=="11"&&k2=="0"){
                        //         drawRect(realx,realy,1,1,"red")
                        //     console.log()
                        // }

                        if (this.isContained(othercat, k)) {
                            //contained cat to main cat
                            //     drawRect(realx,realy,1,1,"red")
                            // if(k=="11"&&k2=="0"){
                            //     drawRect(realx,realy,1,1,"red")
                            // }
                            //this.catEnergyField[k].finalField[y][x]=value
                            continue
                        }


                        if (this.isContained(thiscat, k2) && this.catEnergyField[k2].pointBarrierMap[relativey][relativex] != 3) {
                            //contained cat to main cat
                            //     drawRect(realx,realy,1,1,"red")
                            //this.catEnergyField[k].finalField[y][x]=value
                            continue

                        }

                        if (this.catEnergyField[k2].barrierMap[relativey][relativex] == 3 || this.catEnergyField[k2].barrierMap[relativey][relativex] == 4) {
                            otherinside = true
                        }

                        if (othervalue == 0) {
                            continue
                        }

                        if (!isInside && !otherinside) {
                            if (othervalue > value) {
                                finalvalue = 0
                                break
                            } else {
                                finalvalue = value
                            }
                        } else if (isInside && !otherinside) {
                            finalvalue = value
                        } else if (!isInside && otherinside) {
                            finalvalue = 0
                            break
                        } else if (isInside && otherinside) {
                           if (this.catEnergyField[k].barrierMap[y][x] == 4) {
                                finalvalue = value
                            } else {
                                finalvalue = 0
                            }
                        }

                    }
                }

                this.catEnergyField[k].finalField[y][x] = finalvalue
                if (this.catEnergyField[k].barrierMap[y][x] == 4) {
                    this.catEnergyField[k].finalField[y][x] = 10000
                }
            }
        }

        this.smoothEnergyField(bounding)

    }

    updateFinalField(idx,k,val){

        let id = parseInt(idx);
        let sz = control_points[k].length;
        //console.log([id,sz]);
        let points = []
        let miny = Number.MAX_VALUE
        let maxy = Number.MIN_VALUE
        for(let j = -1;j <= 1;j ++ ){
            points.push({
                x:control_points[k][(id + j) % sz][0],
                y:control_points[k][(id + j) % sz][1]
            })
            miny = Math.min(miny,control_points[k][(id + j) % sz][1]);
            maxy = Math.max(maxy,control_points[k][(id + j) % sz][1]);
        }
//
        let lines = []
//
        for(let j = 0;j < 3;j ++){
            let p1 = points[j]
            let p2 = points[(j+1)%3]
            let tmp = {}
            tmp.y1 = Math.min(p1.y,p2.y);
            tmp.y2 = Math.max(p1.y,p2.y);
            if(p1.y == p2.y){
                tmp.flag = true;
                tmp.val1 = Math.min(p1.x,p2.x);
                tmp.val2 = Math.max(p1.x,p2.x);
            }
            else{
                tmp.flag = false;
                tmp.val1 = (p2.x - p1.x) / (p2.y - p1.y);
                tmp.val2 = (p1.x * p2.y - p2.x * p1.y) / (p2.y - p1.y);
            }
            lines.push(tmp);
        }
//
        for(let y = miny;y < maxy;y ++){
//
            let x1 = Number.MAX_VALUE;
            let x2 = Number.MIN_VALUE;
            let flag = false;
//
            for(let j = 0; j < 3;j ++){
                if(y >= lines[j].y1 && y <= lines[j].y2){
                    if(lines[j].flag == true){
                        x1 = lines[j].val1;
                        x2 = lines[j].val2;
                        flag = true;
                        break;
                    }
                    else{
                        let tmpx = lines[j].val1 * y + lines[j].val2;
                        x1 = Math.min(x1, tmpx);
                        x2 = Math.max(x2,tmpx);
                    }
                }
            }
//
            if(flag==true && val == 0){
                continue;
            }
            else{
                x1 = parseInt(x1)
                x2 = parseInt(x2)
                for(let x = x1;x <= x2;x ++){
                    //console.log("(" + this.catEnergyField[k].x + ", " + this.catEnergyField[k].y + ", "+ pixelGroup + ")");
                    //console.log("(" + this.catEnergyField[k].height + ", " + this.catEnergyField[k].width + ")")
                    let uy = Math.min(parseInt((y - this.catEnergyField[k].y) / pixelGroup),this.catEnergyField[k].height);
                    let ux = Math.min(parseInt((x - this.catEnergyField[k].x) / pixelGroup),this.catEnergyField[k].width);
                    uy = Math.max(uy,0)
                    ux = Math.max(ux,0)
                    //alert("(" + x + ", " + y + ")");
                    // this.catEnergyField[k].finalField[parseInt(uy)][parseInt(ux)] = val;
                    this.catEnergyField[k].field[parseInt(uy)][parseInt(ux)] = val;
                    this.catEnergyField[k].finalField[parseInt(uy)][parseInt(ux)] = val;
                    this.updatedEnergyPoints[k].push([parseInt(ux),parseInt(uy)])
                }
            }
//
        }
        //console.log(this.catEnergyField[k].finalField)
    }

    drawEnergyField(k){
        colors = this.props.colorArray

        let field=this.catEnergyField[k].finalField
        //let field = this.catEnergyField[k].field
        for(let y=0;y<field.length;y++){
            for (let x=0;x<field[y].length;x++){
                if(field[y][x]<0.0001)
                    continue
                let that=this
                let realx=x*pixelGroup+this.catEnergyField[k].x
                let realy=y*pixelGroup+this.catEnergyField[k].y
                let value=field[y][x]

                g.append("rect")
                    .attr("x",realx-0.5)
                    .attr("y",realy-0.5)
                    .attr("width",1)
                    .attr("height",1)
                    .attr("class","energyfieldrect")
                    .attr("fill", function(){
                        // if(value==-1){
                        //     return "red"
                        // }
                        // if(value==-2){
                        //     return "green"
                        // }
                        return colors[parseInt(k)]
                    })
                    .attr("opacity",1)
                    .attr("fieldvalue",value)
                    .on("mouseover",function(d){

                    })
            }
        }

    }

    drawBarrierMap(){
        for(var k in this.catEnergyField){


            let map=this.catEnergyField[k].barrierMap
            for(let i=0;i<this.catEnergyField[k].height;i++){
                for(let j=0;j<this.catEnergyField[k].width;j++){
                    let realy=i+this.catEnergyField[k].y
                    let realx=j+this.catEnergyField[k].x
                    if(map[i][j]==3){
                        drawRect(realx,realy,1,1,"red")
                    }
                    if(map[i][j]==4){
                        drawRect(realx,realy,1,1,"green")
                    }
                    if(map[i][j]==1){
                        drawRect(realx,realy,1,1,"yellow")
                    }
                    if(map[i][j]==2){
                        drawRect(realx,realy,1,1,"orange")
                    }
                }
            }
        }
    }

    drawBSpline(lines,color){
        var svg = d3.select("svg")

        for (let i=0;i<lines.length;i++){
            g.append("path")
                .style("fill", color)
                .style("stroke","none")
                // .style("stroke-width", 0.5)
                .style('opacity', 0.5)
                .attr("d", function () {
                    var p = "";
                    p += (d3.line()
                            .x(function (dat) {
                                return dat[0];
                            })
                            .y(function (dat) {
                                return dat[1];
                            })
                    )(lines[i])+ "";
                    return p;
                })
                .on('mouseover', function () {
                    d3.select(this)
                        .style('stroke', "red")
                        .style("stroke-width", 3);
                })
                .on('mouseout', function () {
                    d3.select(this)
                        .style('stroke', color)
                        .style("stroke-width", 0.5);
                });
        }
    }

    drawBSplineV2(lines,color){
        var svg = d3.select("svg")

        g.append("path")
            .style("fill", color)
            .style("stroke","none")
            // .style("stroke-width", 0.5)
            .style('opacity', 0.5)
            .attr("d", function () {
                var p = "";
                p += (d3.line()
                        .x(function (dat) {
                            return dat[0];
                        })
                        .y(function (dat) {
                            return dat[1];
                        })
                )(lines)+ "";
                return p;
            })
            .on('mouseover', function () {
                d3.select(this)
                    .style('stroke', "red")
                    .style("stroke-width", 3);
            })
            .on('mouseout', function () {
                d3.select(this)
                    .style('stroke', color)
                    .style("stroke-width", 0.5);
            });

    }

    fillPolygonForEdge(Polygon, k, field, othercat){

        let n = Polygon.length;
        let max_y = Number.MIN_VALUE;
        let min_y = Number.MAX_VALUE;
        let max_x = Number.MIN_VALUE;
        let min_x = Number.MAX_VALUE;

        //Node: x; dx; ymax;
        let NET = {};
        for(let i = 0; i < n; i ++){
            let x1 = Polygon[i][0];
            let y1 = Polygon[i][1];
            let x2 = Polygon[(i + 1) % n][0];
            let y2 = Polygon[(i + 1) % n][1];
            max_y = Math.max(max_y,y1);
            min_y = Math.min(min_y,y1);
            max_x = Math.max(max_x,x1);
            min_x = Math.min(min_x,x1);
            if(parseInt(y1) == parseInt(y2)){
                continue;
            }
            let tmpx;
            if(y1 > y2){
                tmpx = x2;
            }
            else{
                tmpx = x1;
            }
            //tmpx = parseInt(tmpx);
            let idx = parseInt(Math.min(y1, y2));
            if(!NET.hasOwnProperty(idx)){
                NET[idx] = []
            }
            NET[idx].push({x:tmpx, dx:(x2 - x1) / (y2 - y1), ymax:Math.max(y1,y2)});
        }

        //console.log(NET)
        //for(var key in NET){
        //    for(let j = 0; j < NET[key].length; j ++){
        //        console.log(NET[key][j]);
        //    }
        //}

        let AET = [];
        for(let i = min_y; i < max_y; i ++){
            let curi = parseInt(i);
            if(NET.hasOwnProperty(curi)){
                for(let j = 0; j < NET[curi].length; j ++){
                    AET.push(NET[curi][j]);
                }
            }
            AET.sort(function (a,b) {
                if(Math.abs(a.x - b.x) > eps) return a.x < b.x;
                if(Math.abs(a.dx - b.dx) > eps) return a.dx < b.dx;
                return a.ymax < b.ymax;
            })

            let CurSize = AET.length;

            //console.log(i)
            //for(let j = 0; j < CurSize; j ++){
            //    console.log(AET[j])
            //}
            //console.log(CurSize)
            //console.log("AET")
            //for(let k = 0; k < CurSize; k ++){
            //    console.log(AET[k].x)
            //}

            if(CurSize == 0){

            }
            else if(CurSize <= 1){
                let fx = Math.ceil((AET[0].x - this.catEnergyField[k].x) / pixelGroup)
                let fy = Math.ceil((i - this.catEnergyField[k].y) / pixelGroup)
                fx = Math.min(fx, this.catEnergyField[k].width - 2);
                fx = Math.max(fx, 0);
                fy = Math.min(fy, this.catEnergyField[k].height - 2);
                fy = Math.max(fy, 0);
                fx = parseInt(fx)
                fy = parseInt(fy)

                //......
                let realx = fx * pixelGroup + this.catEnergyField[k].x
                let realy = fy * pixelGroup + this.catEnergyField[k].y

                //d3.select('g').append('circle')
                //    .attr('cx',realx)
                //    .attr('cy',realy)
                //    .attr('r',1)
                //    .attr('fill','green')

                let relativeotherx=Math.floor((realx-this.catEnergyField[othercat].x)/pixelGroup)
                let relativeothery=Math.floor((realy-this.catEnergyField[othercat].y)/pixelGroup)

                if(relativeotherx>0&&relativeotherx<this.catEnergyField[othercat].width&&relativeothery>0&&relativeothery<this.catEnergyField[othercat].height){
                    // if(this.catEnergyField[k].finalField[y][x]==0&&this.catEnergyField[k].edgeBarrierMap[y][x]>0&&this.catEnergyField[othercat].finalField[relativeothery][relativeotherx]>0){
                    if(this.catEnergyField[k].finalField[fy][fx]==0&&this.catEnergyField[k].edgeBarrierMap[fy][fx]>0){
                        field[k][fy][fx]=this.catEnergyField[k].field[fy][fx]
                    }
                }

            }
            else{

                let p = [];
                //document.write('before<br>')
                for(let j = 0; j < CurSize; j ++){
                    let P_1 = {};
                    P_1.x = AET[j].x;
                    P_1.y = AET[j].ymax;

                    if(parseInt(P_1.y) == parseInt(i)){
                        continue;
                    }

                    if(p.length == 0){
                        p.push(P_1)
                        //document.write(P_1.x + '<br>')
                    }
                    else if(p.length == 1){

                        let P_2 = p[0];
                        if(Math.abs(P_1.x - P_2.x) < eps){
                            if(P_1.y > i && P_2.y > i){
                                p.push(P_1);
                                //document.write(P_1.x + '<br>')
                            }
                        }
                        else{
                            p.push(P_1);
                            //document.write(P_1.x + '<br>')
                        }

                        if(p.length == 2){
                            //document.write('start<br>')
                            //console.log("before")
                            //for(let k = 0; k < p.length; k ++){
                            //    document.write(p[k].x+ '<br>')
                            //}
                            let p_x1 = p.shift().x;
                            let p_x2 = p.shift().x;
                            let x_begin = Math.min(p_x1, p_x2);
                            let x_end = Math.max(p_x1, p_x2);
                            //console.log("after")
                            //for(let k = 0; k < p.length; k ++){
                            //    console.log(p[k])
                            //}
                            x_begin = Math.max(x_begin, min_x)
                            x_end = Math.min(x_end, max_x)
                            while(x_begin < x_end){
                                let fx = Math.ceil((x_begin - this.catEnergyField[k].x) / pixelGroup)
                                let fy = Math.ceil((i - this.catEnergyField[k].y) / pixelGroup)
                                fx = Math.min(fx, this.catEnergyField[k].width - 2);
                                fx = Math.max(fx, 0);
                                fy = Math.min(fy, this.catEnergyField[k].height - 2);
                                fy = Math.max(fy, 0);
                                fx = parseInt(fx);
                                fy = parseInt(fy);

                                let realx = fx * pixelGroup + this.catEnergyField[k].x
                                let realy = fy * pixelGroup + this.catEnergyField[k].y

                                //d3.select('g').append('circle')
                                //    .attr('cx',realx)
                                //    .attr('cy',realy)
                                //    .attr('r',1)
                                //    .attr('fill','green')

                                let relativeotherx=Math.floor((realx-this.catEnergyField[othercat].x)/pixelGroup)
                                let relativeothery=Math.floor((realy-this.catEnergyField[othercat].y)/pixelGroup)

                                if(relativeotherx>0&&relativeotherx<this.catEnergyField[othercat].width&&relativeothery>0&&relativeothery<this.catEnergyField[othercat].height){
                                    // if(this.catEnergyField[k].finalField[y][x]==0&&this.catEnergyField[k].edgeBarrierMap[y][x]>0&&this.catEnergyField[othercat].finalField[relativeothery][relativeotherx]>0){
                                    if(this.catEnergyField[k].finalField[fy][fx]==0&&this.catEnergyField[k].edgeBarrierMap[fy][fx]>0){
                                        field[k][fy][fx]=this.catEnergyField[k].field[fy][fx]
                                        //d3.select('g').append('circle')
                                        //    .attr('cx',realx)
                                        //    .attr('cy',realy)
                                        //    .attr('r',1)
                                        //    .attr('fill','blue')
                                    }
                                }

                                x_begin ++;
                            }
                        }
                    }

                }
            }

            for(let j = CurSize - 1; j >= 0; j --){
                AET[j].x += AET[j].dx;
                if(AET[j].ymax <= i){
                    AET.splice(j,1);
                }
            }

        }

        /*
        let newval = []
        let bx1 = Number.MAX_VALUE
        let bx2 = Number.MIN_VALUE
        let by1 = Number.MAX_VALUE
        let by2 = Number.MIN_VALUE


        // smooth
        for(let i = 0; i < this.updatedEnergyPoints[k].length; i ++){

            let sx = this.updatedEnergyPoints[k][i][0];
            let sy = this.updatedEnergyPoints[k][i][1];
            bx1 = Math.min(bx1, sx)
            bx2 = Math.max(bx2, sx)
            by1 = Math.min(by1, sy)
            by2 = Math.max(by2, sy)

            let kernelsize = 3
            let kernel = this.getGaussianKernel(1.5, kernelsize)
            let anchor = parseInt(kernelsize / 2)

            let newvalue = 0

            for (let i = 0; i < kernelsize; i ++){
                for (let j = 0; j < kernelsize; j ++){
                    let dy = i - anchor
                    let dx = j - anchor
                    let ny = sy + dy
                    let nx = sx + dx
                    if(ny > 0 && ny < this.catEnergyField[k].height && nx > 0 && nx < this.catEnergyField[k].width){
                        newvalue += kernel[i][j] * this.catEnergyField[k].finalField[ny][nx]
                    }
                }
            }

            newval.push(newvalue)

        }

        for(let i = 0; i < this.updatedEnergyPoints[k].length; i ++){
            let sx = this.updatedEnergyPoints[k][i][0];
            let sy = this.updatedEnergyPoints[k][i][1];
            this.catEnergyField[k].finalField[sy][sx] = newval[i];
        }
        */

        // remove unused inner outline

        //for(let i = bx1; i <= bx2; i += 2){
        //    for(let j = by1; j <= by2; j += 2){
        //        //let meanval = 0;
        //        let tmpidx = []
        //        for(let nx = i; nx <= Math.min(i + 1, bx2); nx ++){
        //            for(let ny = j; ny <= Math.min(j + 1, by2); ny ++){
        //                nx = parseInt(nx);
        //                ny = parseInt(ny);
        //                this.catEnergyField[k].finalField[ny][nx] = val
        //                //meanval += this.catEnergyField[k].finalField[ny][nx];
        //                //tmpidx.push([nx, ny])
        //            }
        //        }
        //        //if(tmpidx.length == 0){
        //        //    continue;
        //        //}
        //        //meanval /= tmpidx.length
        //        //for(let idx = 0; idx < tmpidx.length; idx ++){
        //        //    this.catEnergyField[k].finalField[tmpidx[idx][1]][tmpidx[idx][0]] = meanval;
        //        //}
        //    }
        //}


        //this.drawEnergyField(k);

    }

    fillPolygon(Polygon,k,val,cut = false){

        let n = Polygon.length;
        let max_y = Number.MIN_VALUE;
        let min_y = Number.MAX_VALUE;
        let max_x = Number.MIN_VALUE;
        let min_x = Number.MAX_VALUE;

        //Node: x; dx; ymax;
        let NET = {};
        for(let i = 0; i < n; i ++){
            let x1 = Polygon[i][0];
            let y1 = Polygon[i][1];
            let x2 = Polygon[(i + 1) % n][0];
            let y2 = Polygon[(i + 1) % n][1];
            max_y = Math.max(max_y,y1);
            min_y = Math.min(min_y,y1);
            max_x = Math.max(max_x,x1);
            min_x = Math.min(min_x,x1);
            if(parseInt(y1) == parseInt(y2)){
                continue;
            }
            let tmpx;
            if(y1 > y2){
                tmpx = x2;
            }
            else{
                tmpx = x1;
            }
            //tmpx = parseInt(tmpx);
            let idx = parseInt(Math.min(y1, y2));
            if(!NET.hasOwnProperty(idx)){
                NET[idx] = []
            }
            NET[idx].push({x:tmpx, dx:(x2 - x1) / (y2 - y1), ymax:Math.max(y1,y2)});
        }

        //console.log(NET)
        //for(var key in NET){
        //    for(let j = 0; j < NET[key].length; j ++){
        //        console.log(NET[key][j]);
        //    }
        //}

        let AET = [];
        for(let i = min_y; i < max_y; i ++){
            let curi = parseInt(i);
            if(NET.hasOwnProperty(curi)){
                for(let j = 0; j < NET[curi].length; j ++){
                    AET.push(NET[curi][j]);
                }
            }
            AET.sort(function (a,b) {
                if(Math.abs(a.x - b.x) > eps) return a.x < b.x;
                if(Math.abs(a.dx - b.dx) > eps) return a.dx < b.dx;
                return a.ymax < b.ymax;
            })

            let CurSize = AET.length;

            //console.log(i)
            //for(let j = 0; j < CurSize; j ++){
            //    console.log(AET[j])
            //}
            //console.log(CurSize)
            //console.log("AET")
            //for(let k = 0; k < CurSize; k ++){
            //    console.log(AET[k].x)
            //}

            if(CurSize == 0){

            }
            else if(CurSize <= 1){
                let fx = Math.ceil((AET[0].x - this.catEnergyField[k].x) / pixelGroup)
                let fy = Math.ceil((i - this.catEnergyField[k].y) / pixelGroup)
                fx = Math.min(fx, this.catEnergyField[k].width - 2);
                fx = Math.max(fx, 0);
                fy = Math.min(fy, this.catEnergyField[k].height - 2);
                fy = Math.max(fy, 0);
                fx = parseInt(fx)
                fy = parseInt(fy)
                this.catEnergyField[k].finalField[fy][fx] = val;
                if(!cut){
                    this.catEnergyField[k].field[fy][fx] = val;
                }
                this.updatedEnergyPoints[k].push([fx,fy])
            }
            else{

                let p = [];
                //document.write('before<br>')
                for(let j = 0; j < CurSize; j ++){
                    let P_1 = {};
                    P_1.x = AET[j].x;
                    P_1.y = AET[j].ymax;

                    if(parseInt(P_1.y) == parseInt(i)){
                        continue;
                    }

                    if(p.length == 0){
                        p.push(P_1)
                        //document.write(P_1.x + '<br>')
                    }
                    else if(p.length == 1){

                        let P_2 = p[0];
                        if(Math.abs(P_1.x - P_2.x) < eps){
                            if(P_1.y > i && P_2.y > i){
                                p.push(P_1);
                                //document.write(P_1.x + '<br>')
                            }
                        }
                        else{
                            p.push(P_1);
                            //document.write(P_1.x + '<br>')
                        }

                        if(p.length == 2){
                            //document.write('start<br>')
                            //console.log("before")
                            //for(let k = 0; k < p.length; k ++){
                            //    document.write(p[k].x+ '<br>')
                            //}
                            let p_x1 = p.shift().x;
                            let p_x2 = p.shift().x;
                            let x_begin = Math.min(p_x1, p_x2);
                            let x_end = Math.max(p_x1, p_x2);
                            //console.log("after")
                            //for(let k = 0; k < p.length; k ++){
                            //    console.log(p[k])
                            //}
                            x_begin = Math.max(x_begin, min_x)
                            x_end = Math.min(x_end, max_x)
                            while(x_begin < x_end){
                                let fx = Math.ceil((x_begin - this.catEnergyField[k].x) / pixelGroup)
                                let fy = Math.ceil((i - this.catEnergyField[k].y) / pixelGroup)
                                fx = Math.min(fx, this.catEnergyField[k].width - 2);
                                fx = Math.max(fx, 0);
                                fy = Math.min(fy, this.catEnergyField[k].height - 2);
                                fy = Math.max(fy, 0);
                                fx = parseInt(fx);
                                fy = parseInt(fy);
                                //console.log((x_begin,i));
                                //canvas[parseInt(x_begin)][parseInt(i)] = val;
                                this.catEnergyField[k].finalField[fy][fx] = val;
                                if(!cut){
                                    this.catEnergyField[k].field[fy][fx] = val;
                                }
                                this.updatedEnergyPoints[k].push([fx,fy])
                                x_begin ++;
                            }
                        }
                    }

                }
            }

            for(let j = CurSize - 1; j >= 0; j --){
                AET[j].x += AET[j].dx;
                if(AET[j].ymax <= i){
                    AET.splice(j,1);
                }
            }

        }

        /*
        let newval = []
        let bx1 = Number.MAX_VALUE
        let bx2 = Number.MIN_VALUE
        let by1 = Number.MAX_VALUE
        let by2 = Number.MIN_VALUE


        // smooth
        for(let i = 0; i < this.updatedEnergyPoints[k].length; i ++){

            let sx = this.updatedEnergyPoints[k][i][0];
            let sy = this.updatedEnergyPoints[k][i][1];
            bx1 = Math.min(bx1, sx)
            bx2 = Math.max(bx2, sx)
            by1 = Math.min(by1, sy)
            by2 = Math.max(by2, sy)

            let kernelsize = 3
            let kernel = this.getGaussianKernel(1.5, kernelsize)
            let anchor = parseInt(kernelsize / 2)

            let newvalue = 0

            for (let i = 0; i < kernelsize; i ++){
                for (let j = 0; j < kernelsize; j ++){
                    let dy = i - anchor
                    let dx = j - anchor
                    let ny = sy + dy
                    let nx = sx + dx
                    if(ny > 0 && ny < this.catEnergyField[k].height && nx > 0 && nx < this.catEnergyField[k].width){
                        newvalue += kernel[i][j] * this.catEnergyField[k].finalField[ny][nx]
                    }
                }
            }

            newval.push(newvalue)

        }

        for(let i = 0; i < this.updatedEnergyPoints[k].length; i ++){
            let sx = this.updatedEnergyPoints[k][i][0];
            let sy = this.updatedEnergyPoints[k][i][1];
            this.catEnergyField[k].finalField[sy][sx] = newval[i];
        }
        */

        // remove unused inner outline

        //for(let i = bx1; i <= bx2; i += 2){
        //    for(let j = by1; j <= by2; j += 2){
        //        //let meanval = 0;
        //        let tmpidx = []
        //        for(let nx = i; nx <= Math.min(i + 1, bx2); nx ++){
        //            for(let ny = j; ny <= Math.min(j + 1, by2); ny ++){
        //                nx = parseInt(nx);
        //                ny = parseInt(ny);
        //                this.catEnergyField[k].finalField[ny][nx] = val
        //                //meanval += this.catEnergyField[k].finalField[ny][nx];
        //                //tmpidx.push([nx, ny])
        //            }
        //        }
        //        //if(tmpidx.length == 0){
        //        //    continue;
        //        //}
        //        //meanval /= tmpidx.length
        //        //for(let idx = 0; idx < tmpidx.length; idx ++){
        //        //    this.catEnergyField[k].finalField[tmpidx[idx][1]][tmpidx[idx][0]] = meanval;
        //        //}
        //    }
        //}


        //this.drawEnergyField(k);

    }

    drawISOLinesV2(k,that,curdata){


        for(let i = 0;i < 4;i ++){
            d3.select("#bounding"+ k.toString() + i.toString()).remove();
        }
        for(let i = 0;i < control_points[k].length; i ++){
            for(let j = 0;j < control_points[k][i].length; j ++){
                d3.select("#circle" + k.toString() + "i" + i.toString() + "i" + j.toString()).remove();
            }
        }
        for(let i in control_points){
            if(i == k){
                continue;
            }
            d3.select("#path"+i)
                .attr('fill-opacity', 0.5)
        }
        is_selected[k]=false
        that.editMode=false


        colors = this.props.colorArray

        editSeg[k] = []

        let len;

        let bounding = []

        let bx1 = that.catEnergyField[k].boundingX;
        let by1 = that.catEnergyField[k].boundingY;
        let bx2 = that.catEnergyField[k].boundingX + that.catEnergyField[k].boundingWidth * pixelGroup - 5 * pixelGroup;
        let by2 = that.catEnergyField[k].boundingY + that.catEnergyField[k].boundingHeight * pixelGroup - 5 * pixelGroup;

        bounding.push({x:bx1, y:by1})
        bounding.push({x:bx2, y:by1})
        bounding.push({x:bx2, y:by2})
        bounding.push({x:bx1, y:by2})

        function dragstarted() {

            let execflag = false;
            if(d3.select(this)._groups[0][0].attributes.hasOwnProperty("id")){
                execflag = true;
            }
            if(execflag == false){
                return;
            }

            let tmp_idx = d3.select(this)._groups[0][0].attributes.id.value;
            //console.log(tmp_idx)
            let isnum = parseInt(tmp_idx[6])
            if(isnum >= 0 && isnum <= 9){

                let iidx = ""
                let jidx = ""

                for(let i = 7;i < tmp_idx.length;i ++){
                    if(tmp_idx[i] == "i"){
                        i ++;
                        while(tmp_idx[i] != "i"){
                            iidx += tmp_idx[i++];
                        }
                        i ++;
                        while(i < tmp_idx.length){
                            jidx += tmp_idx[i++];
                        }
                        break;
                    }
                }

                iidx = parseInt(iidx);
                jidx = parseInt(jidx);

                len = control_points[k][iidx].length;
                //console.log("(" + iidx + ", " + jidx + ")");

                prepoints = [];
                for(let i = 0; i < control_points[k].length; i ++){
                    prepoints[i] = []
                    for(let j = 0; j < control_points[k][i].length; j ++){
                        prepoints[i].push([control_points[k][i][j][0],control_points[k][i][j][1]]);
                    }
                }

                move_points = [];
                move_points.push(jidx);
                mid_point = 0

                let v1 = [];
                v1[0] = control_points[k][iidx][jidx][0];
                v1[1] = control_points[k][iidx][jidx][1];

                let v2 = [];
                v2[0] = control_points[k][iidx][(jidx + 1) % len][0];
                v2[1] = control_points[k][iidx][(jidx + 1) % len][1];

                nearpts = [];
                nearpts.push(v1);
                nearpts.push(v2);

                //console.log("before")
                //for(let j = 0;j < nearpts.length; j ++){
                //    console.log(nearpts[j])
                //}

                /*
                //multi points
                if(calDistance(control_points[k][iidx][jidx][0],control_points[k][iidx][jidx][1],
                    control_points[k][iidx][(jidx + len - 1) % len][0],control_points[k][iidx][(jidx + len - 1) % len][1]) > control_points[k][iidx].meandis){
                    move_points.unshift((jidx + len - 1) % len);
                    mid_point ++
                }

                if(calDistance(control_points[k][iidx][jidx][0],control_points[k][iidx][jidx][1],
                    control_points[k][iidx][(jidx + 1) % len][0],control_points[k][iidx][(jidx + 1) % len][1]) > control_points[k][iidx].meandis){
                    move_points.push((jidx + 1) % len);
                }

                 */


                //that.updateFinalField(idx,k,0)
            }

        }

        function dragged(e) {

            let execflag = false;
            if(e.sourceEvent.target.attributes.hasOwnProperty("id")){
                execflag = true;
            }
            if(execflag == false){
                return;
            }

            //console.log(e.sourceEvent.target.attributes.id)
            let tmp_idx = e.sourceEvent.target.attributes.id.value.toString()
            let isnum = parseInt(tmp_idx[6])

            let ex = e.x;
            let ey = e.y;

            ex = Math.min(ex, bx2)
            ex = Math.max(ex, bx1)
            ey = Math.min(ey, by2)
            ey = Math.max(ey, by1)

            d3.select(this)
                .attr('cx', ex)
                .attr('cy', ey)

            if(isnum >= 0 && isnum <= 9){

                let iidx = ""
                let jidx = ""

                for(let i = 7;i < tmp_idx.length;i ++){
                    if(tmp_idx[i] == "i"){
                        i ++;
                        while(tmp_idx[i] != "i"){
                            iidx += tmp_idx[i++];
                        }
                        i ++;
                        while(i < tmp_idx.length){
                            jidx += tmp_idx[i++];
                        }
                        break;
                    }
                }

                iidx = parseInt(iidx);
                jidx = parseInt(jidx);

                if(!control_points[k].hasOwnProperty(iidx)){
                    return
                }

                len = control_points[k][iidx].length;
                control_points[k][iidx][jidx][0] = ex;
                control_points[k][iidx][jidx][1] = ey;

                /*
                //multi points
                let dx = ex - control_points[k][iidx][jidx][0];
                let dy = ey - control_points[k][iidx][jidx][1];
                let w = 1;
                for(let j = mid_point;j >= 0;j --){
                    control_points[k][iidx][move_points[j]][0] += w * dx;
                    control_points[k][iidx][move_points[j]][1] += w * dy;
                    if(control_points[k][iidx][move_points[j]][0] > bx2){
                        control_points[k][iidx][move_points[j]][0] = bx2;
                    }
                    if(control_points[k][iidx][move_points[j]][1] > by2){
                        control_points[k][iidx][move_points[j]][1] = by2;
                    }
                    w *= 0.4;
                }

                w = 0.4;
                for(let j = mid_point + 1;j < move_points.length; j ++){
                    control_points[k][iidx][move_points[j]][0] += w * dx;
                    control_points[k][iidx][move_points[j]][1] += w * dy;
                    if(control_points[k][iidx][move_points[j]][0] > bx2){
                        control_points[k][iidx][move_points[j]][0] = bx2;
                    }
                    if(control_points[k][iidx][move_points[j]][1] > by2){
                        control_points[k][iidx][move_points[j]][1] = by2;
                    }
                    w *= 0.4;
                }


                for(let j = 0; j < move_points.length; j ++){
                    if(j == mid_point){
                        continue;
                    }
                    d3.select("#circle" + k.toString() + "i" + iidx.toString() + "i" + move_points[j].toString())
                        .attr('cx', control_points[k][iidx][move_points[j]][0])
                        .attr('cy', control_points[k][iidx][move_points[j]][1])
                }

                let idx = move_points[0];
                if(calDistance(control_points[k][iidx][idx][0],control_points[k][iidx][idx][1],
                    control_points[k][iidx][(idx + len - 1) % len][0],control_points[k][iidx][(idx + len - 1) % len][1]) > control_points[k][iidx].meandis){
                    move_points.unshift((idx + len - 1) % len);
                    mid_point ++
                }
                idx = move_points[move_points.length - 1];
                if(calDistance(control_points[k][iidx][idx][0],control_points[k][iidx][idx][1],
                    control_points[k][iidx][(idx + 1) % len][0],control_points[k][iidx][(idx + 1) % len][1]) > control_points[k][iidx].meandis){
                    move_points.push((idx + 1) % len);
                }
                 */

                //let drawPathData="";
//
                //for(let j = 0;j < control_points[k].length; j ++){
                //    drawPathData += lineFunction(control_points[k][j]);
                //}
//
                //g.append("path")
                //    .attr('id', "temp_path")
                //    .attr('d', drawPathData)
                //    .attr("fill", "none")
//
                //let tmpPath = d3.select("#temp_path").node()
                //let totLen = tmpPath.getTotalLength()
//
                //let reDrawData = []
                //let pointsnum = totLen
//
                //for(let idx = 0;idx < pointsnum;idx ++){
                //    let p = tmpPath.getPointAtLength(idx)
                //    reDrawData.push([p.x, p.y])
                //}
//
                //console.log("reDrawData:")
                //console.log(reDrawData)
                let reDrawData = ""
                for(let j = 0;j < control_points[k].length; j ++){

                    if(j == iidx){

                        let cur_len = control_points[k][j].length
                        let tmp_pts = []
                        //let s_pts = []

                        // select one or more point for interpolation
                        //for(let p = 1; p >= 1; p --){
                        let q = (jidx - 1 + cur_len) % cur_len
                        editSeg[k].push(q)
                            //s_pts.push([control_points[k][j][q][0], control_points[k][j][q][1]])
                       // }
                        //editSeg[k].push(jidx)
                        //s_pts.push([control_points[k][j][jidx][0], control_points[k][j][jidx][1]])
                        //for(let p = 1; p <= 1; p ++){
                        //    let q = (jidx + p) % cur_len
                        //    s_pts.push([control_points[k][j][q][0], control_points[k][j][q][1]])
                        //}

                        //let spline1 = new BSpline(s_pts, 3)
                        //for(let t = 0; t < 1; t += 0.01){
                        //    // TODO : re-locate neighbor control points around the dragged point
                        //    tmp_pts.push(spline1.calcAt(t))
                        //}

                        /*
                        let ra = 0.1
                        for(let idx = -2;idx <= 2;idx ++){
                            if(idx == 0){
                                continue
                            }
                            let p = tmpPath.getPointAtLength( ra * totLen )
                            let q = (jidx + idx + cur_len) % cur_len
                            ra += 0.2
                            //control_points[k][j][q][0] = p.x
                            //control_points[k][j][q][1] = p.y
                            //d3.select("#circle"+ k.toString() + "i" + j.toString() + "i" + q.toString())
                            //    .attr("cx",control_points[k][j][q][0])
                            //    .attr("cy",control_points[k][j][q][1])
                        }
                        */

                        //let new_points = []

                        //console.log("modify points")
                        //console.log(new_points.length)

                        editSeg[k].sort(function(a,b){
                            return a - b
                        })

                        let tmpDict = {}
                        for(let e = 0; e < editSeg[k].length; e ++){
                            tmpDict[editSeg[k][e]] = 1
                        }

                        let sid
                        if(editSeg[k].length > 0){
                            sid = editSeg[k][0]
                        }
                        else{
                            sid = 0
                        }

                        for(let p = 0; p < cur_len; p ++){
                            // start from sid
                            let cur_idx = (sid + p) % cur_len
                            if(tmpDict.hasOwnProperty(cur_idx)){

                                let s_pts = []
                                s_pts.push([control_points[k][j][(cur_idx - 1 + cur_len) % cur_len][0], control_points[k][j][(cur_idx - 1 + cur_len) % cur_len][1]])
                                s_pts.push([control_points[k][j][cur_idx][0], control_points[k][j][cur_idx][1]])
                                s_pts.push([control_points[k][j][(cur_idx + 1) % cur_len][0], control_points[k][j][(cur_idx + 1) % cur_len][1]])
                                s_pts.push([control_points[k][j][(cur_idx + 2) % cur_len][0], control_points[k][j][(cur_idx + 2) % cur_len][1]])
                                s_pts.push([control_points[k][j][(cur_idx + 3) % cur_len][0], control_points[k][j][(cur_idx + 2) % cur_len][1]])

                                let p1 = [ control_points[k][j][cur_idx][0], control_points[k][j][cur_idx][1] ]
                                let p2 = [ control_points[k][j][(cur_idx + 2) % cur_len][0], control_points[k][j][(cur_idx + 2) % cur_len][1] ]

                                d3.select("svg").append("path")
                                    .attr("id","temp_path")
                                    .attr("d",lineFunction_reDraw(s_pts))
                                    .attr("fill","none")

                                let tmpPath = d3.select("#temp_path").node()
                                let totLen = tmpPath.getTotalLength()

                                let r1_idx = 0
                                let dis1 = Number.MAX_VALUE
                                let r2_idx = totLen / 5
                                let dis2 = Number.MAX_VALUE

                                for(let p = 0; p <= totLen / 5 ; p ++){

                                    let tmp_p = tmpPath.getPointAtLength(5 * p)

                                    let tmpdis1 = calDistance(p1[0], p1[1], tmp_p.x, tmp_p.y)
                                    let tmpdis2 = calDistance(p2[0], p2[1], tmp_p.x, tmp_p.y)

                                    if(tmpdis1 < dis1){
                                        r1_idx = p
                                        dis1 = tmpdis1
                                    }

                                    if(tmpdis2 < dis2){
                                        r2_idx = p
                                        dis2 = tmpdis2
                                    }

                                    //tmp_pts.push([tmp_p.x, tmp_p.y])
                                }

                                for(let p = r1_idx; p <= r2_idx; p ++){
                                    let tmp_p = tmpPath.getPointAtLength(5 * p)
                                    tmp_pts.push([tmp_p.x, tmp_p.y])
                                }

                                d3.select("#temp_path").remove()

                                p ++
                            }
                            else{
                                tmp_pts.push([control_points[k][j][cur_idx][0], control_points[k][j][cur_idx][1]])
                            }
                        }

                        //console.log(tmp_pts)
                        reDrawData += lineFunction(tmp_pts)

                    }
                    else{
                    //console.log(control_points[k][j])
                        reDrawData += lineFunction(control_points[k][j]);
                    }

                }

                that.reDraw(k, that, reDrawData)

                //d3.select("#temp_path").remove()

            }

        }

        function dragended() {

            let execflag = false;
            if(d3.select(this)._groups[0][0].attributes.hasOwnProperty("id")){
                execflag = true;
            }
            if(execflag == false){
                return;
            }

            let tmp_idx = d3.select(this)._groups[0][0].attributes.id.value;
            let isnum = parseInt(tmp_idx[6])

            if(isnum >= 0 && isnum <= 9){

                let iidx = ""
                let jidx = ""

                for(let i = 7;i < tmp_idx.length;i ++){
                    if(tmp_idx[i] == "i"){
                        i ++;
                        while(tmp_idx[i] != "i"){
                            iidx += tmp_idx[i++];
                        }
                        i ++;
                        while(i < tmp_idx.length){
                            jidx += tmp_idx[i++];
                        }
                        break;
                    }
                }

                iidx = parseInt(iidx);
                jidx = parseInt(jidx);

                let Polygon = []
                let len = control_points[k][iidx].length;

                Polygon.push([control_points[k][iidx][(jidx + len - 1) % len][0],control_points[k][iidx][(jidx + len - 1) % len][1]])
                Polygon.push([prepoints[iidx][jidx][0],prepoints[iidx][jidx][1]])
                Polygon.push([control_points[k][iidx][(jidx + 1) % len][0],control_points[k][iidx][(jidx + 1) % len][1]])
                Polygon.push([control_points[k][iidx][jidx][0],control_points[k][iidx][jidx][1]])

                //for(let j = 0 ; j < move_points.length; j ++){
                //    Polygon.push([control_points[k][iidx][move_points[j]][0],control_points[k][iidx][move_points[j]][1]]);
                //}
                //for(let j = move_points.length - 1; j >= 0; j --){
                //    Polygon.push([prepoints[iidx][move_points[j]][0],prepoints[iidx][move_points[j]][1]]);
                //}

                let v3 = control_points[k][iidx][jidx];
                nearpts.push(v3);

                //console.log("after")
                //for(let j = 0;j < nearpts.length; j ++){
                //    console.log(nearpts[j])
                //}

                let vec1 = [nearpts[1][0] - nearpts[0][0],nearpts[1][1] - nearpts[0][1]];
                let vec2 = [nearpts[2][0] - nearpts[0][0],nearpts[2][1] - nearpts[0][1]];
                let is_outer = vec1[0] * vec2[1] - vec2[0] * vec1[1];
                let val = 0;
                if(is_outer <= 0){
                    //console.log("move out")
                    if(iidx == 0){
                        val = 10;
                    }
                }
                else{
                    //console.log("move in")
                    if(iidx > 0){
                        val = 10;
                    }
                }
                // drawPolygon(Polygon,0,0,"red")
                that.fillPolygon(Polygon, k, val)

                //d3.select("svg").selectAll(".energyfieldrect")
                //    .remove()
                //that.drawEnergyField(k);
                //
                //that.updateFinalField(idx,k,1)
            }

        }

        g.append("path")
            .attr('id',"path"+k)
            .attr('d',curdata)
            .attr("fill", colors[k])
            .attr('fill-opacity', 0.5)
            .attr('fill-rule',"evenodd")
            .style('stroke', colors[k])
            .style("stroke-width", 1)
            .on('mouseover', function () {
                if(!that.editMode){
                    d3.select(this)
                        .style('stroke', "red")
                        .style("stroke-width", 3);
                }
            })
            .on('mouseout', function () {
                if(!that.editMode){
                    d3.select(this)
                        .style('stroke', colors[k])
                        .style("stroke-width", 1)
                }
                // .style("stroke-width", 0.5);
            })
            .on('mousedown',function (e){
                if(e.button==2){
                    if(is_selected[k]==false&&!that.editMode){
                        that.editMode=true

                        for(let i = 0;i < 4;i ++){
                            g.append("line")
                                .attr('id',"bounding"+ k.toString() + i.toString())
                                .attr("x1", bounding[i].x)
                                .attr("y1", bounding[i].y)
                                .attr("x2", bounding[(i+1)%4].x)
                                .attr("y2", bounding[(i+1)%4].y)
                                .attr("stroke", "red")
                                .attr("stroke-width", "1px");
                        }
                        for(let i in control_points){
                            if(i == k){
                                continue;
                            }
                            d3.select("#path"+i)
                                .attr('fill-opacity', 0.2)
                        }

                        for(let i = 0;i < control_points[k].length; i ++){
                            for(let j = 0;j < control_points[k][i].length; j ++){
                                g.append("circle")
                                    .attr("id","circle" + k.toString() + "i" + i.toString() + "i" + j.toString())
                                    .attr("cx",control_points[k][i][j][0])
                                    .attr("cy",control_points[k][i][j][1])
                                    .attr("r",3)
                                    .attr("fill",'red')
                                    .attr('fill-opacity', 0.5)
                                    .on("mouseover",function(){
                                        d3.select(this).attr("stroke","red")
                                            .attr("stroke-width",2)
                                    })
                                    .on("mouseout",function(){
                                        d3.select(this).attr("stroke","none")
                                            .attr("stroke-width",1)
                                    })
                                    .call(d3.drag()
                                        .on("start", dragstarted)
                                        .on("drag", dragged)
                                        .on("end", dragended))
                            }
                        }
                        is_selected[k]=true;
                    }

                    else if(that.editMode&&is_selected[k]){
                        for(let i = 0;i < 4;i ++){
                            d3.select("#bounding"+ k.toString() + i.toString()).remove();
                        }
                        for(let i = 0;i < control_points[k].length; i ++){
                            for(let j = 0;j < control_points[k][i].length; j ++){
                                d3.select("#circle" + k.toString() + "i" + i.toString() + "i" + j.toString()).remove();
                            }
                        }
                        for(let i in control_points){
                            if(i == k){
                                continue;
                            }
                            d3.select("#path"+i)
                                .attr('fill-opacity', 0.5)
                        }
                        is_selected[k]=false;
                        that.editMode=false
                    }
                }
            });
    }

    reDraw(k,that,curdata){

        colors = this.props.colorArray

        let len = control_points[k].length;
        let bounding = []

        let bx1 = that.catEnergyField[k].boundingX;
        let by1 = that.catEnergyField[k].boundingY;
        let bx2 = that.catEnergyField[k].boundingX + that.catEnergyField[k].boundingWidth * pixelGroup - 5 * pixelGroup;
        let by2 = that.catEnergyField[k].boundingY + that.catEnergyField[k].boundingHeight * pixelGroup - 5 * pixelGroup;

        bounding.push({x:bx1, y:by1})
        bounding.push({x:bx2, y:by1})
        bounding.push({x:bx2, y:by2})
        bounding.push({x:bx1, y:by2})

        function dragstarted() {

            let execflag = false;
            if(d3.select(this)._groups[0][0].attributes.hasOwnProperty("id")){
                execflag = true;
            }
            if(execflag == false){
                return;
            }

            let tmp_idx = d3.select(this)._groups[0][0].attributes.id.value;
            //console.log(tmp_idx)
            let isnum = parseInt(tmp_idx[6])
            if(isnum >= 0 && isnum <= 9){

                let iidx = ""
                let jidx = ""

                for(let i = 7;i < tmp_idx.length;i ++){
                    if(tmp_idx[i] == "i"){
                        i ++;
                        while(tmp_idx[i] != "i"){
                            iidx += tmp_idx[i++];
                        }
                        i ++;
                        while(i < tmp_idx.length){
                            jidx += tmp_idx[i++];
                        }
                        break;
                    }
                }

                iidx = parseInt(iidx);
                jidx = parseInt(jidx);

                len = control_points[k][iidx].length;
                //console.log("(" + iidx + ", " + jidx + ")");

                prepoints = [];
                for(let i = 0; i < control_points[k].length; i ++){
                    prepoints[i] = []
                    for(let j = 0; j < control_points[k][i].length; j ++){
                        prepoints[i].push([control_points[k][i][j][0],control_points[k][i][j][1]]);
                    }
                }

                move_points = [];
                move_points.push(jidx);
                mid_point = 0

                let v1 = [];
                v1[0] = control_points[k][iidx][jidx][0];
                v1[1] = control_points[k][iidx][jidx][1];

                let v2 = [];
                v2[0] = control_points[k][iidx][(jidx + 1) % len][0];
                v2[1] = control_points[k][iidx][(jidx + 1) % len][1];

                nearpts = [];
                nearpts.push(v1);
                nearpts.push(v2);

                //console.log("before")
                //for(let j = 0;j < nearpts.length; j ++){
                //    console.log(nearpts[j])
                //}

                /*
                //multi points
                if(calDistance(control_points[k][iidx][jidx][0],control_points[k][iidx][jidx][1],
                    control_points[k][iidx][(jidx + len - 1) % len][0],control_points[k][iidx][(jidx + len - 1) % len][1]) > control_points[k][iidx].meandis){
                    move_points.unshift((jidx + len - 1) % len);
                    mid_point ++
                }

                if(calDistance(control_points[k][iidx][jidx][0],control_points[k][iidx][jidx][1],
                    control_points[k][iidx][(jidx + 1) % len][0],control_points[k][iidx][(jidx + 1) % len][1]) > control_points[k][iidx].meandis){
                    move_points.push((jidx + 1) % len);
                }

                 */


                //that.updateFinalField(idx,k,0)
            }

        }

        function dragged(e) {

            let execflag = false;
            if(e.sourceEvent.target.attributes.hasOwnProperty("id")){
                execflag = true;
            }
            if(execflag == false){
                return;
            }

            //console.log(e.sourceEvent.target.attributes.id)
            let tmp_idx = e.sourceEvent.target.attributes.id.value.toString()
            let isnum = parseInt(tmp_idx[6])

            let ex = e.x;
            let ey = e.y;

            ex = Math.min(ex, bx2)
            ex = Math.max(ex, bx1)
            ey = Math.min(ey, by2)
            ey = Math.max(ey, by1)

            d3.select(this)
                .attr('cx', ex)
                .attr('cy', ey)

            if(isnum >= 0 && isnum <= 9){

                let iidx = ""
                let jidx = ""

                for(let i = 7;i < tmp_idx.length;i ++){
                    if(tmp_idx[i] == "i"){
                        i ++;
                        while(tmp_idx[i] != "i"){
                            iidx += tmp_idx[i++];
                        }
                        i ++;
                        while(i < tmp_idx.length){
                            jidx += tmp_idx[i++];
                        }
                        break;
                    }
                }

                iidx = parseInt(iidx);
                jidx = parseInt(jidx);

                if(!control_points[k].hasOwnProperty(iidx)){
                    return
                }

                len = control_points[k][iidx].length;
                control_points[k][iidx][jidx][0] = ex;
                control_points[k][iidx][jidx][1] = ey;

                /*
                //multi points
                let dx = ex - control_points[k][iidx][jidx][0];
                let dy = ey - control_points[k][iidx][jidx][1];
                let w = 1;
                for(let j = mid_point;j >= 0;j --){
                    control_points[k][iidx][move_points[j]][0] += w * dx;
                    control_points[k][iidx][move_points[j]][1] += w * dy;
                    if(control_points[k][iidx][move_points[j]][0] > bx2){
                        control_points[k][iidx][move_points[j]][0] = bx2;
                    }
                    if(control_points[k][iidx][move_points[j]][1] > by2){
                        control_points[k][iidx][move_points[j]][1] = by2;
                    }
                    w *= 0.4;
                }

                w = 0.4;
                for(let j = mid_point + 1;j < move_points.length; j ++){
                    control_points[k][iidx][move_points[j]][0] += w * dx;
                    control_points[k][iidx][move_points[j]][1] += w * dy;
                    if(control_points[k][iidx][move_points[j]][0] > bx2){
                        control_points[k][iidx][move_points[j]][0] = bx2;
                    }
                    if(control_points[k][iidx][move_points[j]][1] > by2){
                        control_points[k][iidx][move_points[j]][1] = by2;
                    }
                    w *= 0.4;
                }


                for(let j = 0; j < move_points.length; j ++){
                    if(j == mid_point){
                        continue;
                    }
                    d3.select("#circle" + k.toString() + "i" + iidx.toString() + "i" + move_points[j].toString())
                        .attr('cx', control_points[k][iidx][move_points[j]][0])
                        .attr('cy', control_points[k][iidx][move_points[j]][1])
                }

                let idx = move_points[0];
                if(calDistance(control_points[k][iidx][idx][0],control_points[k][iidx][idx][1],
                    control_points[k][iidx][(idx + len - 1) % len][0],control_points[k][iidx][(idx + len - 1) % len][1]) > control_points[k][iidx].meandis){
                    move_points.unshift((idx + len - 1) % len);
                    mid_point ++
                }
                idx = move_points[move_points.length - 1];
                if(calDistance(control_points[k][iidx][idx][0],control_points[k][iidx][idx][1],
                    control_points[k][iidx][(idx + 1) % len][0],control_points[k][iidx][(idx + 1) % len][1]) > control_points[k][iidx].meandis){
                    move_points.push((idx + 1) % len);
                }
                 */

                //let drawPathData="";
//
                //for(let j = 0;j < control_points[k].length; j ++){
                //    drawPathData += lineFunction(control_points[k][j]);
                //}
//
                //g.append("path")
                //    .attr('id', "temp_path")
                //    .attr('d', drawPathData)
                //    .attr("fill", "none")
//
                //let tmpPath = d3.select("#temp_path").node()
                //let totLen = tmpPath.getTotalLength()
//
                //let reDrawData = []
                //let pointsnum = totLen
//
                //for(let idx = 0;idx < pointsnum;idx ++){
                //    let p = tmpPath.getPointAtLength(idx)
                //    reDrawData.push([p.x, p.y])
                //}
//
                //console.log("reDrawData:")
                //console.log(reDrawData)
                let reDrawData = ""
                for(let j = 0;j < control_points[k].length; j ++){

                    if(j == iidx){

                        let cur_len = control_points[k][j].length
                        let tmp_pts = []
                        //let s_pts = []

                        // select one or more point for interpolation
                        //for(let p = 1; p >= 1; p --){
                        let q = (jidx - 1 + cur_len) % cur_len
                        editSeg[k].push(q)
                        //s_pts.push([control_points[k][j][q][0], control_points[k][j][q][1]])
                        // }
                        //editSeg[k].push(jidx)
                        //s_pts.push([control_points[k][j][jidx][0], control_points[k][j][jidx][1]])
                        //for(let p = 1; p <= 1; p ++){
                        //    let q = (jidx + p) % cur_len
                        //    s_pts.push([control_points[k][j][q][0], control_points[k][j][q][1]])
                        //}

                        //let spline1 = new BSpline(s_pts, 3)
                        //for(let t = 0; t < 1; t += 0.01){
                        //    // TODO : re-locate neighbor control points around the dragged point
                        //    tmp_pts.push(spline1.calcAt(t))
                        //}

                        /*
                        let ra = 0.1
                        for(let idx = -2;idx <= 2;idx ++){
                            if(idx == 0){
                                continue
                            }
                            let p = tmpPath.getPointAtLength( ra * totLen )
                            let q = (jidx + idx + cur_len) % cur_len
                            ra += 0.2
                            //control_points[k][j][q][0] = p.x
                            //control_points[k][j][q][1] = p.y
                            //d3.select("#circle"+ k.toString() + "i" + j.toString() + "i" + q.toString())
                            //    .attr("cx",control_points[k][j][q][0])
                            //    .attr("cy",control_points[k][j][q][1])
                        }
                        */

                        //let new_points = []

                        //console.log("modify points")
                        //console.log(new_points.length)

                        editSeg[k].sort(function(a,b){
                            return a - b
                        })

                        let tmpDict = {}
                        for(let e = 0; e < editSeg[k].length; e ++){
                            tmpDict[editSeg[k][e]] = 1
                        }

                        let sid
                        if(editSeg[k].length > 0){
                            sid = editSeg[k][0]
                        }
                        else{
                            sid = 0
                        }

                        for(let p = 0; p < cur_len; p ++){
                            // start from sid
                            let cur_idx = (sid + p) % cur_len
                            if(tmpDict.hasOwnProperty(cur_idx)){

                                let s_pts = []
                                s_pts.push([control_points[k][j][cur_idx][0], control_points[k][j][cur_idx][1]])
                                s_pts.push([control_points[k][j][(cur_idx + 1) % cur_len][0], control_points[k][j][(cur_idx + 1) % cur_len][1]])
                                s_pts.push([control_points[k][j][(cur_idx + 2) % cur_len][0], control_points[k][j][(cur_idx + 2) % cur_len][1]])

                                d3.select("svg").append("path")
                                    .attr("id","temp_path")
                                    .attr("d",lineFunction_reDraw(s_pts))
                                    .attr("fill","none")

                                let tmpPath = d3.select("#temp_path").node()
                                let totLen = tmpPath.getTotalLength()

                                for(let p = 0; p <= totLen / 5 ; p ++){
                                    let tmp_p = tmpPath.getPointAtLength(5 * p)
                                    tmp_pts.push([tmp_p.x, tmp_p.y])
                                }

                                d3.select("#temp_path").remove()

                                p ++
                            }
                            else{
                                tmp_pts.push([control_points[k][j][cur_idx][0], control_points[k][j][cur_idx][1]])
                            }
                        }

                        //console.log(tmp_pts)
                        reDrawData += lineFunction(tmp_pts)

                    }
                    else{
                        //console.log(control_points[k][j])
                        reDrawData += lineFunction(control_points[k][j]);
                    }

                }

                that.reDraw(k, that, reDrawData)

                //d3.select("#temp_path").remove()

            }

        }

        function dragended() {

            let execflag = false;
            if(d3.select(this)._groups[0][0].attributes.hasOwnProperty("id")){
                execflag = true;
            }
            if(execflag == false){
                return;
            }

            let tmp_idx = d3.select(this)._groups[0][0].attributes.id.value;
            let isnum = parseInt(tmp_idx[6])

            if(isnum >= 0 && isnum <= 9){

                let iidx = ""
                let jidx = ""

                for(let i = 7;i < tmp_idx.length;i ++){
                    if(tmp_idx[i] == "i"){
                        i ++;
                        while(tmp_idx[i] != "i"){
                            iidx += tmp_idx[i++];
                        }
                        i ++;
                        while(i < tmp_idx.length){
                            jidx += tmp_idx[i++];
                        }
                        break;
                    }
                }

                iidx = parseInt(iidx);
                jidx = parseInt(jidx);

                let Polygon = []
                let len = control_points[k][iidx].length;

                Polygon.push([control_points[k][iidx][(jidx + len - 1) % len][0],control_points[k][iidx][(jidx + len - 1) % len][1]])
                Polygon.push([prepoints[iidx][jidx][0],prepoints[iidx][jidx][1]])
                Polygon.push([control_points[k][iidx][(jidx + 1) % len][0],control_points[k][iidx][(jidx + 1) % len][1]])
                Polygon.push([control_points[k][iidx][jidx][0],control_points[k][iidx][jidx][1]])

                //for(let j = 0 ; j < move_points.length; j ++){
                //    Polygon.push([control_points[k][iidx][move_points[j]][0],control_points[k][iidx][move_points[j]][1]]);
                //}
                //for(let j = move_points.length - 1; j >= 0; j --){
                //    Polygon.push([prepoints[iidx][move_points[j]][0],prepoints[iidx][move_points[j]][1]]);
                //}

                let v3 = control_points[k][iidx][jidx];
                nearpts.push(v3);

                //console.log("after")
                //for(let j = 0;j < nearpts.length; j ++){
                //    console.log(nearpts[j])
                //}

                let vec1 = [nearpts[1][0] - nearpts[0][0],nearpts[1][1] - nearpts[0][1]];
                let vec2 = [nearpts[2][0] - nearpts[0][0],nearpts[2][1] - nearpts[0][1]];
                let is_outer = vec1[0] * vec2[1] - vec2[0] * vec1[1];
                let val = 0;
                if(is_outer <= 0){
                    //console.log("move out")
                    if(iidx == 0){
                        val = 10;
                    }
                }
                else{
                    //console.log("move in")
                    if(iidx > 0){
                        val = 10;
                    }
                }
                // drawPolygon(Polygon,0,0,"red")
                that.fillPolygon(Polygon, k, val)

                //that.drawEnergyField(k);
                //
                //that.updateFinalField(idx,k,1)
            }

        }

        d3.select("#path"+k)
            .attr('id',"path"+k)
            .attr('d',curdata)
            .attr("fill", colors[k])
            .attr('fill-opacity', 0.5)
            .attr('fill-rule',"evenodd")
            .style('stroke', colors[k])
            .style("stroke-width", 1)
            .on('mouseover', function () {
                if(!that.editMode){
                    d3.select(this)
                        .style('stroke', "red")
                        .style("stroke-width", 3);
                }
            })
            .on('mouseout', function () {

                if(!that.editMode){
                    d3.select(this)
                        .style('stroke', colors[k])
                        .style("stroke-width", 1)
                    // .style("stroke-width", 0.5);
                }


            })
            .on('mousedown',function (e){
                if(e.button==2){
                    if(is_selected[k]==false&&!that.editMode){
                        that.editMode=true

                        for(let i = 0;i < 4;i ++){
                            g.append("line")
                                .attr('id',"bounding"+ k.toString() + i.toString())
                                .attr("x1", bounding[i].x)
                                .attr("y1", bounding[i].y)
                                .attr("x2", bounding[(i+1)%4].x)
                                .attr("y2", bounding[(i+1)%4].y)
                                .attr("stroke", "red")
                                .attr("stroke-width", "1px");
                        }
                        for(let i in control_points){
                            if(i == k){
                                continue;
                            }
                            d3.select("#path"+i)
                                .attr('fill-opacity', 0.2)
                        }

                        for(let i = 0;i < control_points[k].length; i ++){
                            for(let j = 0;j < control_points[k][i].length; j ++){
                                g.append("circle")
                                    .attr("id","circle" + k.toString() + "i" + i.toString() + "i" + j.toString())
                                    .attr("cx",control_points[k][i][j][0])
                                    .attr("cy",control_points[k][i][j][1])
                                    .attr("r",3)
                                    .attr("fill",'red')
                                    .attr('fill-opacity', 0.5)
                                    .on("mouseover",function(){
                                        d3.select(this).attr("stroke","red")
                                            .attr("stroke-width",2)
                                    })
                                    .on("mouseout",function(){
                                        d3.select(this).attr("stroke","none")
                                            .attr("stroke-width",1)
                                    })
                                    .call(d3.drag()
                                        .on("start", dragstarted)
                                        .on("drag", dragged)
                                        .on("end", dragended))
                            }
                        }
                        is_selected[k]=true;
                    }

                    else if(that.editMode&&is_selected[k]){
                        for(let i = 0;i < 4;i ++){
                            d3.select("#bounding"+ k.toString() + i.toString()).remove();
                        }
                        for(let i = 0;i < control_points[k].length; i ++){
                            for(let j = 0;j < control_points[k][i].length; j ++){
                                d3.select("#circle" + k.toString() + "i" + i.toString() + "i" + j.toString()).remove();
                            }
                        }
                        for(let i in control_points){
                            if(i == k){
                                continue;
                            }
                            d3.select("#path"+i)
                                .attr('fill-opacity', 0.5)
                        }
                        is_selected[k]=false;
                        that.editMode=false
                    }
                }
            });
    }

    drawOutline(points,color){

        let SetAreas = new Array();

        var lineFunction = d3.line()
            .x(function(d) { return d[0]; })
            .y(function(d) { return d[1]; })
            .curve(d3.curveCardinalClosed);

        let pointpath=lineFunction(points);

        g.append('path')
            .attr('d', pointpath)
            .attr('fill-opacity', 0.5)
            .attr('fill',color)
            .attr('fill-rule',"evenodd");
    }

    drawISOLines(lines, intervals,dx,dy,color) {

        var marginBottomLabel = 0;



        var svg = d3.select("svg")

        for (let i=0;i<lines.length;i++){
            g.append("path")
                .style("fill", "none")
                .style("stroke",color)
                .style("stroke-width", 0.5)
                .style('opacity', 1.0)
                .attr("d", function () {
                    var p = "";
                    p += (d3.line()
                            .x(function (dat) {
                                return dat[0]+dx;
                            })
                            .y(function (dat) {
                                return dat[1]+dy;
                            })
                    )(lines[i])+ "";
                    return p;
                })
                .on('mouseover', function () {
                    d3.select(this)
                        .style('stroke', "red")
                        .style("stroke-width", 3);
                })
                .on('mouseout', function () {
                    d3.select(this)
                        .style('stroke', "black")
                        .style("stroke-width", 0.5);
                });
        }


    }

    calOneISOLine(intervals,k){


            // if(k!="1"){
            //     continue
            // }
            let data=this.catEnergyField[k].finalField
            var isoLines = [];
            isoLines=MarchingSquaresJS
                .isoLines(data,
                    intervals,
                    {
                        polygons: false,
                        linearRing: false,
                        noFrame:true
                    }
                )
            // this.drawISOLines(isoLines,intervals,dx,dy)

        return isoLines[0]
    }

    calISOLine(intervals, fieldData){

        let isoLineDict={}
        for (var k in this.catEnergyField){

            // if(k!="1"){
            //     continue
            // }


            let data=fieldData[k]
            var isoLines = [];
            isoLines=MarchingSquaresJS
                .isoLines(data,
                    intervals,
                    {
                        polygons: false,
                        linearRing: false,
                        noFrame:true
                    }
                )
            // this.drawISOLines(isoLines,intervals,dx,dy)

            isoLineDict[k]=isoLines[0]
        }
        return isoLineDict
    }

    BSplineInterpolate(points){
        let tpoints=[]
        let splinePoints=[]
        let gap=5
        for (let i=0;i<points.length;i++){
            let remainLength=points.length-i

            if(remainLength>gap){
                if(i%gap==0){
                    tpoints.push(points[i])
                }
                if(i>0&&i%(3*gap)==0){
                    var spline = new BSpline(tpoints,3)
                    for(var t = 0.01;t<=1;t+=0.01){
                        var p = spline.calcAt(t);
                        splinePoints.push(p)
                    }
                    tpoints=[]
                    tpoints.push(points[i])
                }
            }
            else{
                if(i%3==0){
                    tpoints.push(points[i])
                }
            }


        }
        var spline = new BSpline(tpoints,3)
        for(var t = 0.01;t<=1;t+=0.01){
            var p = spline.calcAt(t);
            splinePoints.push(p)
        }


        return splinePoints
    }

    normalizeKernel(kernel){
        let sum=0
        for(let i=0;i<kernel.length;i++){
            for(let j=0;j<kernel.length;j++){
                sum+=kernel[i][j]
            }
        }

        for(let i=0;i<kernel.length;i++){
            for(let j=0;j<kernel.length;j++){
                kernel[i][j]=kernel[i][j]/sum
            }
        }
        return kernel
    }

    getGaussianKernel(theta,kernelsize){
        let scale=1
        let kernel=[]
        for (let i=0;i<kernelsize;i++){
            kernel.push([])
            for (let j=0;j<kernelsize;j++){
                kernel[i].push(0)
            }
        }
        let anchor=parseInt(kernelsize/2)/scale
        let C=1/(Math.PI*2*theta*theta)

        for (let i=0;i<kernelsize;i++){
            for (let j=0;j<kernelsize;j++){
                let ny=i/scale
                let nx=j/scale
                let y=Math.pow(ny-anchor,2)
                let x=Math.pow(nx-anchor,2)
                kernel[i][j]=C*Math.exp(-(x*x+y*y)/(2*theta*theta))
            }
        }

        kernel=this.normalizeKernel(kernel)
        return kernel
    }

    checkSingularPoint(k,x,y){
        let delta=1
        let field=this.catEnergyField[k].finalField
        let isSingular=true
        //right
        if(x+delta<this.catEnergyField[k].width){
            if(field[y][x+delta]>0){
                isSingular=false
            }
        }
        //left
        if(x-delta>0){
            if(field[y][x-delta]>0){
                isSingular=false
            }
        }
        //up
        if(y-delta>0){
            if(field[y-delta][x]>0){
                isSingular=false
            }
        }
        //down
        if(y+delta<this.catEnergyField[k].height){
            if(field[y+delta][x]>0){
                isSingular=false
            }
        }
        //right-top
        if(x+delta<this.catEnergyField[k].width&&y-delta>0){
            if(field[y-delta][x+delta]>0){
                isSingular=false
            }
        }
        //right-bottom
        if(x+delta<this.catEnergyField[k].width&&y+delta<this.catEnergyField[k].height){
            if(field[y+delta][x+delta]>0){
                isSingular=false
            }
        }
        //left-top
        if(x-delta>0&&y-delta>0){
            if(field[y-delta][x-delta]>0){
                isSingular=false
            }
        }
        //left-bottom
        if(x-delta>0&&y+delta<this.catEnergyField[k].height){
            if(field[y+delta][x-delta]>0){
                isSingular=false
            }
        }

        return isSingular
    }

    fillCrossingEdge_Part(edges){


        for (var k in this.catEnergyField){
            this.catEnergyField[k].edgeCrossingList=[]
        }

        for(let i=0;i<edges.length;i++){
            let cat1=edges[i].cat
            let start1=this.pointData[edges[i].start]
            let end1=this.pointData[edges[i].end]
            let linesToCheck1=[]
            if(this.edges[i].virtrual && edges[i].virtrualNodes.length > 0){
                linesToCheck1.push([{x:start1.x,y:start1.y},{x:edges[i].virtrualNodes[0][0],y:edges[i].virtrualNodes[0][1]}])
                for (let v=0;v<edges[i].virtrualNodes.length;v++){
                    if(v+1<edges[i].virtrualNodes.length){
                        linesToCheck1.push([{x:edges[i].virtrualNodes[v][0],y:edges[i].virtrualNodes[v][1]},{x:edges[i].virtrualNodes[v+1][0],y:edges[i].virtrualNodes[v+1][1]}])
                    }
                }
                let vlength=edges[i].virtrualNodes.length
                linesToCheck1.push([{x:edges[i].virtrualNodes[vlength-1][0],y:edges[i].virtrualNodes[vlength-1][1]},{x:end1.x,y:end1.y}])
            }
            else{
                linesToCheck1.push([{x:start1.x,y:start1.y},{x:end1.x,y:end1.y}])
            }
            for(let j=0;j<this.edges.length;j++){
                let cat2=this.edges[j].cat
                if(cat1==cat2){
                    continue
                }
                let start2=this.pointData[this.edges[j].start]
                let end2=this.pointData[this.edges[j].end]
                let linesToCheck2=[]
                if(this.edges[j].virtrual && this.edges[j].virtrualNodes.length > 0){
                    linesToCheck2.push([{x:start2.x,y:start2.y},{x:this.edges[j].virtrualNodes[0][0],y:this.edges[j].virtrualNodes[0][1]}])
                    for (let v=0;v<this.edges[j].virtrualNodes.length;v++){
                        if(v+1<this.edges[j].virtrualNodes.length){
                            linesToCheck2.push([{x:this.edges[j].virtrualNodes[v][0],y:this.edges[j].virtrualNodes[v][1]},{x:this.edges[j].virtrualNodes[v+1][0],y:this.edges[j].virtrualNodes[v+1][1]}])
                        }
                    }
                    let vlength=this.edges[j].virtrualNodes.length
                    linesToCheck2.push([{x:this.edges[j].virtrualNodes[vlength-1][0],y:this.edges[j].virtrualNodes[vlength-1][1]},{x:end2.x,y:end2.y}])
                }
                else{
                    linesToCheck2.push([{x:start2.x,y:start2.y},{x:end2.x,y:end2.y}])
                }

                for(let l1=0;l1<linesToCheck1.length;l1++){
                    let start1=linesToCheck1[l1][0]
                    let end1=linesToCheck1[l1][1]
                    for (let l2=0;l2<linesToCheck2.length;l2++){
                        let start2=linesToCheck2[l2][0]
                        let end2=linesToCheck2[l2][1]
                        let crossInfo=this.checkEdgeCrossing(start1,end1,start2,end2)
                        if(crossInfo[0]){
                            this.catEnergyField[cat1].edgeCrossingList.push([crossInfo[1],i,j,linesToCheck1[l1],linesToCheck2[l2]])
                            this.catEnergyField[cat2].edgeCrossingList.push([crossInfo[1],j,i,linesToCheck2[l2],linesToCheck1[l1]])
                        }

                    }
                }
            }
        }

        let newFieldDict={}

        for(var k in this.catEnergyField){

            newFieldDict[k]=this.catEnergyField[k].finalField
            let crossingPoints=this.catEnergyField[k].edgeCrossingList
            let fillPoints=[]
            let fillArea=[]
            let stopGap=5
            //var beginTime1 = +new Date()
            for(let i=0;i<crossingPoints.length;i++){
                fillArea.push([])
                let crosspoint=crossingPoints[i][0]
                let thisid=crossingPoints[i][1]
                let otherid=crossingPoints[i][2]
                let line=crossingPoints[i][3]
                let crossline=crossingPoints[i][4]
                let thiscat=k
                let othercat=this.edges[otherid].cat
                let flag=false
                let newpoints=[]

                // if(k=="2"&&othercat=="0"&&i==4){
                //     flag=true
                // }

                //if(k=="0"){
                // drawLine([line[0].x,line[0].y],[line[1].x,line[1].y],"black")
                // drawLine([crossline[0].x,crossline[0].y],[crossline[1].x,crossline[1].y],"black")

                //}


                let dl=0
                let lineLength=calDistance(line[0].x,line[0].y,line[1].x,line[1].y)
                let vec1=[line[1].x-line[0].x,line[1].y-line[0].y]

                let vec2=[vec1[1],-1*vec1[0]]
                let vec3=[crossline[1].x-crossline[0].x,crossline[1].y-crossline[0].y]

                let linedirvec=normalizeVec(vec1)
                let normdirvec=normalizeVec(vec3)
                let step=0.5
                // console.log(lineLength)


                let topBoundPoints=[]
                let bottomBoundPoints=[]
                let lastTop=[]
                let lastBottom=[]
                let rightstop=false
                let topstop=false
                let bottomstop=false

                //right
                while(dl<edgeR1){

                    if(rightstop){
                        break
                    }
                    let newanchor1=[crosspoint.x+dl*normdirvec[0],crosspoint.y+dl*normdirvec[1]]

                    let disalongline=0

                    let topfind=false
                    let bottomfind=false

                    let topFindPoints=[]
                    let bottomFindPoints=[]
                    while(disalongline<lineLength/2){
                        //top
                        if(!topfind&&!rightstop&&!topstop){
                            let newpointtop=[newanchor1[0]+linedirvec[0]*disalongline,newanchor1[1]+linedirvec[1]*disalongline]
                            let newxtop=Math.floor((newpointtop[0]-this.catEnergyField[k].x)/pixelGroup)
                            let newytop=Math.floor((newpointtop[1]-this.catEnergyField[k].y)/pixelGroup)

                            let otherx=Math.floor((newpointtop[0]-this.catEnergyField[othercat].x)/pixelGroup)
                            let othery=Math.floor((newpointtop[1]-this.catEnergyField[othercat].y)/pixelGroup)
                            // drawRect(newpointtop[0],newpointtop[1],1,1,"red")
                            if(otherx>0&&otherx<this.catEnergyField[othercat].width&&othery>0&&othery<this.catEnergyField[othercat].height){
                                if(this.catEnergyField[othercat].pointBarrierMap[othery][otherx]==3){
                                    rightstop=true
                                    break
                                }
                            }

                            if(newxtop>0&&newxtop<this.catEnergyField[k].width&&newytop>0&&newytop<this.catEnergyField[k].height&&this.catEnergyField[k].finalField[newytop][newxtop]>0){
                                // if(flag){
                                //     drawRect(newpointtop[0],newpointtop[1],0.2,0.2,"red")
                                //     console.log()
                                // }
                                topfind=true
                                if(this.catEnergyField[k].edgeBarrierMap[newytop][newxtop]!=4){
                                    if(lastTop.length==0){
                                        topBoundPoints.push([newxtop,newytop])
                                        lastTop=[newxtop,newytop]
                                    }
                                    else{
                                        if(Math.abs(lastTop[0]-newxtop)<=stopGap&&Math.abs(lastTop[1]-newytop)<=stopGap){

                                            lastTop=[newxtop,newytop]
                                            topBoundPoints.push([newxtop,newytop])
                                        }
                                        else{
                                            // if(flag){
                                            //     drawRect(newpointtop[0],newpointtop[1],0.2,0.2,"red")
                                            //     drawRect(lastTop[0]+this.catEnergyField[k].x,lastTop[1]+this.catEnergyField[k].y,0.2,0.2,"blue")
                                            //     console.log()
                                            // }

                                            // drawRect(newpointtop[0],newpointtop[1],0.2,0.2,"blue")
                                            // console.log("1")
                                            topstop=true
                                        }
                                    }
                                }
                                else{
                                    topBoundPoints.push([newxtop,newytop])
                                    // lastTop=[newxtop,newytop]
                                }
                            }

                            /*                            if(!topstop&&!rightstop){
                                                            topFindPoints.push([newpointtop[0],newpointtop[1],othercat])
                                                            if(topfind){
                                                                fillPoints=fillPoints.concat(topFindPoints)
                                                                topFindPoints=[]
                                                            }
                                                        }*/
                        }

                        //bottom
                        if(!bottomfind&&!rightstop&&!bottomstop){
                            let newpointbottom=[newanchor1[0]-linedirvec[0]*disalongline,newanchor1[1]-linedirvec[1]*disalongline]
                            let newxbottom=Math.floor((newpointbottom[0]-this.catEnergyField[k].x)/pixelGroup)
                            let newybottom=Math.floor((newpointbottom[1]-this.catEnergyField[k].y)/pixelGroup)

                            // drawRect(newpointbottom[0],newpointbottom[1],1,1,"red")

                            let otherx=Math.floor((newpointbottom[0]-this.catEnergyField[othercat].x)/pixelGroup)
                            let othery=Math.floor((newpointbottom[1]-this.catEnergyField[othercat].y)/pixelGroup)
                            // drawRect(newpointtop[0],newpointtop[1],1,1,"red")
                            if(otherx>0&&otherx<this.catEnergyField[othercat].width&&othery>0&&othery<this.catEnergyField[othercat].height){
                                if(this.catEnergyField[othercat].pointBarrierMap[othery][otherx]==3){
                                    rightstop=true
                                    break
                                }
                            }


                            if(newxbottom>0&&newxbottom<this.catEnergyField[k].width&&newybottom>0&&newybottom<this.catEnergyField[k].height&&this.catEnergyField[k].finalField[newybottom][newxbottom]>0){
                                // drawRect(newpointbottom[0],newpointbottom[1],1,1,"red")
                                // drawRect(newpointbottom[0],newpointbottom[1],0.2,0.2,"red")

                                bottomfind=true
                                if(this.catEnergyField[k].edgeBarrierMap[newybottom][newxbottom]!=4){
                                    if(lastBottom.length==0){
                                        bottomBoundPoints.push([newxbottom,newybottom])
                                        lastBottom=[newxbottom,newybottom]
                                    }
                                    else{
                                        if(Math.abs(lastBottom[0]-newxbottom)<=stopGap&&Math.abs(lastBottom[1]-newybottom)<=stopGap){

                                            lastBottom=[newxbottom,newybottom]
                                            bottomBoundPoints.push([newxbottom,newybottom])

                                        }
                                        else{
                                            // if(flag){
                                            //     drawRect(newpointbottom[0],newpointbottom[1],0.2,0.2,"red")
                                            //     drawRect(lastBottom[0]+this.catEnergyField[k].x,lastBottom[1]+this.catEnergyField[k].y,0.2,0.2,"blue")
                                            //     console.log()
                                            // }

                                            // drawRect(newpointtop[0],newpointtop[1],0.2,0.2,"blue")
                                            // console.log("1")
                                            bottomstop=true
                                        }
                                    }
                                }
                                else{
                                    bottomBoundPoints.push([newxbottom,newybottom])
                                    // lastBottom=[newxbottom,newybottom]
                                }

                            }
                            /*                            if(!bottomstop&&!rightstop){
                                                            bottomFindPoints.push([newpointbottom[0],newpointbottom[1],othercat])
                                                            if(bottomfind){
                                                                fillPoints=fillPoints.concat(bottomFindPoints)
                                                                bottomFindPoints=[]
                                                            }
                                                        }*/

                        }

                        if(topfind&&bottomfind||topstop&&bottomstop){
                            break
                        }

                        disalongline+=step

                    }

                    dl+=step
                }

                let fillPolyPoints=[[Math.floor((crosspoint.x-this.catEnergyField[k].x)/pixelGroup),Math.floor((crosspoint.y-this.catEnergyField[k].y)/pixelGroup)]]
                for(let p=0;p<topBoundPoints.length;p++){
                    fillPolyPoints.push(topBoundPoints[p])
                }

                for(let p=bottomBoundPoints.length-1;p>=0;p--){
                    fillPolyPoints.push(bottomBoundPoints[p])
                }

                fillArea[i].push(fillPolyPoints)

                topBoundPoints=[]
                bottomBoundPoints=[]
                lastTop=[]
                lastBottom=[]
                let leftstop=false
                topstop=false
                bottomstop=false
                dl=0
                //left
                while(dl<edgeR1){

                    if(leftstop){
                        break
                    }
                    let newanchor2=[crosspoint.x-dl*normdirvec[0],crosspoint.y-dl*normdirvec[1]]

                    let disalongline=0

                    let topfind=false
                    let bottomfind=false

                    let topFindPoints=[]
                    let bottomFindPoints=[]


                    while(disalongline<lineLength/2){
                        //top
                        if(!topfind&&!leftstop&&!topstop){
                            let newpointtop=[newanchor2[0]+linedirvec[0]*disalongline,newanchor2[1]+linedirvec[1]*disalongline]
                            let newxtop=Math.floor((newpointtop[0]-this.catEnergyField[k].x)/pixelGroup)
                            let newytop=Math.floor((newpointtop[1]-this.catEnergyField[k].y)/pixelGroup)

                            let otherx=Math.floor((newpointtop[0]-this.catEnergyField[othercat].x)/pixelGroup)
                            let othery=Math.floor((newpointtop[1]-this.catEnergyField[othercat].y)/pixelGroup)
                            // drawRect(newpointtop[0],newpointtop[1],1,1,"red")
                            if(otherx>0&&otherx<this.catEnergyField[othercat].width&&othery>0&&othery<this.catEnergyField[othercat].height){
                                if(this.catEnergyField[othercat].pointBarrierMap[othery][otherx]==3){
                                    leftstop=true
                                    break
                                }
                            }
                            if(newxtop>0&&newxtop<this.catEnergyField[k].width&&newytop>0&&newytop<this.catEnergyField[k].height&&this.catEnergyField[k].finalField[newytop][newxtop]>0){
                                // drawRect(newpointtop[0],newpointtop[1],0.2,0.2,"red")
                                topfind=true
                                if(this.catEnergyField[k].edgeBarrierMap[newytop][newxtop]!=4){
                                    if(lastTop.length==0){
                                        topBoundPoints.push([newxtop,newytop])
                                        lastTop=[newxtop,newytop]
                                    }
                                    else{
                                        if(Math.abs(lastTop[0]-newxtop)<=stopGap&&Math.abs(lastTop[1]-newytop)<=stopGap){

                                            lastTop=[newxtop,newytop]
                                            topBoundPoints.push([newxtop,newytop])
                                        }
                                        else{
                                            // if(flag){
                                            //     drawRect(newpointtop[0],newpointtop[1],0.2,0.2,"red")
                                            //     drawRect(lastTop[0]+this.catEnergyField[k].x,lastTop[1]+this.catEnergyField[k].y,0.2,0.2,"blue")
                                            //     console.log()
                                            // }

                                            // drawRect(newpointtop[0],newpointtop[1],0.2,0.2,"blue")
                                            // console.log("1")
                                            topstop=true
                                        }
                                    }
                                }
                                else{
                                    topBoundPoints.push([newxtop,newytop])
                                    // lastTop=[newxtop,newytop]
                                }
                            }

                            /*                            if(!topstop&&!leftstop){
                                                            topFindPoints.push([newpointtop[0],newpointtop[1],othercat])
                                                            if(topfind){
                                                                fillPoints=fillPoints.concat(topFindPoints)
                                                                topFindPoints=[]
                                                            }
                                                        }*/
                        }

                        //bottom
                        if(!bottomfind&&!leftstop&&!bottomstop){
                            let newpointbottom=[newanchor2[0]-linedirvec[0]*disalongline,newanchor2[1]-linedirvec[1]*disalongline]
                            let newxbottom=Math.floor((newpointbottom[0]-this.catEnergyField[k].x)/pixelGroup)
                            let newybottom=Math.floor((newpointbottom[1]-this.catEnergyField[k].y)/pixelGroup)

                            // drawRect(newpointbottom[0],newpointbottom[1],1,1,"red")

                            let otherx=Math.floor((newpointbottom[0]-this.catEnergyField[othercat].x)/pixelGroup)
                            let othery=Math.floor((newpointbottom[1]-this.catEnergyField[othercat].y)/pixelGroup)
                            // drawRect(newpointtop[0],newpointtop[1],1,1,"red")
                            if(otherx>0&&otherx<this.catEnergyField[othercat].width&&othery>0&&othery<this.catEnergyField[othercat].height){
                                if(this.catEnergyField[othercat].pointBarrierMap[othery][otherx]==3){
                                    leftstop=true
                                    break
                                }
                            }
                            if(newxbottom>0&&newxbottom<this.catEnergyField[k].width&&newybottom>0&&newybottom<this.catEnergyField[k].height&&this.catEnergyField[k].finalField[newybottom][newxbottom]>0){
                                // drawRect(newpointbottom[0],newpointbottom[1],1,1,"red")
                                // drawRect(newpointbottom[0],newpointbottom[1],0.2,0.2,"red")

                                bottomfind=true
                                if(this.catEnergyField[k].edgeBarrierMap[newybottom][newxbottom]!=4){
                                    if(lastBottom.length==0){
                                        bottomBoundPoints.push([newxbottom,newybottom])
                                        lastBottom=[newxbottom,newybottom]
                                    }
                                    else{
                                        if(Math.abs(lastBottom[0]-newxbottom)<=stopGap&&Math.abs(lastBottom[1]-newybottom)<=stopGap){

                                            lastBottom=[newxbottom,newybottom]
                                            bottomBoundPoints.push([newxbottom,newybottom])
                                        }
                                        else{
                                            // if(flag){
                                            //     drawRect(newpointbottom[0],newpointbottom[1],0.2,0.2,"red")
                                            //     drawRect(lastBottom[0]+this.catEnergyField[k].x,lastBottom[1]+this.catEnergyField[k].y,0.2,0.2,"blue")
                                            //     console.log()
                                            // }

                                            // drawRect(newpointtop[0],newpointtop[1],0.2,0.2,"blue")
                                            // console.log("1")
                                            bottomstop=true
                                        }
                                    }
                                }
                                else{
                                    bottomBoundPoints.push([newxbottom,newybottom])
                                    // lastBottom=[newxbottom,newybottom]
                                }
                            }
                            /*                            if(!bottomstop&&!leftstop){
                                                            bottomFindPoints.push([newpointbottom[0],newpointbottom[1],othercat])
                                                            if(bottomfind){
                                                                fillPoints=fillPoints.concat(bottomFindPoints)
                                                                bottomFindPoints=[]
                                                            }
                                                        }*/
                        }

                        if(topfind&&bottomfind||topstop&&bottomstop){
                            break
                        }

                        disalongline+=step

                    }

                    dl+=step
                }


                fillPolyPoints=[[Math.floor((crosspoint.x-this.catEnergyField[k].x)/pixelGroup),Math.floor((crosspoint.y-this.catEnergyField[k].y)/pixelGroup)]]
                for(let p=0;p<topBoundPoints.length;p++){
                    fillPolyPoints.push(topBoundPoints[p])
                }

                for(let p=bottomBoundPoints.length-1;p>=0;p--){
                    fillPolyPoints.push(bottomBoundPoints[p])
                }

                fillArea[i].push(fillPolyPoints)


                // drawRect(crosspoint.x,crosspoint.y,1,1,"red")
            }
            //var endTime1 = +new Date()
            //console.log("cat " + k + " loop1 " + (endTime1 - beginTime1) + " ms")
            // console.log(fillArea)

            /*            for(let i=0;i<fillPoints.length;i++){
                            let realx=fillPoints[i][0]
                            let realy=fillPoints[i][1]
                            let othercat=fillPoints[i][2]
                            let relativex=Math.floor(realx-this.catEnergyField[k].x)
                            let relativey=Math.floor(realy-this.catEnergyField[k].y)
                            let relativeotherx=Math.floor(realx-this.catEnergyField[othercat].x)
                            let relativeothery=Math.floor(realy-this.catEnergyField[othercat].y)
                            if(relativeotherx>0&&relativeotherx<this.catEnergyField[othercat].width&&relativeothery>0&&relativeothery<this.catEnergyField[othercat].height){
                                if(this.catEnergyField[othercat].finalField[relativeothery][relativeotherx]>0){
                                    // drawRect(realx,realy,0.2,0.2,"red")
                                    newFieldDict[k][relativey][relativex]=this.catEnergyField[k].field[relativey][relativex]
                                }
                            }
                        }*/

            //var beginTime2 = +new Date()

            //console.log("fill area: ")
            //console.log(fillArea)

            for (let i=0;i<fillArea.length;i++){
                //let thisid=crossingPoints[i][1]
                let otherid=crossingPoints[i][2]
                //let thiscat=this.edges[thisid].cat
                let othercat=this.edges[otherid].cat
                let dx=this.catEnergyField[k].x
                let dy=this.catEnergyField[k].y

                //let startx=Math.floor((this.edges[thisid].x-edgeR1-this.catEnergyField[k].x)/pixelGroup)
                //let endx=Math.ceil((this.edges[thisid].x+this.edges[thisid].width+edgeR1-this.catEnergyField[k].x)/pixelGroup)
                //let starty=Math.floor((this.edges[thisid].y-edgeR1-this.catEnergyField[k].y)/pixelGroup)
                //let endy=Math.ceil((this.edges[thisid].y+this.edges[thisid].height+edgeR1-this.catEnergyField[k].y)/pixelGroup)
//
                //startx = Math.max(0, startx)
                //endx = Math.min(this.catEnergyField[k].width, endx)
                //starty = Math.max(0, starty)
                //endy = Math.min(this.catEnergyField[k].height, endy)

                for(let a = 0; a < fillArea[i].length; a ++){
                    //if(a==0){
                    for(let b = 0; b < fillArea[i][a].length; b ++){
                        fillArea[i][a][b][0] = fillArea[i][a][b][0] * pixelGroup + dx
                        fillArea[i][a][b][1] = fillArea[i][a][b][1] * pixelGroup + dy
                    }
                    //    d3.select('g').append("path")
                    //        .attr('d',lineFunction(fillArea[i][a]))
                    //        .attr("fill", 'none')
                    //        .style('stroke', "black")
                    //        .style("stroke-width", 1)
                    //        .on('mouseover', function () {
                    //            d3.select(this)
                    //                .style('stroke', "red")
                    //                .style("stroke-width", 2);
                    //        })
                    //        .on('mouseout', function () {
                    //            d3.select(this)
                    //                .style('stroke', "black")
                    //                .style("stroke-width", 1);
                    //        });

                    //}

                    this.fillPolygonForEdge(fillArea[i][a], k, newFieldDict, othercat)
                }


                /*
                for(let y=starty;y<endy;y++){
                    for (let x=startx;x<endx;x++){
                        let realx=x*pixelGroup+this.catEnergyField[k].x
                        let realy=y*pixelGroup+this.catEnergyField[k].y

                        let relativeotherx=Math.floor((realx-this.catEnergyField[othercat].x)/pixelGroup)
                        let relativeothery=Math.floor((realy-this.catEnergyField[othercat].y)/pixelGroup)

                        if(relativeotherx>0&&relativeotherx<this.catEnergyField[othercat].width&&relativeothery>0&&relativeothery<this.catEnergyField[othercat].height){
                            // if(this.catEnergyField[k].finalField[y][x]==0&&this.catEnergyField[k].edgeBarrierMap[y][x]>0&&this.catEnergyField[othercat].finalField[relativeothery][relativeotherx]>0){
                            if(this.catEnergyField[k].finalField[y][x]==0&&this.catEnergyField[k].edgeBarrierMap[y][x]>0){
                                for(let a=0;a<fillArea[i].length;a++){
                                    //let fillPolygon=fillArea[i][a].map((val)=>{return {x:val[0],y:val[1]}})
                                    //for(let b=0;b < fillPolygon.length; b ++){
                                    //    d3.select('g').append('circle')
                                    //        .attr('cx', fillPolygon[i].x)
                                    //        .attr('cy', fillPolygon[i].y)
                                    //        .attr('r',1)
                                    //        .attr('fill','red')
                                    //}
                                    let intersect=IsoInsideTest([x, y],fillArea[i][a])
                                    //let intersect=IntersectionQuery.pointInPolygon({x:x,y:y},fillPolygon)
                                    if(intersect){
                                        newFieldDict[k][y][x]=this.catEnergyField[k].field[y][x]

                                    }
                                }
                            }
                        }


                    }
                }
                */


                //for(let a=0;a<fillArea[i].length;a++){
//
                //    // if(k=="0"){
                //    // drawPolygon(fillArea[i][a],dx,dy,"red")
                //    // }
                //}




            }
            //var endTime2 = +new Date()
            //console.log("cat " + k + " loop2 " + (endTime2 - beginTime2) + " ms")
            //var endTime = +new Date()
            //console.log("cat " + k + " fill one edge mean: " + (endTime - beginTime) / crossingPoints.length + "ms")
        }



        for(var k in this.catEnergyField){
            this.catEnergyField[k].finalField=newFieldDict[k]
        }
    }

    fillCrossingEdge(){

        //return
        for (var k in this.catEnergyField){
            this.catEnergyField[k].edgeCrossingList=[]
        }

        for(let i=0;i<this.edges.length;i++){
            let cat1=this.edges[i].cat
            let start1=this.pointData[this.edges[i].start]
            let end1=this.pointData[this.edges[i].end]
            let linesToCheck1=[]
            if(this.edges[i].virtrual){
                linesToCheck1.push([{x:start1.x,y:start1.y},{x:this.edges[i].virtrualNodes[0][0],y:this.edges[i].virtrualNodes[0][1]}])
                for (let v=0;v<this.edges[i].virtrualNodes.length;v++){
                    if(v+1<this.edges[i].virtrualNodes.length){
                        linesToCheck1.push([{x:this.edges[i].virtrualNodes[v][0],y:this.edges[i].virtrualNodes[v][1]},{x:this.edges[i].virtrualNodes[v+1][0],y:this.edges[i].virtrualNodes[v+1][1]}])
                    }
                }
                let vlength=this.edges[i].virtrualNodes.length
                linesToCheck1.push([{x:this.edges[i].virtrualNodes[vlength-1][0],y:this.edges[i].virtrualNodes[vlength-1][1]},{x:end1.x,y:end1.y}])
            }
            else{
                linesToCheck1.push([{x:start1.x,y:start1.y},{x:end1.x,y:end1.y}])
            }
            for(let j=i+1;j<this.edges.length;j++){
                let cat2=this.edges[j].cat
                if(cat1==cat2){
                    continue
                }
                let start2=this.pointData[this.edges[j].start]
                let end2=this.pointData[this.edges[j].end]
                let linesToCheck2=[]
                if(this.edges[j].virtrual){
                    linesToCheck2.push([{x:start2.x,y:start2.y},{x:this.edges[j].virtrualNodes[0][0],y:this.edges[j].virtrualNodes[0][1]}])
                    for (let v=0;v<this.edges[j].virtrualNodes.length;v++){
                        if(v+1<this.edges[j].virtrualNodes.length){
                            linesToCheck2.push([{x:this.edges[j].virtrualNodes[v][0],y:this.edges[j].virtrualNodes[v][1]},{x:this.edges[j].virtrualNodes[v+1][0],y:this.edges[j].virtrualNodes[v+1][1]}])
                        }
                    }
                    let vlength=this.edges[j].virtrualNodes.length
                    linesToCheck2.push([{x:this.edges[j].virtrualNodes[vlength-1][0],y:this.edges[j].virtrualNodes[vlength-1][1]},{x:end2.x,y:end2.y}])
                }
                else{
                    linesToCheck2.push([{x:start2.x,y:start2.y},{x:end2.x,y:end2.y}])
                }

                for(let l1=0;l1<linesToCheck1.length;l1++){
                    let start1=linesToCheck1[l1][0]
                    let end1=linesToCheck1[l1][1]
                    for (let l2=0;l2<linesToCheck2.length;l2++){
                        let start2=linesToCheck2[l2][0]
                        let end2=linesToCheck2[l2][1]
                        let crossInfo=this.checkEdgeCrossing(start1,end1,start2,end2)
                        if(crossInfo[0]){
                            this.catEnergyField[cat1].edgeCrossingList.push([crossInfo[1],i,j,linesToCheck1[l1],linesToCheck2[l2]])
                            this.catEnergyField[cat2].edgeCrossingList.push([crossInfo[1],j,i,linesToCheck2[l2],linesToCheck1[l1]])
                        }

                    }
                }
            }
        }


        let newFieldDict={}

        for(var k in this.catEnergyField){

            newFieldDict[k]=this.catEnergyField[k].finalField
            let crossingPoints=this.catEnergyField[k].edgeCrossingList
            let fillPoints=[]
            let fillArea=[]
            let stopGap=5
            //var beginTime1 = +new Date()
            for(let i=0;i<crossingPoints.length;i++){
                fillArea.push([])
                let crosspoint=crossingPoints[i][0]
                let thisid=crossingPoints[i][1]
                let otherid=crossingPoints[i][2]
                let line=crossingPoints[i][3]
                let crossline=crossingPoints[i][4]
                let thiscat=k
                // let othercat=this.edges[otherid].cat
                let flag=false
                let newpoints=[]

                // if(k=="2"&&othercat=="0"&&i==4){
                //     flag=true
                // }

                //if(k=="0"){
                    // drawLine([line[0].x,line[0].y],[line[1].x,line[1].y],"black")
                    // drawLine([crossline[0].x,crossline[0].y],[crossline[1].x,crossline[1].y],"black")

                //}


                let dl=0
                let lineLength=calDistance(line[0].x,line[0].y,line[1].x,line[1].y)
                let vec1=[line[1].x-line[0].x,line[1].y-line[0].y]

                let vec2=[vec1[1],-1*vec1[0]]
                let vec3=[crossline[1].x-crossline[0].x,crossline[1].y-crossline[0].y]

                let linedirvec=normalizeVec(vec1)
                let normdirvec=normalizeVec(vec3)
                let step=0.5
                // console.log(lineLength)


                let topBoundPoints=[]
                let bottomBoundPoints=[]
                let lastTop=[]
                let lastBottom=[]
                let rightstop=false
                let topstop=false
                let bottomstop=false

                //right
                while(dl<edgeR1){

                    if(rightstop){
                        break
                    }
                    let newanchor1=[crosspoint.x+dl*normdirvec[0],crosspoint.y+dl*normdirvec[1]]

                    let disalongline=0

                    let topfind=false
                    let bottomfind=false

                    let topFindPoints=[]
                    let bottomFindPoints=[]
                    while(disalongline<lineLength/2){
                        //top
                        if(!topfind&&!rightstop&&!topstop){
                            let newpointtop=[newanchor1[0]+linedirvec[0]*disalongline,newanchor1[1]+linedirvec[1]*disalongline]
                            let newxtop=Math.floor((newpointtop[0]-this.catEnergyField[k].x)/pixelGroup)
                            let newytop=Math.floor((newpointtop[1]-this.catEnergyField[k].y)/pixelGroup)

                            for (var k2 in this.catEdgeDict){
                                let othercat=k2
                                let otherx=Math.floor((newpointtop[0]-this.catEnergyField[othercat].x)/pixelGroup)
                                let othery=Math.floor((newpointtop[1]-this.catEnergyField[othercat].y)/pixelGroup)
                                // drawRect(newpointtop[0],newpointtop[1],1,1,"red")
                                if(otherx>0&&otherx<this.catEnergyField[othercat].width&&othery>0&&othery<this.catEnergyField[othercat].height){
                                    if(this.catEnergyField[othercat].pointBarrierMap[othery][otherx]==3){
                                        rightstop=true
                                        break
                                    }
                                }
                            }


                            if(newxtop>0&&newxtop<this.catEnergyField[k].width&&newytop>0&&newytop<this.catEnergyField[k].height&&this.catEnergyField[k].finalField[newytop][newxtop]>0){
                                // if(flag){
                                //     drawRect(newpointtop[0],newpointtop[1],0.2,0.2,"red")
                                //     console.log()
                                // }
                                topfind=true
                                if(this.catEnergyField[k].edgeBarrierMap[newytop][newxtop]!=4){
                                    if(lastTop.length==0){
                                        topBoundPoints.push([newxtop,newytop])
                                        lastTop=[newxtop,newytop]
                                    }
                                    else{
                                        if(Math.abs(lastTop[0]-newxtop)<=stopGap&&Math.abs(lastTop[1]-newytop)<=stopGap){

                                            lastTop=[newxtop,newytop]
                                            topBoundPoints.push([newxtop,newytop])
                                        }
                                        else{
                                            // if(flag){
                                            //     drawRect(newpointtop[0],newpointtop[1],0.2,0.2,"red")
                                            //     drawRect(lastTop[0]+this.catEnergyField[k].x,lastTop[1]+this.catEnergyField[k].y,0.2,0.2,"blue")
                                            //     console.log()
                                            // }

                                            // drawRect(newpointtop[0],newpointtop[1],0.2,0.2,"blue")
                                            // console.log("1")
                                            topstop=true
                                        }
                                    }
                                }
                                else{
                                    topBoundPoints.push([newxtop,newytop])
                                    // lastTop=[newxtop,newytop]
                                }
                            }

                            /*                            if(!topstop&&!rightstop){
                                                            topFindPoints.push([newpointtop[0],newpointtop[1],othercat])
                                                            if(topfind){
                                                                fillPoints=fillPoints.concat(topFindPoints)
                                                                topFindPoints=[]
                                                            }
                                                        }*/
                        }

                        //bottom
                        if(!bottomfind&&!rightstop&&!bottomstop){
                            let newpointbottom=[newanchor1[0]-linedirvec[0]*disalongline,newanchor1[1]-linedirvec[1]*disalongline]
                            let newxbottom=Math.floor((newpointbottom[0]-this.catEnergyField[k].x)/pixelGroup)
                            let newybottom=Math.floor((newpointbottom[1]-this.catEnergyField[k].y)/pixelGroup)

                            // drawRect(newpointbottom[0],newpointbottom[1],1,1,"red")

                            for (var k2 in this.catEdgeDict) {
                                let othercat = k2
                                let otherx=Math.floor((newpointbottom[0]-this.catEnergyField[othercat].x)/pixelGroup)
                                let othery=Math.floor((newpointbottom[1]-this.catEnergyField[othercat].y)/pixelGroup)
                                // drawRect(newpointtop[0],newpointtop[1],1,1,"red")
                                if(otherx>0&&otherx<this.catEnergyField[othercat].width&&othery>0&&othery<this.catEnergyField[othercat].height){
                                    if(this.catEnergyField[othercat].pointBarrierMap[othery][otherx]==3){
                                        rightstop=true
                                        break
                                    }
                                }
                            }



                            if(newxbottom>0&&newxbottom<this.catEnergyField[k].width&&newybottom>0&&newybottom<this.catEnergyField[k].height&&this.catEnergyField[k].finalField[newybottom][newxbottom]>0){
                                // drawRect(newpointbottom[0],newpointbottom[1],1,1,"red")
                                // drawRect(newpointbottom[0],newpointbottom[1],0.2,0.2,"red")

                                bottomfind=true
                                if(this.catEnergyField[k].edgeBarrierMap[newybottom][newxbottom]!=4){
                                    if(lastBottom.length==0){
                                        bottomBoundPoints.push([newxbottom,newybottom])
                                        lastBottom=[newxbottom,newybottom]
                                    }
                                    else{
                                        if(Math.abs(lastBottom[0]-newxbottom)<=stopGap&&Math.abs(lastBottom[1]-newybottom)<=stopGap){

                                            lastBottom=[newxbottom,newybottom]
                                            bottomBoundPoints.push([newxbottom,newybottom])

                                        }
                                        else{
                                            // if(flag){
                                            //     drawRect(newpointbottom[0],newpointbottom[1],0.2,0.2,"red")
                                            //     drawRect(lastBottom[0]+this.catEnergyField[k].x,lastBottom[1]+this.catEnergyField[k].y,0.2,0.2,"blue")
                                            //     console.log()
                                            // }

                                            // drawRect(newpointtop[0],newpointtop[1],0.2,0.2,"blue")
                                            // console.log("1")
                                            bottomstop=true
                                        }
                                    }
                                }
                                else{
                                    bottomBoundPoints.push([newxbottom,newybottom])
                                    // lastBottom=[newxbottom,newybottom]
                                }

                            }
                            /*                            if(!bottomstop&&!rightstop){
                                                            bottomFindPoints.push([newpointbottom[0],newpointbottom[1],othercat])
                                                            if(bottomfind){
                                                                fillPoints=fillPoints.concat(bottomFindPoints)
                                                                bottomFindPoints=[]
                                                            }
                                                        }*/

                        }

                        if(topfind&&bottomfind||topstop&&bottomstop){
                            break
                        }

                        disalongline+=step

                    }

                    dl+=step
                }

                let fillPolyPoints=[[Math.floor((crosspoint.x-this.catEnergyField[k].x)/pixelGroup),Math.floor((crosspoint.y-this.catEnergyField[k].y)/pixelGroup)]]
                for(let p=0;p<topBoundPoints.length;p++){
                    fillPolyPoints.push(topBoundPoints[p])
                }

                for(let p=bottomBoundPoints.length-1;p>=0;p--){
                    fillPolyPoints.push(bottomBoundPoints[p])
                }

                fillArea[i].push(fillPolyPoints)

                topBoundPoints=[]
                bottomBoundPoints=[]
                lastTop=[]
                lastBottom=[]
                let leftstop=false
                topstop=false
                bottomstop=false
                dl=0
                //left
                while(dl<edgeR1){

                    if(leftstop){
                        break
                    }
                    let newanchor2=[crosspoint.x-dl*normdirvec[0],crosspoint.y-dl*normdirvec[1]]

                    let disalongline=0

                    let topfind=false
                    let bottomfind=false

                    let topFindPoints=[]
                    let bottomFindPoints=[]


                    while(disalongline<lineLength/2){
                        //top
                        if(!topfind&&!leftstop&&!topstop){
                            let newpointtop=[newanchor2[0]+linedirvec[0]*disalongline,newanchor2[1]+linedirvec[1]*disalongline]
                            let newxtop=Math.floor((newpointtop[0]-this.catEnergyField[k].x)/pixelGroup)
                            let newytop=Math.floor((newpointtop[1]-this.catEnergyField[k].y)/pixelGroup)

                            for(var k2 in this.catEdgeDict){
                                let othercat=k2
                                let otherx=Math.floor((newpointtop[0]-this.catEnergyField[othercat].x)/pixelGroup)
                                let othery=Math.floor((newpointtop[1]-this.catEnergyField[othercat].y)/pixelGroup)
                                // drawRect(newpointtop[0],newpointtop[1],1,1,"red")
                                if(otherx>0&&otherx<this.catEnergyField[othercat].width&&othery>0&&othery<this.catEnergyField[othercat].height){
                                    if(this.catEnergyField[othercat].pointBarrierMap[othery][otherx]==3){
                                        leftstop=true
                                        break
                                    }
                                }
                            }

                            if(newxtop>0&&newxtop<this.catEnergyField[k].width&&newytop>0&&newytop<this.catEnergyField[k].height&&this.catEnergyField[k].finalField[newytop][newxtop]>0){
                                // drawRect(newpointtop[0],newpointtop[1],0.2,0.2,"red")
                                topfind=true
                                if(this.catEnergyField[k].edgeBarrierMap[newytop][newxtop]!=4){
                                    if(lastTop.length==0){
                                        topBoundPoints.push([newxtop,newytop])
                                        lastTop=[newxtop,newytop]
                                    }
                                    else{
                                        if(Math.abs(lastTop[0]-newxtop)<=stopGap&&Math.abs(lastTop[1]-newytop)<=stopGap){

                                            lastTop=[newxtop,newytop]
                                            topBoundPoints.push([newxtop,newytop])
                                        }
                                        else{
                                            // if(flag){
                                            //     drawRect(newpointtop[0],newpointtop[1],0.2,0.2,"red")
                                            //     drawRect(lastTop[0]+this.catEnergyField[k].x,lastTop[1]+this.catEnergyField[k].y,0.2,0.2,"blue")
                                            //     console.log()
                                            // }

                                            // drawRect(newpointtop[0],newpointtop[1],0.2,0.2,"blue")
                                            // console.log("1")
                                            topstop=true
                                        }
                                    }
                                }
                                else{
                                    topBoundPoints.push([newxtop,newytop])
                                    // lastTop=[newxtop,newytop]
                                }
                            }

                            /*                            if(!topstop&&!leftstop){
                                                            topFindPoints.push([newpointtop[0],newpointtop[1],othercat])
                                                            if(topfind){
                                                                fillPoints=fillPoints.concat(topFindPoints)
                                                                topFindPoints=[]
                                                            }
                                                        }*/
                        }

                        //bottom
                        if(!bottomfind&&!leftstop&&!bottomstop){
                            let newpointbottom=[newanchor2[0]-linedirvec[0]*disalongline,newanchor2[1]-linedirvec[1]*disalongline]
                            let newxbottom=Math.floor((newpointbottom[0]-this.catEnergyField[k].x)/pixelGroup)
                            let newybottom=Math.floor((newpointbottom[1]-this.catEnergyField[k].y)/pixelGroup)

                            // drawRect(newpointbottom[0],newpointbottom[1],1,1,"red")
                            for (var k2 in this.catEdgeDict){
                                let othercat=k2
                                let otherx=Math.floor((newpointbottom[0]-this.catEnergyField[othercat].x)/pixelGroup)
                                let othery=Math.floor((newpointbottom[1]-this.catEnergyField[othercat].y)/pixelGroup)
                                // drawRect(newpointtop[0],newpointtop[1],1,1,"red")
                                if(otherx>0&&otherx<this.catEnergyField[othercat].width&&othery>0&&othery<this.catEnergyField[othercat].height){
                                    if(this.catEnergyField[othercat].pointBarrierMap[othery][otherx]==3){
                                        leftstop=true
                                        break
                                    }
                                }
                            }

                            if(newxbottom>0&&newxbottom<this.catEnergyField[k].width&&newybottom>0&&newybottom<this.catEnergyField[k].height&&this.catEnergyField[k].finalField[newybottom][newxbottom]>0){
                                // drawRect(newpointbottom[0],newpointbottom[1],1,1,"red")
                                // drawRect(newpointbottom[0],newpointbottom[1],0.2,0.2,"red")

                                bottomfind=true
                                if(this.catEnergyField[k].edgeBarrierMap[newybottom][newxbottom]!=4){
                                    if(lastBottom.length==0){
                                        bottomBoundPoints.push([newxbottom,newybottom])
                                        lastBottom=[newxbottom,newybottom]
                                    }
                                    else{
                                        if(Math.abs(lastBottom[0]-newxbottom)<=stopGap&&Math.abs(lastBottom[1]-newybottom)<=stopGap){

                                            lastBottom=[newxbottom,newybottom]
                                            bottomBoundPoints.push([newxbottom,newybottom])
                                        }
                                        else{
                                            // if(flag){
                                            //     drawRect(newpointbottom[0],newpointbottom[1],0.2,0.2,"red")
                                            //     drawRect(lastBottom[0]+this.catEnergyField[k].x,lastBottom[1]+this.catEnergyField[k].y,0.2,0.2,"blue")
                                            //     console.log()
                                            // }

                                            // drawRect(newpointtop[0],newpointtop[1],0.2,0.2,"blue")
                                            // console.log("1")
                                            bottomstop=true
                                        }
                                    }
                                }
                                else{
                                    bottomBoundPoints.push([newxbottom,newybottom])
                                    // lastBottom=[newxbottom,newybottom]
                                }
                            }
                            /*                            if(!bottomstop&&!leftstop){
                                                            bottomFindPoints.push([newpointbottom[0],newpointbottom[1],othercat])
                                                            if(bottomfind){
                                                                fillPoints=fillPoints.concat(bottomFindPoints)
                                                                bottomFindPoints=[]
                                                            }
                                                        }*/
                        }

                        if(topfind&&bottomfind||topstop&&bottomstop){
                            break
                        }

                        disalongline+=step

                    }

                    dl+=step
                }


                fillPolyPoints=[[Math.floor((crosspoint.x-this.catEnergyField[k].x)/pixelGroup),Math.floor((crosspoint.y-this.catEnergyField[k].y)/pixelGroup)]]
                for(let p=0;p<topBoundPoints.length;p++){
                    fillPolyPoints.push(topBoundPoints[p])
                }

                for(let p=bottomBoundPoints.length-1;p>=0;p--){
                    fillPolyPoints.push(bottomBoundPoints[p])
                }

                fillArea[i].push(fillPolyPoints)


                // drawRect(crosspoint.x,crosspoint.y,1,1,"red")
            }
            //var endTime1 = +new Date()
            //console.log("cat " + k + " loop1 " + (endTime1 - beginTime1) + " ms")
            // console.log(fillArea)

            /*            for(let i=0;i<fillPoints.length;i++){
                            let realx=fillPoints[i][0]
                            let realy=fillPoints[i][1]
                            let othercat=fillPoints[i][2]
                            let relativex=Math.floor(realx-this.catEnergyField[k].x)
                            let relativey=Math.floor(realy-this.catEnergyField[k].y)
                            let relativeotherx=Math.floor(realx-this.catEnergyField[othercat].x)
                            let relativeothery=Math.floor(realy-this.catEnergyField[othercat].y)
                            if(relativeotherx>0&&relativeotherx<this.catEnergyField[othercat].width&&relativeothery>0&&relativeothery<this.catEnergyField[othercat].height){
                                if(this.catEnergyField[othercat].finalField[relativeothery][relativeotherx]>0){
                                    // drawRect(realx,realy,0.2,0.2,"red")
                                    newFieldDict[k][relativey][relativex]=this.catEnergyField[k].field[relativey][relativex]
                                }
                            }
                        }*/

            //var beginTime2 = +new Date()

            //console.log("fill area: ")
            //console.log(fillArea)

            for (let i=0;i<fillArea.length;i++){
                //let thisid=crossingPoints[i][1]
                let otherid=crossingPoints[i][2]
                //let thiscat=this.edges[thisid].cat
                let othercat=this.edges[otherid].cat
                let dx=this.catEnergyField[k].x
                let dy=this.catEnergyField[k].y

                //let startx=Math.floor((this.edges[thisid].x-edgeR1-this.catEnergyField[k].x)/pixelGroup)
                //let endx=Math.ceil((this.edges[thisid].x+this.edges[thisid].width+edgeR1-this.catEnergyField[k].x)/pixelGroup)
                //let starty=Math.floor((this.edges[thisid].y-edgeR1-this.catEnergyField[k].y)/pixelGroup)
                //let endy=Math.ceil((this.edges[thisid].y+this.edges[thisid].height+edgeR1-this.catEnergyField[k].y)/pixelGroup)
//
                //startx = Math.max(0, startx)
                //endx = Math.min(this.catEnergyField[k].width, endx)
                //starty = Math.max(0, starty)
                //endy = Math.min(this.catEnergyField[k].height, endy)

                for(let a = 0; a < fillArea[i].length; a ++){
                    //if(a==0){
                    for(let b = 0; b < fillArea[i][a].length; b ++){
                        fillArea[i][a][b][0] = fillArea[i][a][b][0] * pixelGroup + dx
                        fillArea[i][a][b][1] = fillArea[i][a][b][1] * pixelGroup + dy
                    }
                    //    d3.select('g').append("path")
                    //        .attr('d',lineFunction(fillArea[i][a]))
                    //        .attr("fill", 'none')
                    //        .style('stroke', "black")
                    //        .style("stroke-width", 1)
                    //        .on('mouseover', function () {
                    //            d3.select(this)
                    //                .style('stroke', "red")
                    //                .style("stroke-width", 2);
                    //        })
                    //        .on('mouseout', function () {
                    //            d3.select(this)
                    //                .style('stroke', "black")
                    //                .style("stroke-width", 1);
                    //        });

                    //}

                    this.fillPolygonForEdge(fillArea[i][a], k, newFieldDict, othercat)
                }


                /*
                for(let y=starty;y<endy;y++){
                    for (let x=startx;x<endx;x++){
                        let realx=x*pixelGroup+this.catEnergyField[k].x
                        let realy=y*pixelGroup+this.catEnergyField[k].y

                        let relativeotherx=Math.floor((realx-this.catEnergyField[othercat].x)/pixelGroup)
                        let relativeothery=Math.floor((realy-this.catEnergyField[othercat].y)/pixelGroup)

                        if(relativeotherx>0&&relativeotherx<this.catEnergyField[othercat].width&&relativeothery>0&&relativeothery<this.catEnergyField[othercat].height){
                            // if(this.catEnergyField[k].finalField[y][x]==0&&this.catEnergyField[k].edgeBarrierMap[y][x]>0&&this.catEnergyField[othercat].finalField[relativeothery][relativeotherx]>0){
                            if(this.catEnergyField[k].finalField[y][x]==0&&this.catEnergyField[k].edgeBarrierMap[y][x]>0){
                                for(let a=0;a<fillArea[i].length;a++){
                                    //let fillPolygon=fillArea[i][a].map((val)=>{return {x:val[0],y:val[1]}})
                                    //for(let b=0;b < fillPolygon.length; b ++){
                                    //    d3.select('g').append('circle')
                                    //        .attr('cx', fillPolygon[i].x)
                                    //        .attr('cy', fillPolygon[i].y)
                                    //        .attr('r',1)
                                    //        .attr('fill','red')
                                    //}
                                    let intersect=IsoInsideTest([x, y],fillArea[i][a])
                                    //let intersect=IntersectionQuery.pointInPolygon({x:x,y:y},fillPolygon)
                                    if(intersect){
                                        newFieldDict[k][y][x]=this.catEnergyField[k].field[y][x]

                                    }
                                }
                            }
                        }


                    }
                }
                */


                //for(let a=0;a<fillArea[i].length;a++){
//
                //    // if(k=="0"){
                //    // drawPolygon(fillArea[i][a],dx,dy,"red")
                //    // }
                //}




            }
            //var endTime2 = +new Date()
            //console.log("cat " + k + " loop2 " + (endTime2 - beginTime2) + " ms")
            //var endTime = +new Date()
            //console.log("cat " + k + " fill one edge mean: " + (endTime - beginTime) / crossingPoints.length + "ms")
        }



        for(var k in this.catEnergyField){
            this.catEnergyField[k].finalField=newFieldDict[k]
        }
    }

    smoothEnergyField(bounding){
        let kernelsize = 3
        let kernel = this.getGaussianKernel(1.5, kernelsize)
        let anchor = parseInt(kernelsize/2)
        // console.log(kernel)
        for (var k in this.catEnergyField){

            let sx = bounding[k].minX;
            let ex = bounding[k].maxX;
            let sy = bounding[k].minY;
            let ey = bounding[k].maxY;

            let cur_width = ex - sx + 1;
            let cur_height = ey - sy + 1;

            let newField=[]
            for (let y = 0;y < cur_height + 10;y ++){
                newField.push(new Array(cur_width + 10).fill(0))
            }

            for (let y = sy; y <= ey; y ++){
                for (let x = sx; x <= ex; x ++){

                    let newvalue = 0
                    for (let i = 0;i < kernelsize;i ++){
                        for (let j = 0;j < kernelsize;j ++){
                            let dy = i - anchor
                            let dx = j - anchor
                            let ny = y + dy
                            let nx = x + dx
                            if(ny > 0 && ny < this.catEnergyField[k].height && nx > 0 && nx < this.catEnergyField[k].width){
                                newvalue += kernel[i][j] * this.catEnergyField[k].finalField[ny][nx]
                            }
                        }
                    }
                    if(newvalue > 0){
                        newField[y - sy][x - sx] = newvalue
                    }

                }
            }

            for(let y = sy; y <= ey; y ++){
                for(let x = sx; x <= ex; x ++){
                    //console.log("(" + y + ", " + x + ")")
                    //console.log(this.catEnergyField[k].finalField)
                    this.catEnergyField[k].finalField[y][x] = newField[y - sy][x - sx]
                }
            }

            //this.catEnergyField[k].finalField=newField
        }
    }

    saveOutline(isoLineDict){
        let res=[]
        for (var k in isoLineDict){
            for (let i=0;i<isoLineDict[k].length;i++){
                let formatpoints=[]
                for(let p=0;p<isoLineDict[k][i].length;p++){
                    formatpoints.push({x:isoLineDict[k][i][p][0],y:isoLineDict[k][i][p][1]})
                }
                res.push({
                    cat:k,
                    id:i,
                    isInterior:false,
                    parentID:-1,
                    points:formatpoints
                })
            }
        }
    }

    removeOverlaps(){

        this.updateEnergyPoints()

        //for(var k in this.catEnergyField){
        //    this.drawEnergyField(k);
        //}


        //this.smoothEnergyField()

        d3.select("svg")
            .selectAll("path")
            .remove()


        recal = false
        recalNum = 0
        this.firstFlag = true
        this.findOutLine()
        this.calOutLine()

        this.calEdgeControlPoints()

        /*
        intervals=[0.01]
        let isoDict=this.calISOLine(intervals)

        //for (var k in isoDict){
        //    this.drawEnergyField(k)
        //}

        let polygontest = {};

        control_points = {};

        let tmp_polygon = {}

        for (var k in isoDict){
            let dx=this.catEnergyField[k].x
            let dy=this.catEnergyField[k].y
            for(let i = 0; i < isoDict[k].length; i ++ ){
                let polygon = [];
                if(!tmp_polygon.hasOwnProperty(k)){
                    tmp_polygon[k] = []
                }
                for(let j = 0; j < isoDict[k][i].length; j += 10){
                    polygon.push([isoDict[k][i][j][0]*pixelGroup + dx,isoDict[k][i][j][1]*pixelGroup + dy])
                }
                tmp_polygon[k].push(polygon)
                let flag = false;
                for(let p = 0;p < this.catPointDict[k].length; p ++){
                    flag = IsoInsideTest([ this.catPointDict[k][p].x, this.catPointDict[k][p].y ], polygon);
                    if(flag) break;
                }
                if(flag){
                    tmp_polygon[k].selectidx = tmp_polygon[k].length - 1;
                    polygontest[k] = [];
                    for(let j = 0; j < isoDict[k][i].length; j += 10){
                        polygontest[k].push([isoDict[k][i][j][0],isoDict[k][i][j][1]]);
                    }
                    is_selected[k] = false
                    control_points[k] = []
                    control_points[k][0] = []
                    control_points[k][0] = polygon;
                    let meandis = 0;
                    let sz = control_points[k][0].length;
                    for(let j = 0; j < sz; j ++){
                        meandis += calDistance(control_points[k][0][j][0], control_points[k][0][j][1],
                            control_points[k][0][(j + 1) % sz][0],control_points[k][0][(j + 1) % sz][1])
                    }
                    meandis /= sz
                    control_points[k][0].meandis = meandis;
                    //this.drawISOLinesV2(k,this)
                }
            }
            //this.drawEnergyField(k);
        }

        //console.log(tmp_polygon)
        for(var k in isoDict){
            let sidx = tmp_polygon[k].selectidx;
            for(let i = 0; i < tmp_polygon[k].length; i ++){
                if(i == sidx){
                    continue;
                }
                let flag = true;
                for(let j = 0; j < tmp_polygon[k][i].length; j ++){
                    flag = IsoInsideTest([ tmp_polygon[k][i][j][0], tmp_polygon[k][i][j][1] ], tmp_polygon[k][sidx]);
                    if(flag == false){
                        break;
                    }
                }
                if(flag){
                    if(tmp_polygon[k][i].length < 30){
                        continue;
                    }
                    let curlen = control_points[k].length;
                    control_points[k][curlen] = [];
                    for(let j = 0; j < tmp_polygon[k][i].length; j += 10){
                        control_points[k][curlen].push( [tmp_polygon[k][i][j][0], tmp_polygon[k][i][j][1]] )
                    }
                    let meandis = 0;
                    let sz = control_points[k][curlen].length;
                    for(let j = 0; j < sz; j ++){
                        meandis += calDistance(control_points[k][curlen][j][0], control_points[k][curlen][j][1],
                            control_points[k][curlen][(j + 1) % sz][0],control_points[k][curlen][(j + 1) % sz][1])
                    }
                    meandis /= sz
                    control_points[k][curlen].meandis = meandis;
                }
            }
        }

        //console.log("hhhh")
        //console.log(isoDict)
        /*
        for (var k in isoDict){

            let dx=this.catEnergyField[k].x
            let dy=this.catEnergyField[k].y
            for(let i = 0; i < isoDict[k].length; i ++ ){
                let polygon = [];
                for(let j = 0; j < isoDict[k][i].length; j += 10){
                    polygon.push([isoDict[k][i][j][0]*pixelGroup + dx,isoDict[k][i][j][1]*pixelGroup + dy])
                }
                let flag = false;
                for(let p = 0;p < this.catPointDict[k].length; p ++){
                    flag = IsoInsideTest([ this.catPointDict[k][p].x, this.catPointDict[k][p].y ], polygon);
                    if(flag) break;
                }
                if(flag){
                    //console.log(isoDict[k][i])
                    if(!polygontest.hasOwnProperty(k)){
                        polygontest[k] = [];
                    }
                    let tmppolygon = []
                    for(let j = 0; j < isoDict[k][i].length; j += 10){
                        tmppolygon.push([isoDict[k][i][j][0],isoDict[k][i][j][1]]);
                    }
                    polygontest[k].push(tmppolygon)
                    is_selected[k] = false
                    control_points[k] = []
                    control_points[k][0] = []
                    control_points[k][0] = polygon;
                    let meandis = 0;
                    let sz = control_points[k][0].length;
                    for(let j = 0; j < sz; j ++){
                        meandis += calDistance(control_points[k][0][j][0], control_points[k][0][j][1],
                            control_points[k][0][(j + 1) % sz][0],control_points[k][0][(j + 1) % sz][1])
                    }
                    meandis /= sz
                    control_points[k][0].meandis = meandis;
                    //this.drawISOLinesV2(k,this)
                }
            }
            //this.drawEnergyField(k);
        }


        // re-cal the energy field for inner outline
        for (var k in this.catEnergyField){
            this.catEnergyField[k].tfinalField = []
            for(let y=0;y<this.catEnergyField[k].height;y++){
                this.catEnergyField[k].tfinalField.push(new Array(this.catEnergyField[k].width).fill(0));
                for(let x=0;x<this.catEnergyField[k].width;x++){
                    let val = this.catEnergyField[k].finalField[y][x];
                    let flag = false;
                    for(let idx = 0; idx < polygontest[k].length; idx ++){
                        flag = IsoInsideTest([x, y], polygontest[k][idx])
                        if(flag){
                            break;
                        }
                    }
                    if(flag){
                        //console.log("test!!")
                        if(val > 0){
                            this.catEnergyField[k].tfinalField[y][x] = 0;
                        }
                        else{
                            this.catEnergyField[k].tfinalField[y][x] = 10;
                        }
                    }
                    else{
                        this.catEnergyField[k].finalField[y][x] = 0;
                    }
                }
            }
        }


        let isoLineDict={}
        for (var k in this.catEnergyField){
            var isoLines = [];
            isoLines=MarchingSquaresJS
                .isoLines(this.catEnergyField[k].tfinalField,
                    intervals,
                    {
                        polygons: false,
                        linearRing: false,
                        noFrame:true
                    }
                )
            isoLineDict[k]=isoLines[0]
        }

        for (var k in isoLineDict){
            //console.log(isoLineDict[k])
            let dx=this.catEnergyField[k].x
            let dy=this.catEnergyField[k].y
            for(let i = 0; i < isoLineDict[k].length; i ++ ){
                if(isoLineDict[k][i].length < 30){
                    continue;
                }
                let curlen = control_points[k].length;
                control_points[k][curlen] = [];
                for(let j = 0; j < isoLineDict[k][i].length; j += 10){
                    control_points[k][curlen].push([isoLineDict[k][i][j][0]*pixelGroup + dx,isoLineDict[k][i][j][1]*pixelGroup + dy])
                }
                let meandis = 0;
                let sz = control_points[k][curlen].length;
                for(let j = 0; j < sz; j ++){
                    meandis += calDistance(control_points[k][curlen][j][0], control_points[k][curlen][j][1],
                        control_points[k][curlen][(j + 1) % sz][0],control_points[k][curlen][(j + 1) % sz][1])
                }
                meandis /= sz
                control_points[k][curlen].meandis = meandis;
            }
            //this.drawEnergyField(k);
        }

        */

        /*
        for(var k in this.catEnergyField){
            let curdata=""
            for(let i = 0; i < control_points[k].length; i ++){
                curdata += lineFunction(control_points[k][i])
            }
            //this.drawEnergyField(k);
            this.drawISOLinesV2(k, this, curdata);
        }
        */

        //d3.select("svg").selectAll(".energyfieldrect")
        //    .remove()

        for(var k in this.catEnergyField){
            // this.drawEnergyField(k);
            this.updatedEnergyPoints[k]=[]
        }


    }

    onChangeEdgeWidth = value => {
        edgeWidth = value
        this.setState({
            edgeWidth:value
        })
        this.changeEdgeWidth(this.selectedEdge,value)
    };


    onChangeNodeR0 = value => {
        nodeR0 = value
        this.setState({
            nodeR0: value,
        });
    };

    onChangeNodeR1 = value => {
        nodeR1 = value
        nodeR0=nodeR1-5
        this.setState({
            nodeR1: value,
            nodeR0:nodeR1-5
        });
    };

    onChangeEdgeR0 = value => {
        edgeR0 = value
        this.setState({
            edgeR0: value,
        });
    };

    onChangeEdgeR1 = value => {
        edgeR1 = value
        edgeR0=edgeR1-5
        this.setState({
            edgeR1: value,
            edgeR0:edgeR0
        });
    };

    onChangePixelGroup = value => {
        pixelGroup = value
        this.setState({
            pixelGroup: value,
        });
    };

    onChangeGap = value => {
        gapBetween = value
        this.setState({
            gapBetween: value,
        });
    };

    render(){
        return(

            <div id={"Sliders"}>
                <br/>
{/*            <Row>
                <Col span={12}>
                    <h4>nodeR0</h4>
                    <Slider
                        min={1}
                        max={50}
                        onChange={this.onChangeNodeR0}
                        value={typeof nodeR0 === 'number' ? nodeR0 : 10}
                    />
                </Col>
                <Col span={4}>
                    <InputNumber
                        min={1}
                        max={50}
                        style={{ margin: '0 16px' }}
                        value={nodeR0}
                        onChange={this.onChangeNodeR0}
                    />
                </Col>
            </Row>*/}

            <Row>
                <Col span={12}>
                    <h4>Node Radius</h4>
                    <Slider
                        min={1}
                        max={50}
                        onChange={this.onChangeNodeR1}
                        value={typeof nodeR1 === 'number' ? nodeR1 : 20}
                    />
                </Col>
                <Col span={4}>
                    <InputNumber
                        min={1}
                        max={50}
                        style={{ margin: '0 16px' }}
                        value={nodeR1}
                        onChange={this.onChangeNodeR1}
                    />
                </Col>
            </Row>

{/*            <Row>
                <Col span={12}>
                    <h4>edgeR0</h4>
                    <Slider
                        min={10}
                        max={100}
                        onChange={this.onChangeEdgeR0}
                        value={typeof edgeR0 === 'number' ? edgeR0 : 15}
                    />
                </Col>
                <Col span={4}>
                    <InputNumber
                        min={10}
                        max={100}
                        style={{ margin: '0 16px' }}
                        value={edgeR0}
                        onChange={this.onChangeEdgeR0}
                    />
                </Col>
            </Row>*/}

            <Row>
                <Col span={12}>
                    <h4>Global Edge Width</h4>
                    <Slider
                        min={10}
                        max={100}
                        onChange={this.onChangeEdgeR1}
                        value={typeof edgeR1 === 'number' ? edgeR1 : 20}
                    />
                </Col>
                <Col span={4}>
                    <InputNumber
                        min={10}
                        max={100}
                        style={{ margin: '0 16px' }}
                        value={edgeR1}
                        onChange={this.onChangeEdgeR1}
                    />
                </Col>
            </Row>

                <Row>
                    <Col span={12}>
                        <h4>Pixel Group</h4>
                        <Slider
                            min={1}
                            max={10}
                            onChange={this.onChangePixelGroup}
                            value={typeof pixelGroup === 'number' ? pixelGroup : 2}
                        />
                    </Col>
                    <Col span={4}>
                        <InputNumber
                            min={1}
                            max={10}
                            style={{ margin: '0 16px' }}
                            value={pixelGroup}
                            onChange={this.onChangePixelGroup}
                        />
                    </Col>
                </Row>

                <Row>
                    <Col span={12}>
                        <h4>Gap Between Different Groups</h4>
                        <Slider
                            min={0}
                            max={5}
                            onChange={this.onChangeGap}
                            value={typeof gapBetween === 'number' ? gapBetween : 1}
                        />
                    </Col>
                    <Col span={4}>
                        <InputNumber
                            min={0}
                            max={5}
                            style={{ margin: '0 16px' }}
                            value={gapBetween}
                            onChange={this.onChangeGap}
                        />
                    </Col>
                </Row>

                <Row>
                    <Col span={12}>
                        <h4>Edge Width</h4>
                        <Slider
                            min={1}
                            max={10}
                            onChange={this.onChangeEdgeWidth}
                            value={this.state.edgeWidth}
                        disabled={this.state.hasSelectEdge?false:true}/>
                    </Col>
                    <Col span={4}>
                        <InputNumber
                            min={1}
                            max={10}
                            style={{ margin: '0 16px' }}
                            value={this.state.edgeWidth}
                            onChange={this.onChangeEdgeWidth}
                            disabled={this.state.hasSelectEdge?false:true}/>
                    </Col>
                </Row>

                <br/>
                <Button onClick = {this.getData.bind(this)} disabled={this.props.hasLoadData?false:true}>
                    Draw Bubbles
                </Button>

                <Button onClick = {this.removeOverlaps.bind(this)} disabled={this.props.hasLoadData?false:true}>
                    Remove Overlaps
                </Button>

        </div>)

    }
}

export default AdaptiveIsovalue